/* NOPAL LIFE SKIN INTELLIGENCE™ — Bundle Shopify
 * Généré le 2026-06-24T13:46:35.540Z
 * TECHNOLOGIE PROTÉGÉE PAR BREVET
 */
(function() {
'use strict';


// ──────────── js/questions.js ────────────
/**
 * NOPAL LIFE — Questionnaire Adaptatif
 * 11 questions, logique adaptative, poids dans le scoring
 */

const QUESTIONS = [
  {
    id: 'q1_skin_type',
    order: 1,
    required: true,
    question: 'Comment décrirez-vous votre peau au naturel ?',
    subtext: 'Choisissez le profil qui correspond le mieux à votre peau',
    type: 'single',
    icon: '✦',
    options: [
      {
        value: 'peau_mature',
        label: 'Peau mature',
        description: 'Signes du temps visibles : rides, perte de fermeté, besoin de raviver l\'apparence',
        icon: '⏳',
        weights: { rides: 82, relachement: 78, peau_mature: 98, secheresse: 65 }
      },
      {
        value: 'peau_seche',
        label: 'Peau sèche',
        description: 'Tiraillements, inconfort, manque de souplesse et de nutrition',
        icon: '🌵',
        weights: { secheresse: 95, sensibilite: 55, peau_mature: 45 }
      },
      {
        value: 'peau_grasse',
        label: 'Peau grasse',
        description: 'Brillance prononcée, pores dilatés, tendance aux imperfections',
        icon: '💧',
        weights: { pores: 90, secheresse: 15, eclat: 45, sensibilite: 30 }
      },
      {
        value: 'peau_sensible',
        label: 'Peau sensible',
        description: 'Rougeurs, picotements, réactions fréquentes, barrière fragilisée',
        icon: '🌸',
        weights: { sensibilite: 98, secheresse: 60, peau_mature: 42 }
      },
      {
        value: 'eclat',
        label: 'Éclat',
        description: 'Teint terne et irrégulier, manque de luminosité et d\'uniformité',
        icon: '✨',
        weights: { eclat: 95, taches: 72, sensibilite: 18, pores: 45 }
      },
      {
        value: 'peau_deshydratee',
        label: 'Peau déshydratée',
        description: 'Manque d\'eau, tiraillements, peau qui "tire" même si elle est mixte ou grasse',
        icon: '💦',
        weights: { secheresse: 92, eclat: 48, sensibilite: 38, pores: 30 }
      }
    ],
    scoringKey: 'skinType'
  },

  {
    id: 'q2_age_range',
    order: 2,
    required: true,
    question: 'Dans quelle tranche d\'âge vous situez-vous ?',
    subtext: null,
    type: 'single',
    icon: '◈',
    options: [
      {
        value: '30_34',
        label: '30 – 34 ans',
        description: 'Prévention précoce, éclat et premiers soins ciblés',
        weights: { rides: 18, relachement: 15, peau_mature: 30, eclat: 20 }
      },
      {
        value: '35_40',
        label: '35 – 40 ans',
        description: 'Premières traces du temps, prévention active',
        weights: { rides: 35, relachement: 30, peau_mature: 55 }
      },
      {
        value: '41_48',
        label: '41 – 48 ans',
        description: 'Changements visibles, intensification soins anti-âge',
        weights: { rides: 60, relachement: 58, peau_mature: 72 }
      },
      {
        value: '49_55',
        label: '49 – 55 ans',
        description: 'Période périménopause, peau en transformation',
        weights: { rides: 78, relachement: 80, peau_mature: 88, secheresse: 75 }
      },
      {
        value: '56_65',
        label: '56 – 65 ans',
        description: 'Soins intensifs nourrissants et réconfortants',
        weights: { rides: 92, relachement: 90, peau_mature: 96, secheresse: 85 }
      }
    ],
    scoringKey: 'ageRange'
  },

  {
    id: 'q3_main_concerns',
    order: 3,
    required: true,
    question: 'Quelles sont vos 3 préoccupations cutanées principales ?',
    subtext: 'Sélectionnez jusqu\'à 3 réponses',
    type: 'multi',
    maxSelect: 3,
    icon: '◉',
    options: [
      {
        value: 'rides',
        label: 'Rides & ridules',
        icon: '〰️',
        weights: { rides: 90, relachement: 60, peau_mature: 80 }
      },
      {
        value: 'relachement',
        label: 'Perte de fermeté',
        icon: '↕️',
        weights: { relachement: 92, rides: 65, peau_mature: 85 }
      },
      {
        value: 'secheresse',
        label: 'Sécheresse / déshydratation',
        icon: '🌡️',
        weights: { secheresse: 92, sensibilite: 60 }
      },
      {
        value: 'eclat',
        label: 'Manque d\'éclat, teint terne',
        icon: '✨',
        weights: { eclat: 90, taches: 55 }
      },
      {
        value: 'taches',
        label: 'Taches & irrégularités du teint',
        icon: '🎯',
        weights: { taches: 92, eclat: 70 }
      },
      {
        value: 'pores',
        label: 'Pores dilatés',
        icon: '🔬',
        weights: { pores: 90 }
      },
      {
        value: 'contour_yeux',
        label: 'Cernes & poches',
        icon: '👁️',
        weights: { contour_yeux: 92, rides: 55 }
      },
      {
        value: 'sensibilite',
        label: 'Rougeurs & irritations',
        icon: '🌹',
        weights: { sensibilite: 92 }
      }
    ],
    scoringKey: 'mainConcerns'
  },

  {
    id: 'q4_hydration_feeling',
    order: 4,
    required: true,
    question: 'Comment se sent votre peau en fin de journée ?',
    subtext: null,
    type: 'scale',
    icon: '◈',
    min: 1,
    max: 5,
    labels: {
      1: 'Très inconfortable,\ntiraillements importants',
      3: 'Acceptable,\nlégèrement inconfortable',
      5: 'Confortable\net hydratée'
    },
    scoringKey: 'hydrationFeeling',
    weights: {
      1: { secheresse: 95, sensibilite: 70 },
      2: { secheresse: 80, sensibilite: 55 },
      3: { secheresse: 55, sensibilite: 40 },
      4: { secheresse: 35, sensibilite: 25 },
      5: { secheresse: 20, sensibilite: 15 }
    }
  },

  {
    id: 'q5_hormonal_stage',
    order: 5,
    required: true,
    question: 'Où en êtes-vous dans votre parcours hormonal ?',
    subtext: 'Cette donnée est essentielle pour adapter votre routine',
    type: 'single',
    icon: '◈',
    options: [
      {
        value: 'cycles_reguliers',
        label: 'Cycles menstruels réguliers',
        description: null,
        weights: { rides: 35, secheresse: 40, peau_mature: 50 }
      },
      {
        value: 'cycles_irreguliers',
        label: 'Cycles irréguliers (préménopause)',
        description: 'Fluctuations, cycles qui s\'espacent',
        weights: { rides: 65, secheresse: 70, relachement: 60, peau_mature: 75 }
      },
      {
        value: 'perimenopause',
        label: 'Périménopause',
        description: 'Transition ménopausique en cours',
        weights: { rides: 80, secheresse: 85, relachement: 80, peau_mature: 88 }
      },
      {
        value: 'menopause',
        label: 'Ménopause (plus de cycles)',
        description: null,
        weights: { rides: 90, secheresse: 92, relachement: 90, peau_mature: 95 }
      },
      {
        value: 'ne_sait_pas',
        label: 'Je ne sais pas / Préfère ne pas répondre',
        description: null,
        weights: { peau_mature: 60 }
      }
    ],
    scoringKey: 'hormonalStage'
  },

  {
    id: 'q6_current_routine',
    order: 6,
    required: false,
    question: 'Quelle est votre routine actuelle ?',
    subtext: 'Sélectionnez tout ce que vous utilisez régulièrement',
    type: 'multi',
    maxSelect: 6,
    icon: '◉',
    options: [
      { value: 'nettoyant', label: 'Nettoyant visage', weights: {} },
      { value: 'tonique', label: 'Tonique / eau micellaire', weights: {} },
      { value: 'serum', label: 'Sérum', weights: { eclat: 10, rides: 10 } },
      { value: 'creme_jour', label: 'Crème de jour', weights: { secheresse: -15 } },
      { value: 'creme_nuit', label: 'Crème de nuit', weights: { relachement: -10 } },
      { value: 'contour_yeux', label: 'Soin contour des yeux', weights: { contour_yeux: -15 } },
      { value: 'spf', label: 'Protection solaire', weights: { taches: -20 } },
      { value: 'aucun', label: 'Routine minimale / aucun soin spécifique', weights: {} }
    ],
    scoringKey: 'currentRoutine'
  },

  {
    id: 'q7_sun_exposure',
    order: 7,
    required: true,
    question: 'Quelle est votre exposition solaire habituelle ?',
    subtext: null,
    type: 'single',
    icon: '☀️',
    options: [
      {
        value: 'faible',
        label: 'Faible',
        description: 'Travail en intérieur, peu de sorties',
        weights: { taches: 30 }
      },
      {
        value: 'moderee',
        label: 'Modérée',
        description: 'Quelques heures dehors par jour',
        weights: { taches: 55, peau_mature: 10 }
      },
      {
        value: 'importante',
        label: 'Importante',
        description: 'Travail ou activité en extérieur, vacances au soleil',
        weights: { taches: 85, rides: 25, relachement: 20, peau_mature: 25 }
      }
    ],
    scoringKey: 'sunExposure'
  },

  {
    id: 'q8_stress_sleep',
    order: 8,
    required: true,
    question: 'Comment évaluez-vous votre niveau de stress et votre sommeil ?',
    subtext: '1 = très mauvais, 5 = excellent',
    type: 'scale',
    icon: '◈',
    min: 1,
    max: 5,
    labels: {
      1: 'Stress élevé,\nsommeil perturbé',
      3: 'Stress moyen,\nsommeil acceptable',
      5: 'Zen & repos\noptimal'
    },
    scoringKey: 'stressSleep',
    weights: {
      1: { sensibilite: 25, eclat: 25, contour_yeux: 30, rides: 15 },
      2: { sensibilite: 18, eclat: 18, contour_yeux: 22 },
      3: { sensibilite: 10, eclat: 10, contour_yeux: 12 },
      4: {},
      5: {}
    }
  },

  {
    id: 'q9_known_sensitivities',
    order: 9,
    required: false,
    question: 'Avez-vous des sensibilités ou conditions cutanées connues ?',
    subtext: 'Sélectionnez tout ce qui s\'applique',
    type: 'multi',
    maxSelect: 5,
    icon: '⚕️',
    options: [
      { value: 'rosacee', label: 'Rosacée / Couperose', weights: { sensibilite: 30 } },
      { value: 'eczema', label: 'Eczéma / Dermatite', weights: { sensibilite: 35 } },
      { value: 'psoriasis', label: 'Psoriasis', weights: { sensibilite: 30 } },
      { value: 'allergies_cosmetiques', label: 'Allergies cosmétiques connues', weights: { sensibilite: 25 } },
      { value: 'acne_hormonale', label: 'Acné hormonale résiduelle', weights: { pores: 20, taches: 15 } },
      { value: 'melasma', label: 'Mélasma / Masque de grossesse', weights: { taches: 40 } },
      { value: 'aucune', label: 'Aucune condition particulière', weights: {} }
    ],
    scoringKey: 'knownSensitivities'
  },

  {
    id: 'q10_environment',
    order: 10,
    required: false,
    question: 'Dans quel environnement vivez-vous principalement ?',
    subtext: null,
    type: 'single',
    icon: '🌍',
    options: [
      {
        value: 'urbain_pollue',
        label: 'Urbain — grande ville',
        description: 'Pollution, stress environnemental',
        weights: { rides: 12, taches: 12, eclat: 15, sensibilite: 10 }
      },
      {
        value: 'urbain_modere',
        label: 'Urbain — ville moyenne',
        description: null,
        weights: { rides: 6, taches: 8, eclat: 8 }
      },
      {
        value: 'rural',
        label: 'Rural / Campagne',
        description: 'Air pur, moins de pollution',
        weights: {}
      },
      {
        value: 'climatise',
        label: 'Environnement climatisé',
        description: 'Bureau ou domicile souvent climatisé',
        weights: { secheresse: 20, sensibilite: 12 }
      }
    ],
    scoringKey: 'environment'
  },

  {
    id: 'q11_priorities',
    order: 11,
    required: true,
    question: 'Quel est votre objectif N°1 pour votre peau ?',
    subtext: 'Votre priorité absolue',
    type: 'single',
    icon: '⊕',
    options: [
      {
        value: 'rides',
        label: 'Atténuer les rides',
        icon: '〰️',
        weights: { rides: 100 }
      },
      {
        value: 'relachement',
        label: 'Retrouver fermeté & contour',
        icon: '↕️',
        weights: { relachement: 100 }
      },
      {
        value: 'secheresse',
        label: 'Hydrater intensément',
        icon: '💦',
        weights: { secheresse: 100 }
      },
      {
        value: 'eclat',
        label: 'Retrouver de l\'éclat',
        icon: '✨',
        weights: { eclat: 100 }
      },
      {
        value: 'taches',
        label: 'Atténuer taches & teint irrégulier',
        icon: '🎯',
        weights: { taches: 100 }
      },
      {
        value: 'sensibilite',
        label: 'Calmer & apaiser',
        icon: '🌸',
        weights: { sensibilite: 100 }
      }
    ],
    scoringKey: 'topPriority'
  }
];

/**
 * Détermine si une question doit être affichée selon les réponses précédentes
 * @param {Object} question
 * @param {Object} answers - Réponses déjà collectées
 * @returns {boolean}
 */
function shouldShowQuestion(question, answers) {
  // La q9 (sensibilités connues) est masquée si peau sensible déjà déclarée + rosacée/eczéma
  // La q5 (hormonal) s'affiche toujours pour les 35-60 ans
  return true; // Toutes les questions sont affichées en V1
}

/**
 * Retourne les questions dans l'ordre, filtrées selon les réponses
 */
function getActiveQuestions(answers = {}) {
  return QUESTIONS
    .filter(q => shouldShowQuestion(q, answers))
    .sort((a, b) => a.order - b.order);
}



// ──────────── js/scoring.js ────────────
/**
 * NOPAL LIFE — Moteur de Scoring Cutané
 * Combine analyse visuelle (40%) + questionnaire (60%)
 * Produit un profil sur 9 dimensions + scores compatibilité produits
 */


// ─── DIMENSIONS DU PROFIL ──────────────────────────────────────────────────
const DIMENSIONS = ['rides', 'relachement', 'secheresse', 'eclat', 'taches', 'sensibilite', 'contour_yeux', 'pores', 'peau_mature'];

const DIMENSION_LABELS = {
  rides: 'Rides & ridules',
  relachement: 'Fermeté',
  secheresse: 'Hydratation',
  eclat: 'Éclat',
  taches: 'Uniformité',
  sensibilite: 'Sérénité',
  contour_yeux: 'Contour des yeux',
  pores: 'Pores & texture',
  peau_mature: 'Âge cutané'
};

const DIMENSION_DESCRIPTIONS = {
  rides: 'Profondeur et densité des rides visibles',
  relachement: 'Tonicité et redéfinition du contour facial',
  secheresse: 'Niveau d\'hydratation et confort cutané',
  eclat: 'Luminosité et vivacité du teint',
  taches: 'Uniformité et régularité du teint',
  sensibilite: 'Réactivité et confort de la peau',
  contour_yeux: 'Fraîcheur et jeunesse du regard',
  peau_mature: 'Indice global de maturité cutanée'
};

// ─── SCORING VISUEL ────────────────────────────────────────────────────────
/**
 * Convertit les données face-api.js en scores cutanés
 * @param {Object} faceData - Données brutes face-api.js
 * @returns {Object} Scores visuels 0-100 (100 = problème important)
 */
function computeVisualScores(faceData) {
  if (!faceData || faceData.simulated) {
    return computeSimulatedVisualScores(faceData);
  }

  const { age, expressions, landmarks, brightness, texture } = faceData;
  const scores = {};

  // ── Signaux par zones (Palier 1) — additif, avec fallback global ──────────
  // Chaque champ vaut null si la zone n'était pas exploitable → on retombe
  // alors sur la mesure GLOBALE (texture/age) historique. Aucun throw.
  const z = (faceData.zones && faceData.zones.available) ? faceData.zones : null;
  const has = (v) => v !== null && v !== undefined;

  // Âge estimé → rides
  const ageNorm = Math.max(0, Math.min(100, ((age - 35) / 30) * 100));

  // Rides ← densité de contours front + pattes d'oie (sinon age + wrinkleScore global)
  scores.rides = (z && has(z.rides))
    ? Math.round(z.rides * 0.7 + ageNorm * 0.3)
    : Math.round(ageNorm * 0.7 + (texture?.wrinkleScore || 50) * 0.3);

  // Fermeté (inférée via positions landmarks) — inchangé
  const jawDrop = landmarks?.jawDrop || 50;
  scores.relachement = Math.round(Math.max(0, Math.min(100, jawDrop)));

  // Hydratation (luminosité inverse) — inchangé
  const lum = brightness || 128;
  scores.secheresse = Math.round(Math.max(0, 100 - ((lum / 255) * 80)));

  // Éclat (luminosité directe) — inchangé
  scores.eclat = Math.round(Math.max(0, 100 - scores.secheresse));

  // Taches ← uniformité localisée joues+front (sinon unevenness global)
  scores.taches = (z && has(z.uniformite))
    ? Math.round(z.uniformite)
    : Math.round(texture?.unevenness || 45);

  // Sensibilité ← rougeur des joues (sinon rougeur globale)
  scores.sensibilite = (z && has(z.rougeurJoues))
    ? Math.round(z.rougeurJoues)
    : Math.round(texture?.redness || 35);

  // Contour des yeux ← cernes mesurés (ratio sous-yeux/joue) si dispo,
  // sinon ancien proxy (âge + fatigue questionnaire).
  scores.contour_yeux = (z && has(z.cernes))
    ? Math.round(z.cernes * 0.7 + ageNorm * 0.3)
    : Math.round(ageNorm * 0.6 + (expressions?.tired || 0.3) * 40);

  // Pores & texture ← brillance zone T (proxy sébum) si dispo, sinon unevenness global
  scores.pores = (z && has(z.brillanceT))
    ? Math.round(Math.min(100, z.brillanceT * 0.75 + ageNorm * 0.1))
    : Math.round(Math.min(100, (texture?.unevenness || 40) * 0.6 + ageNorm * 0.1));

  // Âge cutané global
  scores.peau_mature = Math.round(
    scores.rides * 0.3 +
    scores.relachement * 0.25 +
    scores.secheresse * 0.15 +
    scores.taches * 0.15 +
    scores.contour_yeux * 0.15
  );

  return scores;
}

/**
 * Scores visuels simulés quand la caméra n'est pas disponible
 * Basés uniquement sur les données questionnaire (âge, type de peau)
 */
function computeSimulatedVisualScores(hint = {}) {
  // DÉTERMINISTE : basé sur ageRangeHint uniquement, sans Math.random()
  // Garantit la reproductibilité pour le brevet et les tests de stabilité
  const base = hint.ageRangeHint || 50;
  // Valeurs fixes dérivées de base — reproductibles à 100%
  return {
    rides:        Math.round(base * 0.85 + 7),
    relachement:  Math.round(base * 0.80 + 7),
    secheresse:   Math.round(45 + (base - 50) * 0.3 + 10),
    eclat:        Math.round(55 - (base - 50) * 0.2 - 7),
    taches:       Math.round(base * 0.60 + 10),
    sensibilite:  Math.round(35 + (base - 50) * 0.2 + 10),
    contour_yeux: Math.round(base * 0.75 + 7),
    peau_mature:  Math.round(base * 0.88 + 6)
  };
}

// ─── SCORING QUESTIONNAIRE ─────────────────────────────────────────────────
/**
 * Convertit les réponses questionnaire en scores cutanés
 * @param {Object} answers - Réponses collectées {q1_skin_type: 'seche', ...}
 * @returns {Object} Scores questionnaire 0-100
 */
function computeQuestionnaireScores(answers) {
  const scores = Object.fromEntries(DIMENSIONS.map(d => [d, 0]));
  const counts = Object.fromEntries(DIMENSIONS.map(d => [d, 0]));

  // Q1 — Type de peau
  if (answers.q1_skin_type) {
    const opt = findOption('q1_skin_type', answers.q1_skin_type);
    if (opt) applyWeights(scores, counts, opt.weights);
  }

  // Q2 — Tranche d'âge
  if (answers.q2_age_range) {
    const opt = findOption('q2_age_range', answers.q2_age_range);
    if (opt) applyWeights(scores, counts, opt.weights);
  }

  // Q3 — Préoccupations principales (multi)
  if (answers.q3_main_concerns && answers.q3_main_concerns.length) {
    answers.q3_main_concerns.forEach(v => {
      const opt = findOption('q3_main_concerns', v);
      if (opt) applyWeights(scores, counts, opt.weights, 1.2);
    });
  }

  // Q4 — Hydratation ressentie (scale)
  if (answers.q4_hydration_feeling) {
    const q = getQuestion('q4_hydration_feeling');
    const w = q.weights[answers.q4_hydration_feeling];
    if (w) applyWeights(scores, counts, w);
  }

  // Q5 — Stade hormonal
  if (answers.q5_hormonal_stage) {
    const opt = findOption('q5_hormonal_stage', answers.q5_hormonal_stage);
    if (opt) applyWeights(scores, counts, opt.weights, 1.3);
  }

  // Q6 — Routine actuelle (multi — modifie en négatif)
  if (answers.q6_current_routine && answers.q6_current_routine.length) {
    answers.q6_current_routine.forEach(v => {
      const opt = findOption('q6_current_routine', v);
      if (opt) applyWeights(scores, counts, opt.weights);
    });
  }

  // Q7 — Exposition solaire
  if (answers.q7_sun_exposure) {
    const opt = findOption('q7_sun_exposure', answers.q7_sun_exposure);
    if (opt) applyWeights(scores, counts, opt.weights);
  }

  // Q8 — Stress / sommeil (scale)
  if (answers.q8_stress_sleep) {
    const q = getQuestion('q8_stress_sleep');
    const w = q.weights[answers.q8_stress_sleep];
    if (w) applyWeights(scores, counts, w);
  }

  // Q9 — Sensibilités connues (multi)
  if (answers.q9_known_sensitivities && answers.q9_known_sensitivities.length) {
    answers.q9_known_sensitivities.forEach(v => {
      const opt = findOption('q9_known_sensitivities', v);
      if (opt) applyWeights(scores, counts, opt.weights, 1.1);
    });
  }

  // Q10 — Environnement
  if (answers.q10_environment) {
    const opt = findOption('q10_environment', answers.q10_environment);
    if (opt) applyWeights(scores, counts, opt.weights);
  }

  // Q11 — Priorité N°1 (boost × 2)
  if (answers.q11_priorities) {
    const opt = findOption('q11_priorities', answers.q11_priorities);
    if (opt) applyWeights(scores, counts, opt.weights, 2.0);
  }

  // Normaliser 0-100
  DIMENSIONS.forEach(d => {
    scores[d] = counts[d] > 0
      ? Math.round(Math.min(100, scores[d] / counts[d]))
      : 50;
  });

  return scores;
}

// ─── COMBINAISON FINALE ────────────────────────────────────────────────────
/**
 * Combine scores visuels et questionnaire en profil final
 * @param {Object} visualScores
 * @param {Object} questionnaireScores
 * @param {Object} answers
 * @returns {Object} Profil complet
 */
function buildFinalProfile(visualScores, questionnaireScores, answers) {
  const VISUAL_WEIGHT = 0.40;
  const QUESTIONNAIRE_WEIGHT = 0.60;

  const combined = {};
  DIMENSIONS.forEach(d => {
    const v = visualScores[d] || 50;
    const q = questionnaireScores[d] || 50;
    combined[d] = Math.round(v * VISUAL_WEIGHT + q * QUESTIONNAIRE_WEIGHT);
  });

  const skinType = answers.q1_skin_type || 'eclat';
  const ageRange = answers.q2_age_range || '41_48';

  // Top 3 préoccupations (triées par score décroissant)
  const topConcerns = [...DIMENSIONS]
    .filter(d => d !== 'peau_mature')
    .sort((a, b) => combined[b] - combined[a])
    .slice(0, 3);

  // Priorités pour la recommandation produits
  const priorities = answers.q3_main_concerns && answers.q3_main_concerns.length >= 2
    ? [...answers.q3_main_concerns, answers.q11_priorities].filter(Boolean)
    : topConcerns;

  // Âge cutané vs âge chronologique
  const chronoAgeMap = { '30_34': 32, '35_40': 37, '41_48': 44, '49_55': 52, '56_65': 60 };
  const chronoAge = chronoAgeMap[ageRange] || 40;
  const skinAge = computeSkinAge(combined, chronoAge);

  return {
    skinType,
    ageRange,
    chronoAge,
    skinAge,
    ageDelta: skinAge - chronoAge,
    scores: combined,
    topConcerns,
    priorities: priorities.slice(0, 3),
    hormonalStage: answers.q5_hormonal_stage,
    needsHighlights: topConcerns.map(c => ({
      key: c,
      label: DIMENSION_LABELS[c],
      score: combined[c],
      severity: combined[c] >= 70 ? 'high' : combined[c] >= 45 ? 'medium' : 'low'
    }))
  };
}

// ─── CALCUL ÂGE CUTANÉ ────────────────────────────────────────────────────
function computeSkinAge(scores, chronoAge) {
  const weightedScore =
    scores.rides * 0.25 +
    scores.relachement * 0.20 +
    scores.secheresse * 0.15 +
    scores.taches * 0.15 +
    scores.eclat * (-0.10) +
    scores.peau_mature * 0.15;

  const deviation = ((weightedScore - 50) / 100) * 12;
  return Math.round(Math.max(25, Math.min(75, chronoAge + deviation)));
}

// ─── HELPERS ──────────────────────────────────────────────────────────────
function applyWeights(scores, counts, weights, multiplier = 1) {
  Object.entries(weights).forEach(([dim, value]) => {
    if (DIMENSIONS.includes(dim)) {
      scores[dim] = (scores[dim] || 0) + value * multiplier;
      counts[dim] = (counts[dim] || 0) + 1;
    }
  });
}

function getQuestion(id) {
  return QUESTIONS.find(q => q.id === id);
}

function findOption(questionId, value) {
  const q = getQuestion(questionId);
  return q ? q.options.find(o => o.value === value) : null;
}

/**
 * Génère le message personnalisé de diagnostic
 */
function generateDiagnosticText(profile) {
  const { skinType, ageRange, ageDelta, topConcerns, hormonalStage } = profile;

  const skinTypeLabels = {
    peau_mature: 'mature', peau_seche: 'sèche', peau_grasse: 'grasse',
    peau_sensible: 'sensible', eclat: 'en quête d\'éclat', peau_deshydratee: 'déshydratée',
    // Compat anciens labels
    seche: 'sèche', normale: 'normale', mixte: 'mixte', grasse: 'grasse', sensible: 'sensible'
  };

  const topLabel = DIMENSION_LABELS[topConcerns[0]] || '';
  const deltaText = ageDelta > 2
    ? `Votre peau paraît légèrement plus âgée que votre âge chronologique — un soin ciblé peut corriger cela rapidement.`
    : ageDelta < -2
    ? `Bonne nouvelle : votre peau paraît plus jeune que votre âge ! Continuez sur cette lancée.`
    : `Votre peau est en cohérence avec votre âge chronologique.`;

  const hormonalNote = hormonalStage === 'menopause' || hormonalStage === 'perimenopause'
    ? ` La fluctuation hormonale amplifie les besoins en nutrition et fermeté — votre routine doit l\'intégrer.`
    : '';

  return `Votre peau ${skinTypeLabels[skinType] || ''} présente des besoins prioritaires en ${topLabel.toLowerCase()}. ${deltaText}${hormonalNote}`;
}



// ──────────── js/products.js ────────────
/**
 * NOPAL LIFE SKIN INTELLIGENCE™ — Catalogue produits & Routines
 * Routines par OBJECTIF — réaligné le 23/06/2026
 *
 * ⛔ RÈGLES EN VIGUEUR (réécriture 23/06/2026) :
 *   1. GAMME FINALE = 19 produits (16 conservés + 3 nouveaux : bakuchiol, kojique, SPF30 teinté).
 *   2. SN-HFB-15 (Huile Figue de Barbarie) = ANCRE : toujours présente, toujours en position 1.
 *   3. 6 routines par OBJECTIF (antiage / eclat_taches / hydratation / apaisement / purete / signature),
 *      chacune en 3 niveaux cumulatifs : Essentiel ⊂ Ciblée ⊂ Complet.
 *   4. SN-TMS-30 (crème solaire teintée SPF30) = protecteur matin, recommandé dans les conseils.
 *   5. Le scan détecte un type de peau → mappé vers la routine OBJECTIF correspondante (SKIN_TYPE_TO_GOAL).
 *
 * ⚖️ CLAIM-SAFE : toutes les descriptions et tous les conseils sont rédigés sans allégation
 *    cosmétique interdite (pas de « reconstruit le collagène », « renouvellement cellulaire »,
 *    « inhibe la tyrosinase / mélanogenèse », « régule le sébum », « en profondeur », « efface les
 *    rides/taches », « guérit/traite », noms d'enzymes…). On parle d'APPARENCE et d'ASPECT
 *    (lisse l'aspect des ridules, aide à atténuer l'apparence des taches, aide à matifier
 *    l'apparence des zones brillantes, apparence de l'éclat, action antioxydante visible…).
 */

// ─── VARIANT IDS SHOPIFY (pour AJAX cart /cart/add.js) ───────────────────────
// 16 conservés + 3 nouveaux (variant IDs récupérés via API Shopify REST 2024-10 le 23/06/2026)
const SHOPIFY_VARIANTS = {
  'SN-HFB-15':   57201878204790,
  'SN-SFB-100':  57201877778806,
  'SN-MFB-120':  57201877320054,
  'SN-CFB-50':   57201876304246,
  'SN-PUM-190':  57201873617270,
  'SN-PUT-200':  57201873322358,
  'SN-MDC-50-W': 57201872994678,
  'SN-GBG-20-AB':57201872437622,
  'SN-VCS-30':   57201869029750,
  'SN-CNC-50-W': 57201867555190,
  'SN-SOM-150':  57201861689718,
  'SN-BPJS-30':  57201848549750,
  'SN-MPFM-100': 57201846157686,
  'SN-RAES-15':  57201838752118,
  'SN-DHBG-30':  57201836851574,
  'SN-AHAP-30':  57201835573622,
  // ── 3 nouveaux produits (gamme 19) ──
  'SN-RAOS-30':  58135439901046, // Sérum-huile bakuchiol (alternative au rétinol)
  'SN-KDS-15':   58135439966582, // Soin ciblé anti-taches acide kojique 1%
  'SN-TMS-30':   58135439999350, // Crème solaire teintée SPF30
};

// ─── KITS ROUTINE BOUTIQUE (product_type='Routine') ────────────────────────────
// SOURCE DE VÉRITÉ diagnostic ↔ boutique : chaque objectif pointe vers LE kit
// vendu en boutique (titre EXACT + handle), avec ses 3 variants de niveau
// (Essentiel / Ciblée / Complet). Variant IDs récupérés via API Shopify REST
// 2024-10 le 23/06/2026 (GET products.json?product_type=Routine).
// → À l'achat, le diagnostic ajoute 1 SEUL produit « kit » au prix remisé du
//   bundle (au lieu des produits individuels). Titres affichés partout = .title.
const KIT_BY_GOAL = {
  antiage: {
    title: 'Routine Anti-âge & Fermeté',
    handle: 'routine-anti-age-fermete',
    variants: { essentiel: 58135671177590, ciblee: 58135671210358, complet: 58135671243126 },
  },
  eclat_taches: {
    title: 'Routine Éclat & Teint unifié',
    handle: 'routine-eclat-teint-unifie',
    variants: { essentiel: 58135685136758, ciblee: 58135685169526, complet: 58135685202294 },
  },
  hydratation: {
    title: 'Routine Hydratation & Confort',
    handle: 'routine-hydratation-confort',
    variants: { essentiel: 58135685464438, ciblee: 58135685497206, complet: 58135685529974 },
  },
  apaisement: {
    title: 'Routine Apaisement & Barrière',
    handle: 'routine-apaisement-barriere',
    variants: { essentiel: 58135685562742, ciblee: 58135685595510, complet: 58135685628278 },
  },
  purete: {
    title: 'Routine Pureté & Équilibre',
    handle: 'routine-purete-equilibre',
    variants: { essentiel: 58135685661046, ciblee: 58135685693814, complet: 58135685726582 },
  },
  signature: {
    title: 'Rituel Signature Figue de Barbarie',
    handle: 'rituel-signature-figue-de-barbarie',
    variants: { essentiel: 58135685759350, ciblee: 58135685792118, complet: 58135685824886 },
  },
};

// Niveau de kit par défaut servi au diagnostic = « Ciblée » (le ⭐, recommandé).
const DEFAULT_KIT_LEVEL = 'ciblee';

// ─── CATALOGUE PRODUITS (19 produits) ────────────────────────────────────────
const PRODUCTS = [
  {
    id: 'SN-HFB-15',
    name: 'Huile de pépins de figue de barbarie pressée à froid – Bio',
    shortName: 'Huile Figue de Barbarie Bio',
    category: 'Huile visage',
    price: 39,
    image: null,
    skinTypes: ['peau_mature','peau_seche','peau_sensible','peau_deshydratee','eclat','peau_grasse'],
    description: "L'huile signature Nopal Life — pressée à froid, certifiée bio. Riche en vitamine E et en acides gras essentiels. Nourrit, apporte souplesse et confort et sublime l'aspect de toutes les peaux. En dernière étape pour aider à préserver l'hydratation.",
  },
  {
    id: 'SN-PUM-190',
    name: 'Mousse nettoyante douce à l\'Aloe vera – Peaux sensibles & normales',
    shortName: 'Mousse Nettoyante Aloe Vera',
    category: 'Nettoyant',
    price: 18,
    image: null,
    skinTypes: ['peau_sensible','peau_seche','peau_mature','eclat','peau_deshydratee'],
    description: "Mousse aérienne à l'aloe vera pour un nettoyage doux et apaisant. Respecte le film hydrolipidique et élimine les impuretés sans dessécher. Idéale peaux sensibles, normales et délicates.",
  },
  {
    id: 'SN-PUT-200',
    name: 'Tonique purifiant à l\'acide salicylique – Peaux mixtes & grasses',
    shortName: 'Tonique Purifiant BHA',
    category: 'Tonique',
    price: 18,
    image: null,
    skinTypes: ['peau_grasse'],
    description: "Tonique ciblé à l'acide salicylique (BHA) — aide à libérer les pores des impuretés, à affiner l'aspect du grain de peau et à limiter l'apparence des brillances sur peaux mixtes et grasses.",
  },
  {
    id: 'SN-MPFM-100',
    name: 'Brume douce aux prébiotiques – Équilibre & Hydratation',
    shortName: 'Brume Prébiotiques',
    category: 'Brume',
    price: 19,
    image: null,
    skinTypes: ['peau_seche','peau_sensible','peau_deshydratee'],
    description: "Brume express aux prébiotiques, acide hyaluronique et sucres végétaux — hydrate, apaise et prépare la peau à recevoir les soins. À vaporiser avant le sérum ou à tout moment de la journée.",
  },
  {
    id: 'SN-DHBG-30',
    name: 'Gel hydratant repulpant à l\'acide hyaluronique multi-formes – COSMOS NATURAL',
    shortName: 'Gel HA Multi-formes',
    category: 'Sérum gel',
    price: 28,
    image: null,
    skinTypes: ['peau_sensible','peau_deshydratee','peau_mature'],
    description: "Gel certifié COSMOS NATURAL à l'acide hyaluronique multi-formes et Sodium PCA — hydrate, apporte un effet repulpant et lisse l'aspect des ridules de déshydratation. Texture gel légère, tous types.",
  },
  {
    id: 'SN-VCS-30',
    name: 'Sérum éclat concentré à la vitamine C – Teint Unifié & Lumineux',
    shortName: 'Sérum Vitamine C Éclat',
    category: 'Sérum',
    price: 28,
    image: null,
    skinTypes: ['eclat'],
    description: "Sérum à la vitamine C — ravive l'apparence de l'éclat, aide à unifier l'apparence du teint et apporte une action antioxydante face aux effets visibles des UV et de la pollution. Le matin avant la crème, suivi d'une protection solaire.",
  },
  {
    id: 'SN-RAES-15',
    name: 'Sérum vitalisant contour des yeux – Regard frais & Défatigué',
    shortName: 'Sérum Contour des Yeux',
    category: 'Soin yeux',
    price: 28,
    image: null,
    skinTypes: ['peau_mature'],
    description: "Sérum dédié au contour des yeux — aide à raviver l'aspect du regard, à atténuer l'apparence des cernes et des poches et à lisser l'aspect des ridules de fatigue. Par tapotements, de l'angle interne vers l'externe.",
  },
  {
    id: 'SN-GBG-20-AB',
    name: 'Booster antioxydant au Ginkgo biloba – Protection & Éclat',
    shortName: 'Booster Ginkgo Antioxydant',
    category: 'Booster',
    price: 22,
    image: null,
    skinTypes: ['peau_grasse','eclat'],
    description: "Booster aux flavonoïdes de Ginkgo biloba — action antioxydante face aux agressions visibles (pollution, effets des UV) pour aider à préserver l'apparence de l'éclat. Se mélange à votre sérum ou votre crème habituelle.",
  },
  {
    id: 'SN-MDC-50-W',
    name: 'Crème de jour hydratante à l\'acide hyaluronique – Repulpante & Lumineuse',
    shortName: 'Crème Jour HA Repulpante',
    category: 'Crème de jour',
    price: 32,
    image: null,
    skinTypes: ['peau_mature','eclat','peau_deshydratee'],
    description: "Crème de jour fondante à l'acide hyaluronique — hydrate, apporte un effet repulpant et laisse un fini lumineux non gras. Parfaite seule ou sous maquillage pour peaux normales, mixtes et déshydratées.",
  },
  {
    id: 'SN-BPJS-30',
    name: 'Gel hydratant léger à l\'acide hyaluronique – Hydratation intense & Fini mat',
    shortName: 'Gel Hydratant Fini Mat',
    category: 'Gel hydratant',
    price: 32,
    image: null,
    skinTypes: ['peau_grasse'],
    description: "Gel à l'acide hyaluronique ultra-léger à fini mat — hydrate sans film gras et aide à matifier l'apparence des zones brillantes. Parfait pour peaux mixtes et grasses. Non comédogène.",
  },
  {
    id: 'SN-CFB-50',
    name: 'Crème de nuit enrichissante anti-âge bio à la figue de barbarie',
    shortName: 'Crème Nuit Anti-âge FdB Bio',
    category: 'Crème de nuit',
    price: 32,
    image: null,
    skinTypes: ['peau_mature','eclat'],
    description: "Crème de nuit bio enrichissante — huile de figue de barbarie, niacinamide et vitamine E. Nourrit, aide à préserver une apparence ferme et souple et lisse l'aspect des traits pour un teint reposé au réveil.",
  },
  {
    id: 'SN-CNC-50-W',
    name: 'Crème de nuit réparatrice aux céramides végétaux – Barrière & Hydratation',
    shortName: 'Crème Nuit Céramides Réparatrice',
    category: 'Crème de nuit',
    price: 32,
    image: null,
    skinTypes: ['peau_seche','peau_sensible'],
    description: "Crème de nuit aux céramides végétaux — aide à renforcer le confort de la barrière cutanée, à limiter la sensation de tiraillement et à nourrir les peaux fragilisées pendant le sommeil.",
  },
  {
    id: 'SN-SOM-150',
    name: 'Huile démaquillante douce aux huiles végétales – Maquillage & Impuretés',
    shortName: 'Huile Démaquillante',
    category: 'Démaquillant',
    price: 25,
    image: null,
    skinTypes: ['peau_sensible','peau_mature','peau_seche'],
    description: "Huile démaquillante aux huiles végétales nourrissantes — dissout le maquillage résistant et les impuretés en douceur. S'émulsionne à l'eau et se rince facilement. Premier nettoyage du soir.",
  },
  {
    id: 'SN-MFB-120',
    name: 'Masque visage bio à la poudre de pépins de figue de barbarie – Éclat & Nutrition',
    shortName: 'Masque Poudre FdB Bio',
    category: 'Masque',
    price: 24,
    image: null,
    skinTypes: ['peau_seche','peau_deshydratee'],
    description: "Masque en poudre 100 % naturel aux pépins de figue de barbarie — revitalise l'aspect des peaux ternes, nourrit et ravive l'apparence de l'éclat. 1 à 2 fois par semaine, 10-15 min.",
  },
  {
    id: 'SN-SFB-100',
    name: 'Savon exfoliant bio Figue de barbarie – Peaux ternes & rugueuses',
    shortName: 'Savon Exfoliant FdB Bio',
    category: 'Nettoyant exfoliant',
    price: 16,
    image: null,
    skinTypes: ['peau_grasse'],
    description: "Savon exfoliant à l'huile de figue de barbarie et poudre de graines — exfolie doucement les cellules mortes de surface, lisse l'aspect et ravive l'éclat du grain de peau. 2 à 3 fois par semaine sur peau humide.",
  },
  {
    id: 'SN-AHAP-30',
    name: 'Peeling AHA 10% à l\'acide lactique & acide hyaluronique – Éclat & Grain de peau',
    shortName: 'Peeling AHA 10% Acide Lactique',
    category: 'Exfoliant',
    price: 26,
    image: null,
    skinTypes: ['peau_grasse','eclat'],
    description: "Peeling aux AHA (acide lactique 10 %) enrichi en acide hyaluronique — exfolie en douceur, affine l'aspect du grain de peau et aide à atténuer l'apparence des taches et des ridules. 1 à 2 fois par semaine le soir. Protection solaire indispensable le lendemain.",
  },
  // ── 3 nouveaux produits (gamme 19) — descriptions claim-safe ──
  {
    id: 'SN-RAOS-30',
    name: 'Sérum-huile au bakuchiol – Alternative naturelle au rétinol – Rides & Fermeté',
    shortName: 'Sérum-huile Bakuchiol',
    category: 'Sérum',
    price: 23,
    image: null,
    skinTypes: ['peau_mature','eclat'],
    description: "Sérum-huile au bakuchiol — une alternative douce au rétinol, d'origine végétale. Aide à préserver une apparence ferme et souple et lisse l'aspect des ridules, sans la sensibilisation associée au rétinol. Le soir, quelques gouttes après le nettoyage.",
  },
  {
    id: 'SN-KDS-15',
    name: 'Soin ciblé anti-taches à l\'acide kojique 1 % – Éclat & Teint unifié',
    shortName: 'Soin Ciblé Anti-taches Kojique',
    category: 'Soin ciblé',
    price: 23,
    image: null,
    skinTypes: ['eclat'],
    description: "Soin ciblé à l'acide kojique 1 % — aide à atténuer l'apparence des taches et à unifier l'apparence du teint pour un éclat plus homogène. Application localisée sur les zones marquées, le soir. Protection solaire recommandée en journée.",
  },
  {
    id: 'SN-TMS-30',
    name: 'Crème solaire teintée SPF30 – Protection & Éclat naturel',
    shortName: 'Crème Solaire Teintée SPF30',
    category: 'Protection solaire',
    price: 25,
    image: null,
    skinTypes: ['peau_mature','eclat','peau_seche','peau_sensible','peau_deshydratee','peau_grasse'],
    description: "Crème solaire teintée SPF30 — protection solaire au fini naturel qui unifie l'apparence du teint et aide à protéger la peau des effets visibles du soleil. Dernière étape de la routine du matin. À renouveler régulièrement ; aucun produit solaire ne garantit une protection à 100 % contre les UVA/UVB : limitez l'exposition prolongée, recherchez l'ombre et couvrez les enfants.",
  },
];

// ─── ROUTINES PAR OBJECTIF ─────────────────────────────────────────────────────
// 6 objectifs × 3 niveaux cumulatifs (Essentiel ⊂ Ciblée ⊂ Complet).
// SN-HFB-15 (huile FdB) = ancre, toujours en position 1 (cf. getTopProducts).
// Chaque niveau supérieur = niveau précédent + 1 produit ciblé.
const ROUTINES_BY_GOAL = {
  antiage: {
    label: 'Anti-âge',
    essentiel: ['SN-HFB-15','SN-PUM-190','SN-MDC-50-W'],
    ciblee:    ['SN-HFB-15','SN-PUM-190','SN-MDC-50-W','SN-RAOS-30'],
    complet:   ['SN-HFB-15','SN-PUM-190','SN-MDC-50-W','SN-RAOS-30','SN-CFB-50'],
  },
  eclat_taches: {
    label: 'Éclat & Taches',
    essentiel: ['SN-HFB-15','SN-PUM-190','SN-MDC-50-W'],
    ciblee:    ['SN-HFB-15','SN-PUM-190','SN-MDC-50-W','SN-KDS-15'],
    complet:   ['SN-HFB-15','SN-PUM-190','SN-MDC-50-W','SN-KDS-15','SN-VCS-30'],
  },
  hydratation: {
    label: 'Hydratation',
    essentiel: ['SN-HFB-15','SN-PUM-190','SN-MDC-50-W'],
    ciblee:    ['SN-HFB-15','SN-PUM-190','SN-MDC-50-W','SN-DHBG-30'],
    complet:   ['SN-HFB-15','SN-PUM-190','SN-MDC-50-W','SN-DHBG-30','SN-MPFM-100'],
  },
  apaisement: {
    label: 'Apaisement',
    essentiel: ['SN-HFB-15','SN-PUM-190','SN-MDC-50-W'],
    ciblee:    ['SN-HFB-15','SN-PUM-190','SN-MDC-50-W','SN-MPFM-100'],
    complet:   ['SN-HFB-15','SN-PUM-190','SN-MDC-50-W','SN-MPFM-100','SN-CNC-50-W'],
  },
  purete: {
    label: 'Pureté',
    essentiel: ['SN-HFB-15','SN-PUM-190','SN-BPJS-30'],
    ciblee:    ['SN-HFB-15','SN-PUM-190','SN-BPJS-30','SN-PUT-200'],
    complet:   ['SN-HFB-15','SN-PUM-190','SN-BPJS-30','SN-PUT-200','SN-GBG-20-AB'],
  },
  signature: {
    label: 'Signature Figue de Barbarie',
    essentiel: ['SN-HFB-15','SN-SFB-100','SN-MDC-50-W'],
    ciblee:    ['SN-HFB-15','SN-SFB-100','SN-MDC-50-W','SN-MFB-120'],
    complet:   ['SN-HFB-15','SN-SFB-100','SN-MDC-50-W','SN-MFB-120','SN-CFB-50'],
  },
};

// Niveau de routine par défaut servi au diagnostic (le scan peut surcharger via profile.level).
const DEFAULT_ROUTINE_LEVEL = 'complet';

// ─── MAPPING type de peau détecté → routine OBJECTIF ───────────────────────────
// Le scan détecte un type de peau ; on le redirige vers l'objectif adapté.
// « signature » = routine transversale accessible, non mappée à un type détecté.
const SKIN_TYPE_TO_GOAL = {
  peau_mature:      'antiage',
  eclat:            'eclat_taches',
  peau_deshydratee: 'hydratation',
  peau_seche:       'hydratation',
  peau_sensible:    'apaisement',
  peau_grasse:      'purete',
  normale:          'eclat_taches', // défaut
  mixte:            'eclat_taches', // défaut
};

// ─── COMPAT : objet ROUTINES (type de peau → liste de SKU à plat) ──────────────
// Conserve l'API historique ROUTINES[skinType] = [SKU…] en s'appuyant sur le
// mapping objectif + niveau « complet ». Inclut aussi les clés objectif directes.
const ROUTINES = (function buildRoutines() {
  const out = {};
  // Clés objectif (ex. ROUTINES['antiage']) → niveau complet
  Object.keys(ROUTINES_BY_GOAL).forEach(function(goal) {
    out[goal] = ROUTINES_BY_GOAL[goal][DEFAULT_ROUTINE_LEVEL].slice();
  });
  // Clés type de peau (ex. ROUTINES['peau_mature']) → routine de l'objectif mappé
  Object.keys(SKIN_TYPE_TO_GOAL).forEach(function(skinType) {
    const goal = SKIN_TYPE_TO_GOAL[skinType];
    out[skinType] = ROUTINES_BY_GOAL[goal][DEFAULT_ROUTINE_LEVEL].slice();
  });
  return out;
})();

// ─── CONSEILS D'UTILISATION PAR OBJECTIF (claim-safe) ──────────────────────────
// Rédigés sans allégation interdite (apparence / aspect). SPF30 teinté = étape
// matin partout, huile FdB = dernier soin (ancre).
const ROUTINE_ADVICE_BY_GOAL = {
  antiage: "MATIN : Mousse nettoyante douce → Crème de jour HA repulpante → Huile Figue de Barbarie (2-3 gouttes, press & hold 10 s) → Crème solaire teintée SPF30 (dernière étape).\nSOIR : Mousse nettoyante → Sérum-huile bakuchiol (alternative douce au rétinol, quelques gouttes) → Crème de nuit anti-âge FdB → Huile Figue de Barbarie en dernier soin.\nObjectif : aider à préserver une apparence ferme et souple et lisser l'aspect des ridules. Le bakuchiol s'utilise le soir. Aspect plus lisse visible au fil des semaines.",

  eclat_taches: "MATIN : Mousse nettoyante douce → Sérum Vitamine C (action antioxydante) → Crème de jour HA → Crème solaire teintée SPF30 (indispensable, dernière étape).\nSOIR : Mousse nettoyante → Soin ciblé anti-taches kojique 1 % (en localisé sur les zones marquées) → Crème de jour HA ou Huile Figue de Barbarie en dernier soin.\nObjectif : aider à atténuer l'apparence des taches et unifier l'apparence du teint. La protection solaire SPF30 quotidienne est essentielle pour un résultat homogène. Le soin kojique s'applique le soir.",

  hydratation: "MATIN : Mousse nettoyante douce → Gel HA multi-formes (peau encore humide) → Crème de jour HA → Huile Figue de Barbarie (scelle l'hydratation) → Crème solaire teintée SPF30.\nSOIR : Mousse nettoyante → Gel HA multi-formes → Brume prébiotiques (confort) → Huile Figue de Barbarie en dernier soin.\nObjectif : hydratation, confort et souplesse, et lissage de l'aspect des ridules de déshydratation. Peau plus confortable dès les premières semaines.",

  apaisement: "MATIN : Mousse nettoyante douce → Brume prébiotiques → Crème de jour HA (tapoter) → Crème solaire teintée SPF30.\nSOIR : Huile démaquillante ou Mousse nettoyante douce → Brume prébiotiques → Crème de nuit céramides (effleurage) → Huile Figue de Barbarie en dernier soin (2-3 gouttes).\nObjectif : apaiser, apporter du confort et aider à renforcer le confort de la barrière cutanée. Introduire les produits un par un. Peau plus confortable dès 4 à 6 semaines.",

  purete: "MATIN : Mousse nettoyante douce → Gel HA fini mat (aide à matifier l'apparence des zones brillantes) → Crème solaire teintée SPF30.\nSOIR : Mousse nettoyante → Tonique BHA acide salicylique (laisser poser) → Gel HA fini mat → Booster Ginkgo antioxydant → Huile Figue de Barbarie (2-3 gouttes max, dernier soin).\nObjectif : aider à affiner l'aspect du grain de peau et à matifier l'apparence des brillances. Protection solaire SPF30 le matin, surtout après usage d'exfoliants. Aspect du grain affiné au fil de 3 à 6 semaines.",

  signature: "MATIN : Savon exfoliant Figue de Barbarie (sur peau humide) → Crème de jour HA → Huile Figue de Barbarie → Crème solaire teintée SPF30.\nSOIR : Savon ou Mousse nettoyante → Masque poudre Figue de Barbarie (1 à 2 fois par semaine, 10-15 min) → Crème de nuit anti-âge FdB → Huile Figue de Barbarie en dernier soin.\nObjectif : la routine signature autour de la figue de barbarie — nutrition, souplesse, confort et apparence de l'éclat. L'huile FdB reste le dernier soin de chaque routine.",
};

// ─── COMPAT : ROUTINE_ADVICE (par type de peau) → conseil de l'objectif mappé ──
const ROUTINE_ADVICE = (function buildAdvice() {
  const out = {};
  Object.keys(ROUTINE_ADVICE_BY_GOAL).forEach(function(goal) {
    out[goal] = ROUTINE_ADVICE_BY_GOAL[goal];
  });
  Object.keys(SKIN_TYPE_TO_GOAL).forEach(function(skinType) {
    out[skinType] = ROUTINE_ADVICE_BY_GOAL[SKIN_TYPE_TO_GOAL[skinType]];
  });
  return out;
})();

// ─── HELPERS ──────────────────────────────────────────────────────────────────

/**
 * Résout un type de peau (ou un objectif) vers une CLÉ valide d'objectif.
 * Accepte aussi bien 'peau_mature' que 'antiage'. Défaut : 'eclat_taches'.
 */
function resolveSkinType(skinType) {
  if (!skinType) return 'eclat_taches';
  if (ROUTINES_BY_GOAL[skinType]) return skinType;          // déjà un objectif
  if (SKIN_TYPE_TO_GOAL[skinType]) return SKIN_TYPE_TO_GOAL[skinType]; // type de peau → objectif
  return 'eclat_taches';
}

/**
 * Retourne les produits de la routine pour un profil donné.
 * SN-HFB-15 (huile FdB) TOUJOURS en premier, puis le reste de la routine.
 * profile.skinType = type détecté ('peau_mature'…) ou objectif ('antiage'…).
 * profile.level = 'essentiel' | 'ciblee' | 'complet' (défaut : complet).
 */
function getTopProducts(profile, limit) {
  profile = profile || {};
  const maxProducts = limit || 6;
  const goal = resolveSkinType(profile.skinType);
  const level = (profile.level && ROUTINES_BY_GOAL[goal][profile.level]) ? profile.level : DEFAULT_ROUTINE_LEVEL;
  const routine = (ROUTINES_BY_GOAL[goal] && ROUTINES_BY_GOAL[goal][level]) || ROUTINES_BY_GOAL['eclat_taches'][DEFAULT_ROUTINE_LEVEL];

  const huile = PRODUCTS.find(function(p) { return p.id === 'SN-HFB-15'; });
  const others = routine
    .filter(function(sku) { return sku !== 'SN-HFB-15'; })
    .map(function(sku) { return PRODUCTS.find(function(p) { return p.id === sku; }); })
    .filter(Boolean);

  return [huile].concat(others).filter(Boolean).slice(0, maxProducts);
}

function getRoutineAdvice(skinType) {
  const goal = resolveSkinType(skinType);
  return ROUTINE_ADVICE_BY_GOAL[goal] || ROUTINE_ADVICE_BY_GOAL['eclat_taches'];
}

function getProductBySku(sku) {
  return PRODUCTS.find(function(p) { return p.id === sku; });
}

/**
 * Ajoute les produits de la routine directement au panier Shopify via AJAX API
 * @param {Array} products — produits enrichis (avec .id = SKU)
 * @returns {Promise<{success: boolean, itemCount: number}>}
 */
async function addRoutineToCart(products) {
  const items = products
    .map(function(p) { return SHOPIFY_VARIANTS[p.id]; })
    .filter(Boolean)
    .map(function(variantId) { return { id: variantId, quantity: 1 }; });

  if (!items.length) return { success: false, itemCount: 0 };

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    });
    if (!res.ok) throw new Error('Cart add failed: ' + res.status);
    const data = await res.json();
    return { success: true, itemCount: data.items ? data.items.length : items.length };
  } catch(err) {
    console.warn('[Cart] Erreur ajout panier:', err);
    return { success: false, itemCount: 0, error: err.message };
  }
}

/**
 * Retourne le kit boutique (titre EXACT, handle, variants) pour un profil donné.
 * Accepte un type de peau ('peau_mature'…) ou un objectif ('antiage'…).
 * @param {string} goal — type de peau OU objectif
 * @returns {{title:string, handle:string, variants:{essentiel:number,ciblee:number,complet:number}}}
 */
function getKitForGoal(goal) {
  const key = resolveSkinType(goal);
  return KIT_BY_GOAL[key] || KIT_BY_GOAL['eclat_taches'];
}

/**
 * Ajoute LE KIT ROUTINE du bon niveau au panier Shopify (1 seul produit « kit »,
 * au prix remisé du bundle) via l'AJAX API /cart/add.js.
 * @param {string} goal — type de peau ('peau_mature'…) ou objectif ('antiage'…)
 * @param {string} [level='ciblee'] — 'essentiel' | 'ciblee' | 'complet' (défaut : ciblee ⭐)
 * @returns {Promise<{success: boolean, itemCount: number}>}
 */
async function addKitToCart(goal, level) {
  const kit = getKitForGoal(goal);
  const lvl = (level && kit.variants[level]) ? level : DEFAULT_KIT_LEVEL;
  const variantId = kit.variants[lvl] || kit.variants[DEFAULT_KIT_LEVEL];

  if (!variantId) return { success: false, itemCount: 0 };

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    });
    if (!res.ok) throw new Error('Cart add failed: ' + res.status);
    const data = await res.json();
    return { success: true, itemCount: data.items ? data.items.length : 1 };
  } catch(err) {
    console.warn('[Cart] Erreur ajout kit:', err);
    return { success: false, itemCount: 0, error: err.message };
  }
}



// ──────────── js/face-landmarker.js ────────────
/**
 * NOPAL LIFE — Module MediaPipe Face Landmarker (Palier 2, brique 1)
 * ---------------------------------------------------------------------------
 * Charge MediaPipe Tasks Vision (FaceLandmarker, 478 points normalisés +
 * 52 blendshapes + matrice de pose) en COEXISTENCE avec face-api.js.
 *
 * CHARGEMENT AU RUNTIME via IMPORT DYNAMIQUE — voir build-shopify.js :
 *   les regex de strip d'imports y sont ancrées `^import\s+...from...` (flag m),
 *   donc elles ne visent QUE les `import ... from "..."` en début de ligne.
 *   Un `await import("https://...")` est un APPEL de fonction (pas un statement
 *   en début de ligne avec `from`) → il n'est PAS supprimé par le build et
 *   survit dans l'IIFE bundlé. C'est la méthode retenue (cf. (a) du rapport).
 *
 * SÉCURITÉ : tout est try/catch. Ce module ne DOIT JAMAIS throw au chargement
 * du bundle. L'init réseau (import dynamique + fetch WASM/modèle) ne se déclenche
 * QU'À l'appel explicite de initFaceLandmarker() au démarrage du scan — jamais
 * au top-level. Le harness Node (vm.runInThisContext) charge donc ce fichier
 * sans toucher au réseau.
 * ---------------------------------------------------------------------------
 */

// CDN du package @mediapipe/tasks-vision v0.10.35 (ESM) + assets
const MP_VISION_ESM = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.35';
const MP_WASM_ROOT  = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.35/wasm';
const MP_MODEL_URL  =
  'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task';

const FaceLandmarkerMP = {
  available: false,        // true une fois le landmarker prêt
  loading: false,          // évite les inits concurrentes
  _landmarker: null,       // instance FaceLandmarker
  _delegate: null,         // 'GPU' | 'CPU' (informatif)
  _lastError: null,        // dernière erreur d'init (debug)
  _lite: false,            // true = options allégées mobile (sans blendshapes/pose)
  _scaleCanvas: null,      // canvas intermédiaire de downscale (mobile)
  _scaleCtx: null,         // contexte 2d du canvas de downscale
  // ── Inférence STATIQUE sur image figée (mobile : analyse finale 1-shot) ──────
  // Sur mobile, le guidage temps réel est piloté par face-api (léger) et MediaPipe
  // ne sert QU'À l'analyse finale : UNE SEULE inférence sur la frame CAPTURÉE
  // (image figée). On crée pour ça un SECOND landmarker en runningMode:'IMAGE'
  // (méthode detect(), pas detectForVideo()) — séparé du _landmarker VIDEO pour
  // ne pas mélanger les modes (MediaPipe interdit de changer de runningMode après
  // create). Aucune boucle → aucun gel possible (1 passe puis on rend la main).
  _stillLandmarker: null,  // instance FaceLandmarker runningMode:'IMAGE'
  _stillLoading: false,    // évite les inits concurrentes du landmarker IMAGE
  _stillVision: null,      // module vision mémoïsé (réutilisé entre init VIDEO/IMAGE)

  /**
   * Initialise MediaPipe FaceLandmarker (async, paresseux, idempotent).
   * Import dynamique → FilesetResolver (WASM) → FaceLandmarker.createFromOptions
   * (GPU d'abord, repli CPU). Ne throw jamais : renvoie true/false.
   * @param {{lite?:boolean}} [opts] - lite=true (mobile) : coupe blendshapes +
   *        matrice de pose pour alléger l'inférence (on ne les exploite pas encore).
   * @returns {Promise<boolean>}
   */
  async init(opts) {
    const lite = !!(opts && opts.lite);
    this._lite = lite;
    if (this.available && this._landmarker) return true;
    if (this.loading) {
      // Attente courte si une init est déjà en cours (autre appelant)
      for (let i = 0; i < 60 && this.loading; i++) {
        await new Promise(r => setTimeout(r, 100));
      }
      return this.available;
    }
    this.loading = true;
    try {
      // Import dynamique au RUNTIME (survit au build, cf. en-tête)
      const vision = await import(/* @vite-ignore */ MP_VISION_ESM);
      this._stillVision = vision;   // mémoïsé pour réutilisation par detectStill (IMAGE)
      const FilesetResolver = vision.FilesetResolver;
      const FaceLandmarker = vision.FaceLandmarker;
      if (!FilesetResolver || !FaceLandmarker) {
        throw new Error('MediaPipe tasks-vision: exports introuvables');
      }

      const filesetResolver = await FilesetResolver.forVisionTasks(MP_WASM_ROOT);

      // Mobile (lite) : blendshapes + matrice de pose COUPÉS (calcul en moins) ;
      // on n'exploite pas encore ces sorties. Desktop : on les garde (comportement
      // de prod inchangé, 478 pts + 52 blendshapes + pose).
      const baseOptions = (delegate) => ({
        baseOptions: { modelAssetPath: MP_MODEL_URL, delegate },
        runningMode: 'VIDEO',
        numFaces: 1,
        outputFaceBlendshapes: !lite,
        outputFacialTransformationMatrixes: !lite,
        minFaceDetectionConfidence: 0.5,
        minFacePresenceConfidence: 0.5,
        minTrackingConfidence: 0.5
      });

      // GPU d'abord, repli CPU si la création GPU échoue (driver/WebGL absent)
      try {
        this._landmarker = await FaceLandmarker.createFromOptions(
          filesetResolver, baseOptions('GPU')
        );
        this._delegate = 'GPU';
      } catch (gpuErr) {
        console.warn('[FaceLandmarkerMP] GPU indisponible, repli CPU', gpuErr && gpuErr.message);
        this._landmarker = await FaceLandmarker.createFromOptions(
          filesetResolver, baseOptions('CPU')
        );
        this._delegate = 'CPU';
      }

      this.available = true;
      console.log('[FaceLandmarkerMP] prêt (delegate=' + this._delegate + ', 478 pts'
        + (lite ? ', mode allégé mobile' : '') + ')');
      return true;
    } catch (err) {
      this._lastError = err;
      this.available = false;
      this._landmarker = null;
      console.warn('[FaceLandmarkerMP] init échouée — repli face-api', err && err.message);
      return false;
    } finally {
      this.loading = false;
    }
  },

  /**
   * Détecte un visage sur une frame vidéo et renvoie les points EN PIXELS.
   * MediaPipe sort des coordonnées NORMALISÉES [0,1] → on multiplie par
   * videoWidth / videoHeight (PIÈGE 2) pour rester homogène avec face-api
   * et avec _getZones/_sampleRegion qui travaillent en pixels vidéo source.
   *
   * DOWNSCALE (mobile) : si `maxWidth` est fourni et que la vidéo est plus large,
   * la frame est d'abord redessinée dans un canvas intermédiaire réduit (largeur
   * = maxWidth) et c'est CE canvas qui est passé à detectForVideo. L'inférence
   * coûte alors bien moins cher. Les points restent NORMALISÉS [0,1] côté modèle :
   * on les remet directement à l'échelle de la vidéo SOURCE (×vw/×vh) → toute la
   * géométrie pixel en aval est INCHANGÉE (les ROIs échantillonnent videoEl plein).
   *
   * @param {HTMLVideoElement} videoEl
   * @param {number} [timestampMs] - horodatage monotone (défaut: performance.now())
   * @param {number} [maxWidth] - largeur cible de downscale (mobile, ex. 384). 0/absent = pas de downscale.
   * @returns {{points:Array<{x:number,y:number}>, blendshapes:Object|null,
   *            pose:(Array<number>|null), width:number, height:number} | null}
   */
  detectFrame(videoEl, timestampMs, maxWidth) {
    if (!this.available || !this._landmarker || !videoEl) return null;
    try {
      const vw = videoEl.videoWidth || videoEl.width || 0;
      const vh = videoEl.videoHeight || videoEl.height || 0;
      if (!vw || !vh) return null;

      const ts = (typeof timestampMs === 'number')
        ? timestampMs
        : (typeof performance !== 'undefined' ? performance.now() : Date.now());

      // ── Source d'inférence : vidéo plein cadre OU canvas downscalé (mobile) ──
      let input = videoEl;
      if (maxWidth && vw > maxWidth && typeof document !== 'undefined') {
        try {
          const scale = maxWidth / vw;
          const dw = Math.max(1, Math.round(vw * scale));
          const dh = Math.max(1, Math.round(vh * scale));
          if (!this._scaleCanvas) {
            this._scaleCanvas = document.createElement('canvas');
            this._scaleCtx = this._scaleCanvas.getContext('2d', { willReadFrequently: false });
          }
          if (this._scaleCanvas.width !== dw)  this._scaleCanvas.width = dw;
          if (this._scaleCanvas.height !== dh) this._scaleCanvas.height = dh;
          this._scaleCtx.drawImage(videoEl, 0, 0, dw, dh);
          input = this._scaleCanvas;
        } catch (_) {
          input = videoEl; // tout pépin canvas → on retombe sur la vidéo plein cadre
        }
      }

      const res = this._landmarker.detectForVideo(input, ts);
      if (!res || !res.faceLandmarks || res.faceLandmarks.length === 0) return null;

      // Premier (seul) visage — conversion normalisé → pixels VIDÉO SOURCE.
      // (Le modèle renvoie des coords [0,1] relatives à SON entrée ; comme le
      //  downscale conserve l'aspect ratio, ×vw/×vh redonne les pixels source.)
      const lm = res.faceLandmarks[0];
      const points = new Array(lm.length);
      for (let i = 0; i < lm.length; i++) {
        const p = lm[i];
        points[i] = { x: p.x * vw, y: p.y * vh };
      }

      // Blendshapes → map { categoryName: score } (52 entrées attendues)
      let blendshapes = null;
      const bsList = res.faceBlendshapes && res.faceBlendshapes[0];
      if (bsList && bsList.categories) {
        blendshapes = {};
        for (const c of bsList.categories) {
          blendshapes[c.categoryName || c.displayName || ('cat' + c.index)] = c.score;
        }
      }

      // Matrice de pose (4x4 aplatie, 16 floats) si dispo
      let pose = null;
      const mtx = res.facialTransformationMatrixes && res.facialTransformationMatrixes[0];
      if (mtx && mtx.data) pose = Array.prototype.slice.call(mtx.data);

      return { points, blendshapes, pose, width: vw, height: vh };
    } catch (err) {
      // Ne jamais throw dans la boucle de scan
      return null;
    }
  },

  /**
   * Prépare (paresseux, idempotent) un landmarker dédié en runningMode:'IMAGE'
   * pour l'inférence STATIQUE sur image figée. Réutilise le module `vision`
   * déjà importé par init() si dispo (sinon import dynamique). Ne throw jamais.
   * @returns {Promise<boolean>}
   */
  async ensureStill() {
    if (this._stillLandmarker) return true;
    if (this._stillLoading) {
      for (let i = 0; i < 60 && this._stillLoading; i++) {
        await new Promise(r => setTimeout(r, 100));
      }
      return !!this._stillLandmarker;
    }
    this._stillLoading = true;
    try {
      const vision = this._stillVision || await import(/* @vite-ignore */ MP_VISION_ESM);
      this._stillVision = vision;
      const FilesetResolver = vision.FilesetResolver;
      const FaceLandmarker = vision.FaceLandmarker;
      if (!FilesetResolver || !FaceLandmarker) {
        throw new Error('MediaPipe tasks-vision: exports introuvables (still)');
      }
      const filesetResolver = await FilesetResolver.forVisionTasks(MP_WASM_ROOT);
      // runningMode:'IMAGE' → on appellera detect() (et NON detectForVideo).
      // On garde les blendshapes ici (1 seule passe, coût négligeable, et ça
      // alimente `expression` exactement comme le chemin desktop).
      const opts = (delegate) => ({
        baseOptions: { modelAssetPath: MP_MODEL_URL, delegate },
        runningMode: 'IMAGE',
        numFaces: 1,
        outputFaceBlendshapes: true,
        outputFacialTransformationMatrixes: true,
        minFaceDetectionConfidence: 0.5,
        minFacePresenceConfidence: 0.5,
        minTrackingConfidence: 0.5
      });
      try {
        this._stillLandmarker = await FaceLandmarker.createFromOptions(filesetResolver, opts('GPU'));
      } catch (gpuErr) {
        console.warn('[FaceLandmarkerMP] still GPU indisponible, repli CPU', gpuErr && gpuErr.message);
        this._stillLandmarker = await FaceLandmarker.createFromOptions(filesetResolver, opts('CPU'));
      }
      console.log('[FaceLandmarkerMP] still prêt (runningMode=IMAGE, 478 pts)');
      return true;
    } catch (err) {
      this._lastError = err;
      this._stillLandmarker = null;
      console.warn('[FaceLandmarkerMP] still init échouée', err && err.message);
      return false;
    } finally {
      this._stillLoading = false;
    }
  },

  /**
   * Inférence STATIQUE sur une image FIGÉE (canvas / ImageBitmap / <img> / vidéo
   * arrêtée). UNE SEULE passe via detect() (runningMode:'IMAGE') → aucun gel.
   * Format de sortie IDENTIQUE à detectFrame (points EN PIXELS de l'image source).
   *
   * @param {CanvasImageSource} image - canvas/ImageBitmap/HTMLImageElement figé.
   *        Doit exposer une largeur/hauteur (width/height ou videoWidth/videoHeight).
   * @returns {Promise<{points:Array<{x:number,y:number}>, blendshapes:Object|null,
   *            pose:(Array<number>|null), width:number, height:number} | null>}
   */
  async detectStill(image) {
    if (!image) return null;
    const ok = await this.ensureStill();
    if (!ok || !this._stillLandmarker) return null;
    try {
      const iw = image.width || image.videoWidth || (image.naturalWidth) || 0;
      const ih = image.height || image.videoHeight || (image.naturalHeight) || 0;
      if (!iw || !ih) return null;

      const res = this._stillLandmarker.detect(image);
      if (!res || !res.faceLandmarks || res.faceLandmarks.length === 0) return null;

      const lm = res.faceLandmarks[0];
      const points = new Array(lm.length);
      for (let i = 0; i < lm.length; i++) {
        const p = lm[i];
        points[i] = { x: p.x * iw, y: p.y * ih };
      }

      let blendshapes = null;
      const bsList = res.faceBlendshapes && res.faceBlendshapes[0];
      if (bsList && bsList.categories) {
        blendshapes = {};
        for (const c of bsList.categories) {
          blendshapes[c.categoryName || c.displayName || ('cat' + c.index)] = c.score;
        }
      }

      let pose = null;
      const mtx = res.facialTransformationMatrixes && res.facialTransformationMatrixes[0];
      if (mtx && mtx.data) pose = Array.prototype.slice.call(mtx.data);

      return { points, blendshapes, pose, width: iw, height: ih };
    } catch (err) {
      this._lastError = err;
      return null;
    }
  },

  /** Libère l'instance (optionnel — appelé à l'arrêt caméra si souhaité). */
  close() {
    try {
      if (this._landmarker && typeof this._landmarker.close === 'function') {
        this._landmarker.close();
      }
    } catch (_) { /* no-op */ }
    try {
      if (this._stillLandmarker && typeof this._stillLandmarker.close === 'function') {
        this._stillLandmarker.close();
      }
    } catch (_) { /* no-op */ }
    this._landmarker = null;
    this._stillLandmarker = null;
    this.available = false;
    this._scaleCanvas = null;
    this._scaleCtx = null;
  }
};

// Helpers exportés pour usage direct (façade simple attendue par le cadrage)
async function initFaceLandmarker() {
  return FaceLandmarkerMP.init();
}

function detectFrameMP(videoEl, timestampMs) {
  return FaceLandmarkerMP.detectFrame(videoEl, timestampMs);
}



// ──────────── js/face-analyzer.js ────────────
/**
 * NOPAL LIFE — Module Analyse Visuelle
 * Wrapper face-api.js : chargement modèles CDN, guidage caméra temps réel,
 * capture automatique, extraction des 8 paramètres cutanés
 */

const FACE_API_CDN = 'https://cdn.jsdelivr.net/npm/@vladmandic/face-api/dist/face-api.js';
const MODELS_URL = 'https://cdn.jsdelivr.net/npm/@vladmandic/face-api/model';

// ─── FEATURE FLAG PALIER 2 — MediaPipe Face Landmarker (478 pts) ────────────
// MediaPipe est désormais activé PARTOUT (desktop + mobile). Au démarrage du scan
// on initialise MediaPipe (paresseux) ; si dispo, les zones sont produites depuis
// ses 478 pts, sinon repli intégral sur face-api (chemin historique 100% intact).
// Scoring zones + `simulated` + claim-safe inchangés.
//
// MOBILE : MediaPipe à pleine charge (478 pts à 60 fps, frame pleine résolution,
// blendshapes + pose) est trop lourd → l'inférence rame et le scan ne se terminait
// pas. On le fait donc tourner en mode ALLÉGÉ sur mobile uniquement, piloté par
// _IS_MOBILE : (1) throttle de l'inférence (~MOBILE_INFER_MS), (2) downscale de la
// frame (MOBILE_INFER_WIDTH), (3) options légères (sans blendshapes ni pose),
// (4) condition de capture en TEMPS écoulé (pas en nb de frames), (5) watchdog qui
// bascule sur face-api si aucune capture après MP_WATCHDOG_MS. Desktop = inchangé.
const _IS_MOBILE = (function () {
  try {
    if (typeof navigator === 'undefined') return false;
    var ua = navigator.userAgent || navigator.vendor || '';
    if (/Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini|Mobile|Silk/i.test(ua)) return true;
    // iPad iPadOS 13+ s'annonce en "Macintosh" mais a un écran tactile multi-points
    if (typeof navigator.maxTouchPoints === 'number' && navigator.maxTouchPoints > 1 && /Macintosh/i.test(ua)) return true;
    return false;
  } catch (_) { return false; }
})();
const USE_MEDIAPIPE = true;

// ─── Réglages d'allègement MOBILE (ignorés sur desktop) ──────────────────────
// Throttle inférence MediaPipe : 1 inférence toutes les ~220 ms (≈4-5/s) sur
// mobile ; ~16 ms (≈60 fps libre) sur desktop. Entre deux inférences on réutilise
// le dernier résultat pour le rendu/guidage → l'overlay reste fluide.
const MOBILE_INFER_MS    = 220;   // intervalle mini entre 2 inférences MediaPipe (mobile)
const DESKTOP_INFER_MS   = 16;    // desktop : throttle quasi nul (comportement actuel)
const MP_INFER_INTERVAL  = _IS_MOBILE ? MOBILE_INFER_MS : DESKTOP_INFER_MS;
// Downscale : largeur cible de la frame envoyée à MediaPipe sur mobile (px).
// 0 sur desktop = aucun downscale (frame pleine résolution, prod inchangée).
const MOBILE_INFER_WIDTH = 384;
const MP_INFER_WIDTH     = _IS_MOBILE ? MOBILE_INFER_WIDTH : 0;
// Watchdog anti-blocage : si aucune capture après ce délai en mode MediaPipe,
// bascule proprement sur face-api pour garantir la fin du scan. DESKTOP seulement
// désormais (sur mobile le guidage est face-api, cf. _detectFace).
const MP_WATCHDOG_MS     = 9000;
// Timeout de l'ANALYSE FINALE MediaPipe STATIQUE sur l'image figée (mobile).
// Au-delà (init du landmarker IMAGE trop longue, WASM lent…), on abandonne et on
// retombe sur face-api pour produire le résultat. 1 passe → jamais de gel, mais on
// garde ce garde-fou pour ne pas faire attendre l'utilisateur indéfiniment.
const MP_STILL_TIMEOUT_MS = 3000;

// Référence runtime vers le module MediaPipe (face-landmarker.js, bundlé juste
// avant ce fichier). Résolue paresseusement : on ne touche au global que si le
// flag est actif, et jamais au top-level (le harness ne déclenche aucune init).
function _getMP() {
  try {
    if (typeof FaceLandmarkerMP !== 'undefined' && FaceLandmarkerMP) return FaceLandmarkerMP;
  } catch (_) { /* ReferenceError si le module n'est pas dans le bundle */ }
  try {
    if (typeof window !== 'undefined' && window.FaceLandmarkerMP) return window.FaceLandmarkerMP;
  } catch (_) { /* no-op */ }
  return null;
}

// Clamp + arrondi 0-100 (utilisé par l'analyse par zones)
function clamp100(v) {
  if (!isFinite(v)) return null;
  return Math.round(Math.max(0, Math.min(100, v)));
}

const FaceAnalyzer = {
  initialized: false,
  stream: null,
  animFrame: null,
  captureCallback: null,
  stableFrames: 0,
  STABLE_THRESHOLD: 45, // ~1.5s à 30fps — countdown naturel 3-2-1 (legacy, conservé)
  // ── Stabilité en TEMPS (robuste au throttle, cf. correction fin de scan) ────
  // On mesure la DURÉE pendant laquelle le visage reste "READY" (centré/cadré/
  // éclairé), indépendamment du nombre de frames d'inférence. C'est ce qui
  // déclenche la capture — fiable même à 4-5 inférences/s sur mobile.
  stableSince: 0,       // timestamp (performance.now) du début de stabilité, 0 = pas stable
  STABLE_MS: 1500,      // durée de stabilité requise avant capture (~1,5 s)
  COUNTDOWN_MS: 1000,   // dernière seconde = countdown 3-2-1 affiché
  _tmpCanvas: null,     // canvas pré-alloué pour mesures (évite new canvas en boucle)
  _analysisCanvas: null,
  mpReady: false,       // MediaPipe Face Landmarker prêt pour ce scan (Palier 2)
  // ── Throttle + cache d'inférence MediaPipe (mobile) ────────────────────────
  _lastInferTs: 0,      // timestamp de la dernière inférence MediaPipe
  _lastMpResult: null,  // dernier objet detection MediaPipe (réutilisé entre 2 inférences)
  _scanStartTs: 0,      // timestamp de démarrage de la boucle de guidage (watchdog)
  _mpWatchdogFired: false, // évite de rebasculer plusieurs fois

  // ─── INITIALISATION ──────────────────────────────────────────────────────
  async init() {
    if (this.initialized) return true;
    try {
      // Charger face-api.js depuis CDN si pas déjà chargé
      if (typeof faceapi === 'undefined') {
        await this._loadScript(FACE_API_CDN);
      }
      // Charger les modèles nécessaires
      await Promise.all([
        faceapi.nets.tinyFaceDetector.loadFromUri(MODELS_URL),
        faceapi.nets.faceLandmark68TinyNet.loadFromUri(MODELS_URL),
        faceapi.nets.ageGenderNet.loadFromUri(MODELS_URL)
      ]);
      this.initialized = true;
      console.log('[FaceAnalyzer] Modèles chargés avec succès');
      return true;
    } catch (err) {
      console.warn('[FaceAnalyzer] Chargement modèles échoué — mode questionnaire seul', err);
      return false;
    }
  },

  _loadScript(src) {
    return new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  },

  // ─── CAMÉRA ───────────────────────────────────────────────────────────────
  async startCamera(videoEl) {
    try {
      this.stream = await navigator.mediaDevices.getUserMedia({
        video: {
          width: { ideal: 1280, min: 320 },   // min réduit : compatible tous mobiles
          height: { ideal: 720, min: 240 },
          facingMode: 'user',
          frameRate: { ideal: 30, min: 15 },
          aspectRatio: { ideal: 4 / 3 }       // 4:3 plus adapté caméra frontale mobile
        }
      });
      // Pré-allouer les canvas de mesure une seule fois
      this._tmpCanvas = document.createElement('canvas');
      this._tmpCanvas.width = 80; this._tmpCanvas.height = 60;
      this._analysisCanvas = document.createElement('canvas');
      this._analysisCanvas.width = 160; this._analysisCanvas.height = 160;
      videoEl.srcObject = this.stream;
      await new Promise(r => { videoEl.onloadedmetadata = r; });
      await videoEl.play();

      // ── À CE POINT LA CAMÉRA EST LIVE ────────────────────────────────────
      // On retourne `true` IMMÉDIATEMENT après le démarrage du flux vidéo, sans
      // RIEN attendre d'autre. L'init MediaPipe (Palier 2) est lancée séparément
      // EN ARRIÈRE-PLAN (fire-and-forget) juste après — elle ne peut donc JAMAIS
      // bloquer ni retarder l'apparition de la caméra ni le démarrage du scan.
      // Tant que mpReady est false (init en cours, échouée, ou flag off),
      // _detectFace utilise face-api : caméra + scan 100% fonctionnels.
      this.mpReady = false;
      if (USE_MEDIAPIPE) this._initMediaPipeBackground();
      return true;
    } catch (err) {
      console.warn('[FaceAnalyzer] Caméra non disponible:', err.name);
      return false;
    }
  },

  // ─── INIT MEDIAPIPE EN ARRIÈRE-PLAN (NON BLOQUANTE, AVEC TIMEOUT) ───────────
  // Lancée APRÈS le démarrage caméra. Ne renvoie rien, n'est jamais `await`ée par
  // startCamera : le flux vidéo et la boucle de guidage tournent indépendamment.
  // - timeout 5 s : au-delà, on continue définitivement sur face-api (mpReady
  //   reste false), même si le chargement CDN/WASM/modèle finit par aboutir plus
  //   tard (on ignore alors le résultat tardif pour ne pas changer de moteur en
  //   plein scan).
  // - .catch() global : toute erreur (CSP qui bloque l'import dynamique depuis
  //   cdn.jsdelivr.net / storage.googleapis.com, WebGL absent, réseau) → repli
  //   silencieux sur face-api. Ne throw jamais, ne touche jamais au <video>.
  _initMediaPipeBackground() {
    let settled = false;
    const TIMEOUT_MS = 5000;
    try {
      const mp = _getMP();
      if (!mp || typeof mp.init !== 'function') return;

      const timer = setTimeout(() => {
        if (settled) return;
        settled = true;
        console.warn('[FaceAnalyzer] init MediaPipe > ' + TIMEOUT_MS + 'ms → on garde face-api');
      }, TIMEOUT_MS);

      Promise.resolve()
        .then(() => mp.init({ lite: _IS_MOBILE }))
        .then((ok) => {
          if (settled) return;            // timeout déjà écoulé → on ignore le résultat tardif
          settled = true;
          clearTimeout(timer);
          this.mpReady = !!ok;
          console.log('[FaceAnalyzer] MediaPipe ' + (this.mpReady ? 'actif' : 'indispo → face-api'));
        })
        .catch((e) => {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          this.mpReady = false;
          console.warn('[FaceAnalyzer] init MediaPipe échouée → face-api', e && e.message);
        });
    } catch (e) {
      // _getMP() ou setTimeout indisponible : repli immédiat, caméra intacte.
      this.mpReady = false;
      console.warn('[FaceAnalyzer] init MediaPipe non lancée → face-api', e && e.message);
    }
  },

  stopCamera() {
    if (this.stream) {
      this.stream.getTracks().forEach(t => t.stop());
      this.stream = null;
    }
    if (this.animFrame) {
      cancelAnimationFrame(this.animFrame);
      this.animFrame = null;
    }
  },

  // ─── BOUCLE DE GUIDAGE TEMPS RÉEL ────────────────────────────────────────
  // L'overlay/messages tournent à chaque frame d'animation (fluide). L'inférence
  // MediaPipe, elle, est THROTTLÉE (_detectFace réutilise le dernier résultat
  // entre deux inférences sur mobile). La capture se déclenche sur la DURÉE de
  // stabilité (stableSince), pas sur un compteur de frames — fiable même quand
  // peu d'inférences/s. Un WATCHDOG bascule sur face-api si rien n'aboutit.
  startGuidanceLoop(videoEl, canvasEl, guidanceEl, onCapture) {
    this.captureCallback = onCapture;
    this.stableFrames = 0;
    this.stableSince = 0;
    this._lastInferTs = 0;
    this._lastMpResult = null;
    this._mpWatchdogFired = false;
    this._scanStartTs = (typeof performance !== 'undefined') ? performance.now() : Date.now();

    const loop = async () => {
      if (!this.stream) return;
      const now = (typeof performance !== 'undefined') ? performance.now() : Date.now();

      // Watchdog anti-blocage (DESKTOP uniquement désormais) : MediaPipe pilote le
      // guidage temps réel sur desktop ; si aucune capture après le délai, repli
      // propre sur face-api pour terminer le scan (jamais de blocage infini).
      // ⚠️ Sur MOBILE, le guidage est DÉJÀ face-api (cf. _detectFace) et mpReady
      // doit rester true pour l'analyse finale 1-shot → on N'Y TOUCHE PAS.
      if (USE_MEDIAPIPE && !_IS_MOBILE && this.mpReady && !this._mpWatchdogFired
          && (now - this._scanStartTs) > MP_WATCHDOG_MS) {
        this._mpWatchdogFired = true;
        this.mpReady = false;          // force le chemin face-api dans _detectFace
        this._lastMpResult = null;
        this.stableSince = 0;          // on repart proprement sur le nouveau moteur
        try { if (!this.initialized) await this.init(); } catch (_) { /* no-op */ }
        console.warn('[FaceAnalyzer] watchdog MediaPipe (' + MP_WATCHDOG_MS + 'ms sans capture) → bascule face-api');
      }

      const result = await this._detectFace(videoEl);
      const state = this._evaluateFaceState(result, videoEl);
      this._drawOverlay(canvasEl, result, state);
      this._updateGuidance(guidanceEl, state);

      if (state.code === 'READY') {
        // Démarre/poursuit le chrono de stabilité (en TEMPS, pas en frames)
        if (!this.stableSince) this.stableSince = now;
        if ((now - this.stableSince) >= this.STABLE_MS) {
          this._autoCapture(videoEl, result);
          return;
        }
      } else {
        this.stableSince = 0;
      }
      this.animFrame = requestAnimationFrame(loop);
    };
    loop();
  },

  stopGuidanceLoop() {
    if (this.animFrame) {
      cancelAnimationFrame(this.animFrame);
      this.animFrame = null;
    }
  },

  // ─── DÉTECTION VISAGE (boucle de GUIDAGE temps réel) ──────────────────────
  async _detectFace(videoEl) {
    // ── MOBILE : le GUIDAGE temps réel n'appelle JAMAIS MediaPipe ────────────
    // La boucle continue (detectForVideo) gèle le main thread du téléphone, même
    // throttlée/downscalée. Sur mobile, le guidage (cadrage/centrage/capture auto)
    // est donc piloté UNIQUEMENT par face-api (léger, fluide) — on force ce chemin
    // même si mpReady est true. MediaPipe (478 pts) est réservé à l'ANALYSE FINALE,
    // en 1 SEULE inférence sur l'image figée (cf. _captureFrame → _runFinalMpAnalysis).
    // Desktop : comportement INCHANGÉ (MediaPipe temps réel ci-dessous).
    if (USE_MEDIAPIPE && this.mpReady && !_IS_MOBILE) {
      try {
        const now = (typeof performance !== 'undefined') ? performance.now() : Date.now();
        // THROTTLE : on ne lance une vraie inférence que si l'intervalle mini est
        // écoulé (mobile ~220 ms, desktop ~16 ms). Sinon, on RÉUTILISE le dernier
        // résultat → l'overlay/guidage reste fluide sans payer l'inférence.
        if (this._lastMpResult && (now - this._lastInferTs) < MP_INFER_INTERVAL) {
          return this._lastMpResult;
        }
        const mp = _getMP();
        // DOWNSCALE (mobile) : MP_INFER_WIDTH > 0 → la frame est réduite avant
        // inférence (desktop : 0 = frame pleine résolution, inchangé).
        const r = mp && mp.detectFrame(videoEl, now, MP_INFER_WIDTH);
        this._lastInferTs = now;
        if (r && r.points && r.points.length) {
          this._lastMpResult = this._mpToDetection(r, videoEl);
          return this._lastMpResult;
        }
        // r null = pas de visage cette frame → on oublie le cache et on renvoie
        // null (comme face-api) pour que la stabilité se réinitialise correctement.
        this._lastMpResult = null;
        return null;
      } catch {
        // En cas de pépin MediaPipe en cours de scan, repli silencieux face-api
        // (ne pas désactiver mpReady : ça peut être une frame transitoire).
      }
    }

    // ── Chemin face-api historique (DÉFAUT, 100% intact) ─────────────────────
    if (!this.initialized || typeof faceapi === 'undefined') return null;
    try {
      const opts = new faceapi.TinyFaceDetectorOptions({ inputSize: 512, scoreThreshold: 0.5 });
      return await faceapi
        .detectSingleFace(videoEl, opts)
        .withFaceLandmarks(true)
        .withAgeAndGender();
    } catch {
      return null;
    }
  },

  /**
   * Adapte un résultat MediaPipe (points pixels + blendshapes + pose) en objet
   * "detection-shaped" façon face-api, pour réutiliser tel quel le reste du
   * pipeline. La box est calculée comme bbox des 478 points.
   */
  _mpToDetection(r, videoEl) {
    const pts = r.points;
    let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    for (let i = 0; i < pts.length; i++) {
      const p = pts[i];
      if (p.x < minX) minX = p.x;
      if (p.x > maxX) maxX = p.x;
      if (p.y < minY) minY = p.y;
      if (p.y > maxY) maxY = p.y;
    }
    const vw = (videoEl && (videoEl.videoWidth || videoEl.width)) || r.width || 0;
    const vh = (videoEl && (videoEl.videoHeight || videoEl.height)) || r.height || 0;
    const box = { x: minX, y: minY, width: Math.max(1, maxX - minX), height: Math.max(1, maxY - minY) };

    return {
      _src: 'mp',                         // marqueur de source pour _getZones
      detection: { box, imageWidth: vw, imageHeight: vh, score: 1 },
      landmarks: { positions: pts, _src: 'mp' },
      // pas d'âge fiable côté MP → on laisse l'estimateur de zones/scoring gérer
      age: 35,
      blendshapes: r.blendshapes || null,
      pose: r.pose || null
    };
  },

  // ─── ÉVALUATION ÉTAT VISAGE ───────────────────────────────────────────────
  _evaluateFaceState(detection, videoEl) {
    if (!detection) {
      return { code: 'NO_FACE', label: 'Placez votre visage dans le cadre', progress: 0, color: '#888' };
    }

    const { box } = detection.detection;
    const vw = videoEl.videoWidth || videoEl.width;
    const vh = videoEl.videoHeight || videoEl.height;

    // Vérifier taille du visage (40-75% de la hauteur vidéo)
    const faceRatio = box.height / vh;
    if (faceRatio < 0.35) {
      return { code: 'TOO_FAR', label: 'Rapprochez-vous un peu', progress: 20, color: '#E8A840' };
    }
    if (faceRatio > 0.80) {
      return { code: 'TOO_CLOSE', label: 'Éloignez-vous légèrement', progress: 20, color: '#E8A840' };
    }

    // Vérifier centrage (±20% du centre)
    const centerX = box.x + box.width / 2;
    const centerY = box.y + box.height / 2;
    const offsetX = Math.abs(centerX / vw - 0.5);
    const offsetY = Math.abs(centerY / vh - 0.5);

    if (offsetX > 0.20) {
      const dir = centerX < vw / 2 ? 'Déplacez-vous vers la droite' : 'Déplacez-vous vers la gauche';
      return { code: 'OFF_CENTER', label: dir, progress: 40, color: '#E8A840' };
    }
    if (offsetY > 0.20) {
      const dir = centerY < vh / 2 ? 'Descendez légèrement' : 'Montez légèrement';
      return { code: 'OFF_CENTER_V', label: dir, progress: 40, color: '#E8A840' };
    }

    // Vérifier luminosité dans la bounding box visage (pas toute la frame)
    const brightness = this._measureBrightness(videoEl, box);
    if (brightness < 60) {
      return { code: 'TOO_DARK', label: 'Trop sombre — cherchez plus de lumière', progress: 50, color: '#E05C5C' };
    }
    if (brightness > 230) {
      return { code: 'TOO_BRIGHT', label: 'Trop lumineux — évitez la lumière directe', progress: 50, color: '#E05C5C' };
    }

    // ── Progression + countdown pilotés par le TEMPS de stabilité ────────────
    // (et non plus par un compteur de frames, qui devenait inatteignable avec
    //  l'inférence throttlée sur mobile). `stableSince` est posé par la boucle de
    //  guidage dès l'état READY ; ici on calcule la durée écoulée.
    const now = (typeof performance !== 'undefined') ? performance.now() : Date.now();
    const elapsed = this.stableSince ? (now - this.stableSince) : 0;
    const progress = 60 + Math.min(40, (elapsed / this.STABLE_MS) * 40);
    // Dernière COUNTDOWN_MS (≈1 s) → countdown 3-2-1 ; avant → "Restez immobile…".
    const remaining = this.STABLE_MS - elapsed;     // ms restantes avant capture
    if (remaining <= this.COUNTDOWN_MS) {
      // Mappe les ms restantes sur 3→2→1 (borné à [1,3])
      const cnt = Math.max(1, Math.min(3, Math.ceil((remaining / this.COUNTDOWN_MS) * 3)));
      return { code: 'READY', label: `${cnt}…`, progress, color: '#C9956A', detection, brightness, countdown: cnt };
    }
    return { code: 'READY', label: 'Parfait ! Restez immobile…', progress: 65, color: '#5B9E6B', detection, brightness, countdown: null };
  },

  // ─── MESURE LUMINOSITÉ (dans la ROI visage, pas toute la frame) ─────────────
  _measureBrightness(videoEl, box) {
    try {
      const c = this._tmpCanvas || document.createElement('canvas');
      c.width = 80; c.height = 60;
      const ctx = c.getContext('2d');
      if (box) {
        // Mesurer uniquement dans la bounding box du visage
        ctx.drawImage(videoEl, box.x, box.y, box.width, box.height, 0, 0, 80, 60);
      } else {
        ctx.drawImage(videoEl, 0, 0, 80, 60);
      }
      const data = ctx.getImageData(0, 0, 80, 60).data;
      let sum = 0;
      for (let i = 0; i < data.length; i += 4) {
        sum += (data[i] * 0.299 + data[i + 1] * 0.587 + data[i + 2] * 0.114);
      }
      return sum / (data.length / 4);
    } catch {
      return 128;
    }
  },

  // ─── SCORE QUALITÉ PHOTO (Q/100) ─────────────────────────────────────────
  computeQualityScore(videoEl, detection) {
    if (!detection) return { Q: 0, facteur_bloquant: 'aucun visage' };
    const { box } = detection.detection;
    const vw = videoEl.videoWidth || 640;
    const vh = videoEl.videoHeight || 480;

    // S_LUM : luminosité dans la bounding box visage
    const lum = this._measureBrightness(videoEl, box);
    const S_lum = lum < 40 ? 0 :
      lum > 220 ? Math.max(0, 100 - (lum - 220) * 4) :
      lum <= 100 ? (lum - 40) / 60 * 100 :
      lum <= 160 ? 100 :
      Math.max(0, 100 - (lum - 160) * 1.5);

    // S_NETT : variance Laplacian approximée (netteté)
    const S_nett = (() => {
      try {
        const c = this._analysisCanvas || document.createElement('canvas');
        c.width = 64; c.height = 64;
        const ctx = c.getContext('2d');
        const cx = box.x + box.width * 0.35;
        const cy = box.y + box.height * 0.25;
        ctx.drawImage(videoEl, cx, cy, box.width * 0.3, box.height * 0.4, 0, 0, 64, 64);
        const d = ctx.getImageData(0, 0, 64, 64).data;
        let variance = 0, mean = 0, n = 0;
        for (let i = 0; i < d.length; i += 4) {
          const g = d[i] * 0.299 + d[i+1] * 0.587 + d[i+2] * 0.114;
          mean += g; n++;
        }
        mean /= n;
        for (let i = 0; i < d.length; i += 4) {
          const g = d[i] * 0.299 + d[i+1] * 0.587 + d[i+2] * 0.114;
          variance += (g - mean) ** 2;
        }
        const lv = variance / n;
        return Math.min(100, lv / 8);
      } catch { return 50; }
    })();

    // S_CENTRAGE
    const cx = box.x + box.width / 2;
    const cy2 = box.y + box.height / 2;
    const offset = Math.max(Math.abs(cx / vw - 0.5), Math.abs(cy2 / vh - 0.5));
    const S_centrage = offset < 0.05 ? 100 : Math.max(0, 100 - (offset - 0.05) / 0.20 * 100);

    // S_COUVERTURE : ratio idéal 42-72%
    const faceRatio = box.height / vh;
    const S_couverture = faceRatio < 0.42 ? (faceRatio / 0.42) * 100 :
      faceRatio > 0.72 ? Math.max(0, 100 - (faceRatio - 0.72) / 0.20 * 100) : 100;

    // S_STABILITE — basée sur la DURÉE de stabilité (cohérent avec la capture
    // temps-based). La capture ne se déclenchant qu'à STABLE_MS atteint, ce score
    // vaut ~100 au moment de la capture auto.
    const _now = (typeof performance !== 'undefined') ? performance.now() : Date.now();
    const _elapsedStable = this.stableSince ? (_now - this.stableSince) : 0;
    const S_stabilite = Math.min(100, (_elapsedStable / this.STABLE_MS) * 100);

    const Q = Math.round(0.30 * S_lum + 0.25 * S_nett + 0.20 * S_centrage + 0.15 * S_couverture + 0.10 * S_stabilite);
    const facteurs = [
      { name: 'luminosité', score: S_lum },
      { name: 'netteté', score: S_nett },
      { name: 'centrage', score: S_centrage },
      { name: 'couverture', score: S_couverture }
    ].sort((a, b) => a.score - b.score);
    return { Q, facteur_bloquant: facteurs[0].name, S_lum, S_nett, S_centrage, S_couverture, S_stabilite };
  },

  // ─── OVERLAY CANVAS ───────────────────────────────────────────────────────
  _drawOverlay(canvasEl, detection, state) {
    if (!canvasEl) return;
    const ctx = canvasEl.getContext('2d');
    ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);

    // Fond semi-transparent avec découpe ovale
    ctx.fillStyle = 'rgba(15, 10, 5, 0.55)';
    ctx.fillRect(0, 0, canvasEl.width, canvasEl.height);

    // Ovale guide
    const cx = canvasEl.width / 2;
    const cy = canvasEl.height / 2 - 10;
    const rx = canvasEl.width * 0.32;
    const ry = canvasEl.height * 0.45;

    ctx.save();
    ctx.beginPath();
    ctx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2);
    ctx.clip();
    ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);
    ctx.restore();

    // Bordure ovale
    ctx.beginPath();
    ctx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2);
    ctx.strokeStyle = state.color || '#C8A96E';
    ctx.lineWidth = 3;
    ctx.setLineDash(state.code === 'READY' ? [] : [8, 6]);
    ctx.stroke();
    ctx.setLineDash([]);

    // Points landmarks (si disponible et OK)
    if (detection && detection.landmarks && state.code === 'READY') {
      const pts = detection.landmarks.positions;
      const scaleX = canvasEl.width / (detection.detection.imageWidth || canvasEl.width);
      const scaleY = canvasEl.height / (detection.detection.imageHeight || canvasEl.height);
      ctx.fillStyle = 'rgba(200, 169, 110, 0.6)';
      pts.forEach(p => {
        ctx.beginPath();
        ctx.arc(p.x * scaleX, p.y * scaleY, 1.5, 0, Math.PI * 2);
        ctx.fill();
      });
    }
  },

  _updateGuidance(guidanceEl, state) {
    if (!guidanceEl) return;

    // Countdown 3-2-1 overlay quand cercle vert
    const countdownEl = document.getElementById('scan-countdown');
    const countdownNum = document.getElementById('scan-countdown-num');

    if (state.countdown !== null && state.countdown !== undefined && state.code === 'READY') {
      // Afficher le countdown
      if (countdownEl) {
        if (countdownEl.style.display === 'none') {
          countdownEl.style.display = 'flex';
        }
        if (countdownNum) {
          const prev = countdownNum.textContent;
          const curr = String(state.countdown);
          if (prev !== curr) {
            // Nouvelle valeur → relancer l'animation
            countdownNum.textContent = curr;
            countdownNum.style.animation = 'none';
            requestAnimationFrame(() => {
              countdownNum.style.animation = 'countdown-pulse 0.9s ease-in-out';
            });
          }
        }
      }
      guidanceEl.textContent = '';
    } else {
      // Masquer le countdown
      if (countdownEl) countdownEl.style.display = 'none';
      guidanceEl.textContent = state.label;
    }

    guidanceEl.style.color = state.color;
    const bar = document.getElementById('scan-progress-bar');
    if (bar) bar.style.width = `${state.progress}%`;
  },

  // ─── CAPTURE ─────────────────────────────────────────────────────────────
  _autoCapture(videoEl, detection) {
    this.stopGuidanceLoop();
    this._captureFrame(videoEl, detection);
  },

  captureManual(videoEl) {
    this.stopGuidanceLoop();
    this._detectFace(videoEl).then(det => this._captureFrame(videoEl, det));
  },

  async _captureFrame(videoEl, detection) {
    // ── FRAME FIGÉE : on dessine la vidéo live dans un canvas (snapshot) ──────
    // À partir d'ici, l'analyse travaille sur CETTE image figée, plus sur le flux
    // live → aucune course, aucun gel possible (une seule passe).
    const canvas = document.createElement('canvas');
    canvas.width = videoEl.videoWidth || 1280;
    canvas.height = videoEl.videoHeight || 720;
    canvas.getContext('2d').drawImage(videoEl, 0, 0);
    const imageDataUrl = canvas.toDataURL('image/jpeg', 0.92);

    // ── ANALYSE FINALE ────────────────────────────────────────────────────────
    // DESKTOP : comportement INCHANGÉ. `detection` est DÉJÀ MediaPipe (478 pts,
    // temps réel) ; on l'utilise tel quel et on échantillonne — comme en prod — sur
    // le flux `videoEl` (aucune inférence supplémentaire, aucun changement).
    //
    // MOBILE : le guidage était face-api → `detection` n'a que 68 pts. Si MediaPipe
    // est prêt, on lance UNE SEULE inférence STATIQUE (478 pts) sur la frame FIGÉE
    // (canvas) et on en dérive la detection MP. On échantillonne alors les pixels
    // sur ce MÊME canvas figé (cohérent avec les points calculés dessus). Si
    // MediaPipe échoue / ne voit pas de visage / dépasse le timeout court → repli
    // sur la detection face-api du guidage (68 pts), échantillonnée sur le canvas.
    let analysisDetection = detection;
    let analysisSource = videoEl;              // desktop & défaut : flux live (inchangé)
    if (_IS_MOBILE) {
      analysisSource = canvas;                 // mobile : on fige toujours sur le canvas
      if (USE_MEDIAPIPE && this.mpReady) {
        try {
          const mpDet = await this._runFinalMpAnalysis(canvas);
          if (mpDet) analysisDetection = mpDet; // 478 pts sur l'image figée
        } catch (_) { /* repli sur la detection face-api du guidage */ }
      }
    }

    const faceData = await this._extractSkinData(analysisSource, analysisDetection);
    this.stopCamera();

    if (this.captureCallback) {
      this.captureCallback({ imageDataUrl, faceData });
    }
  },

  // ─── ANALYSE FINALE MEDIAPIPE STATIQUE (mobile) ───────────────────────────
  // UNE SEULE inférence MediaPipe sur l'image FIGÉE (canvas capturé) via
  // detectStill (runningMode:'IMAGE', detect()). Borné par un timeout court
  // (~MP_STILL_TIMEOUT_MS) : si MediaPipe n'a pas répondu à temps (init IMAGE
  // longue, WASM lent…), on abandonne et le flux retombe sur face-api. Aucun
  // gel : c'est 1 passe, pas une boucle. Renvoie une detection "MP-shaped"
  // (via _mpToDetection) ou null.
  _runFinalMpAnalysis(frozenImage) {
    const mp = _getMP();
    if (!mp || typeof mp.detectStill !== 'function') return Promise.resolve(null);
    const TIMEOUT_MS = MP_STILL_TIMEOUT_MS;
    const infer = Promise.resolve()
      .then(() => mp.detectStill(frozenImage))
      .then((r) => {
        if (r && r.points && r.points.length) {
          return this._mpToDetection(r, frozenImage);
        }
        return null;
      })
      .catch(() => null);
    const timeout = new Promise((resolve) => {
      setTimeout(() => resolve(null), TIMEOUT_MS);
    });
    return Promise.race([infer, timeout]);
  },

  // ─── EXTRACTION DONNÉES CUTANÉES ──────────────────────────────────────────
  async _extractSkinData(videoEl, detection) {
    if (!detection) {
      return { simulated: true, ageRangeHint: 50 };
    }

    const { age, landmarks } = detection;
    const brightness = this._measureBrightness(videoEl);
    const texture = this._analyzeTexture(videoEl, detection);
    const jawDrop = this._measureJawDrop(landmarks);
    // Palier 1 : analyse par zones (additif, ne casse rien si indisponible)
    const zones = this._analyzeZones(videoEl, detection);

    // Palier 2 (bonus) : remonter les blendshapes MediaPipe comme `expression`
    // SANS les exploiter encore (champ informatif, lecture seule en aval).
    // null si source face-api (pas de blendshapes) → aucun impact existant.
    const expression = (detection && detection.blendshapes) || null;

    return {
      simulated: false,
      age: Math.round(age),
      brightness,
      texture,
      zones,
      // jawDrop conservé (consommé par le scoring) + positions exposées pour la
      // cartographie heatmap existante (face-zones.js) — additif.
      // _src propagé pour que la heatmap (face-zones.js) choisisse les bons
      // indices quand les points viennent de MediaPipe (478) au lieu de face-api (68).
      landmarks: {
        jawDrop,
        positions: (landmarks && landmarks.positions) || null,
        _src: (landmarks && landmarks._src) || 'faceapi'
      },
      expressions: {},
      // Additif Palier 2 : blendshapes (52) + source des points (debug/perf)
      expression,
      source: (landmarks && landmarks._src === 'mp') ? 'mediapipe' : 'faceapi'
    };
  },

  _analyzeTexture(videoEl, detection) {
    try {
      const box = detection.detection.box;
      // Utiliser canvas pré-alloué. Source-agnostic : videoEl peut être la vidéo
      // live (guidage/desktop) OU le canvas figé (analyse finale mobile) → .width.
      const c = this._analysisCanvas || document.createElement('canvas');
      const scale = 160 / (videoEl.videoWidth || videoEl.width || 640);
      const w = Math.max(4, Math.round(box.width * scale));
      const h = Math.max(4, Math.round(box.height * scale));
      c.width = w; c.height = h;
      const ctx = c.getContext('2d');
      ctx.drawImage(videoEl, box.x, box.y, box.width, box.height, 0, 0, w, h);
      const data = ctx.getImageData(0, 0, w, h).data;
      const samples = data.length / 4;

      // Rougeur
      let rednessSum = 0;
      // Passe 1 : calcul de la moyenne de luminance (pour vraie variance)
      let meanGray = 0;
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i], g = data[i + 1], b = data[i + 2];
        rednessSum += Math.max(0, r - g - 20);
        meanGray += r * 0.299 + g * 0.587 + b * 0.114;
      }
      meanGray /= samples;

      // Passe 2 : vraie variance Σ(x - μ)² / N
      let varSum = 0;
      for (let i = 0; i < data.length; i += 4) {
        const gray = data[i] * 0.299 + data[i + 1] * 0.587 + data[i + 2] * 0.114;
        varSum += (gray - meanGray) ** 2;
      }
      const stdDev = Math.sqrt(varSum / samples);

      const redness = Math.min(100, (rednessSum / samples) / 1.5);
      const unevenness = Math.min(100, stdDev / 0.6); // normalisé : std 60 = 100
      const wrinkleScore = Math.min(100, unevenness * 0.8);

      return { redness: Math.round(redness), unevenness: Math.round(unevenness), wrinkleScore: Math.round(wrinkleScore) };
    } catch {
      return { redness: 35, unevenness: 45, wrinkleScore: 40 };
    }
  },

  // ─── ANALYSE PAR ZONES (Palier 1) ─────────────────────────────────────────
  // Segmente le visage via les 68 landmarks et mesure localement chaque ROI.
  // Privilégie les RATIOS entre zones pour neutraliser l'éclairage.
  //
  // Convention coordonnées : landmarks.positions et box sont dans l'espace
  // pixels de la vidéo source (videoWidth × videoHeight) — on échantillonne
  // donc directement depuis videoEl via drawImage(src ROI → canvas).

  /**
   * Calcule les rectangles ROI (en pixels vidéo) depuis les landmarks.
   * SOURCE-AWARE (Palier 2) : accepte aussi bien les 68 points face-api que
   * les 478 points MediaPipe (déjà en PIXELS dans les deux cas). Le marqueur
   * landmarks._src ('mp' | absent) sélectionne le bon jeu d'indices via un
   * petit normaliseur (A.*) ; toute la GÉOMÉTRIE en aval est INCHANGÉE.
   * @param {Object} landmarks - { positions:[{x,y}], _src? } pixels vidéo
   * @param {Object} box       - bounding box {x,y,width,height} (pixels)
   * @returns {Object|null}    - { front, joueG, joueD, zoneT, sousYeuxG,
   *                               sousYeuxD, coinG, coinD } chacun {x,y,w,h}, ou null
   */
  _getZones(landmarks, box) {
    try {
      const pts = landmarks && landmarks.positions;
      const isMP = !!(landmarks && landmarks._src === 'mp');
      // Seuil de validité : 68 pour face-api, ~468 pour MediaPipe (478 réels)
      const minLen = isMP ? 468 : 68;
      if (!pts || pts.length < minLen) return null;

      // ── Normaliseur d'indices 68(face-api) → 468/478(MediaPipe) ────────────
      // Chaque entrée "groupe" est une LISTE d'indices (consommée par bboxOf) ;
      // chaque "point" est un indice unique. Mapping documenté dans le rapport.
      const A = isMP
        ? {
            brows:    [70, 63, 105, 66, 107, 336, 296, 334, 293, 300], // sourcils G+D
            eyes:     [33, 133, 159, 145, 153, 362, 263, 386, 374, 380], // les 2 yeux
            noseTop:  168,                                              // haut arête nez (≈27)
            bridge:   [168, 6, 197, 195, 4],                           // arête nez (≈27-30)
            eyeOuterL: 33,  noseWingL: 64,  jawL: [234, 93, 132, 58, 172, 136, 150], // côté image G
            eyeOuterR: 263, noseWingR: 294, jawR: [454, 323, 361, 288, 397, 365, 379], // côté image D
            eyeLowerL: [33, 7, 163, 144, 145, 153],                    // paupière basse G (≈36-41)
            eyeLowerR: [362, 382, 381, 380, 374, 373]                  // paupière basse D (≈42-47)
          }
        : {
            brows:    [17, 18, 19, 20, 21, 22, 23, 24, 25, 26],
            eyes:     [36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47],
            noseTop:  27,
            bridge:   [27, 28, 29, 30],
            eyeOuterL: 36, noseWingL: 31, jawL: [1, 2, 3, 4, 5, 6, 7],
            eyeOuterR: 45, noseWingR: 35, jawR: [9, 10, 11, 12, 13, 14, 15],
            eyeLowerL: [36, 37, 38, 39, 40, 41],
            eyeLowerR: [42, 43, 44, 45, 46, 47]
          };

      // bbox d'une liste d'indices de landmarks
      const bboxOf = (idx) => {
        let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
        for (const i of idx) {
          const p = pts[i];
          if (!p) continue;
          if (p.x < minX) minX = p.x;
          if (p.x > maxX) maxX = p.x;
          if (p.y < minY) minY = p.y;
          if (p.y > maxY) maxY = p.y;
        }
        return { minX, maxX, minY, maxY };
      };

      const browBB = bboxOf(A.brows);              // sourcils G+D
      const eyeBB  = bboxOf(A.eyes);               // les deux yeux
      const browH  = Math.max(1, browBB.maxY - browBB.minY);
      // hauteur sourcils→arête nez = échelle verticale de référence du haut du visage
      const noseTopY = pts[A.noseTop] ? pts[A.noseTop].y : (eyeBB.minY);
      const brow2nose = Math.max(8, noseTopY - browBB.minY);

      const zones = {};

      // ── FRONT : au-dessus des sourcils (17-26) ───────────────────────────
      {
        const topY = browBB.minY - brow2nose * 1.5;
        zones.front = {
          x: browBB.minX,
          y: topY,
          w: browBB.maxX - browBB.minX,
          h: browBB.minY - topY
        };
      }

      // ── ZONE T : front + arête du nez (27-30) ────────────────────────────
      {
        const bridge = bboxOf(A.bridge);
        const topY = browBB.minY - brow2nose * 1.2;
        zones.zoneT = {
          x: Math.min(browBB.minX, bridge.minX),
          y: topY,
          w: Math.max(browBB.maxX, bridge.maxX) - Math.min(browBB.minX, bridge.minX),
          h: bridge.maxY - topY
        };
      }

      // ── JOUES : sous les yeux, à côté du nez ─────────────────────────────
      // Joue gauche (côté image) : entre coin œil G (36) / aile nez G (31)
      //   et mâchoire G (1-7).
      {
        const eyeOuterL = pts[A.eyeOuterL], noseWingL = pts[A.noseWingL];
        const jawL = bboxOf(A.jawL);
        const top = Math.max(eyeOuterL ? eyeOuterL.y : eyeBB.maxY, noseWingL ? noseWingL.y - browH : eyeBB.maxY);
        const x = jawL.minX;
        const right = noseWingL ? noseWingL.x : (eyeOuterL ? eyeOuterL.x + browH : x + browH);
        zones.joueG = {
          x, y: top,
          w: Math.max(6, right - x),
          h: Math.max(6, (noseWingL ? noseWingL.y : eyeBB.maxY + browH) - top + browH * 0.5)
        };
      }
      {
        const eyeOuterR = pts[A.eyeOuterR], noseWingR = pts[A.noseWingR];
        const jawR = bboxOf(A.jawR);
        const top = Math.max(eyeOuterR ? eyeOuterR.y : eyeBB.maxY, noseWingR ? noseWingR.y - browH : eyeBB.maxY);
        const x = noseWingR ? noseWingR.x : (eyeOuterR ? eyeOuterR.x - browH : jawR.maxX - browH);
        const right = jawR.maxX;
        zones.joueD = {
          x, y: top,
          w: Math.max(6, right - x),
          h: Math.max(6, (noseWingR ? noseWingR.y : eyeBB.maxY + browH) - top + browH * 0.5)
        };
      }

      // ── SOUS-YEUX : juste sous l'œil (36-41 G / 42-47 D) ─────────────────
      {
        const lo = bboxOf(A.eyeLowerL);   // œil gauche
        const eyeH = Math.max(4, lo.maxY - lo.minY);
        zones.sousYeuxG = {
          x: lo.minX,
          y: lo.maxY + eyeH * 0.15,
          w: Math.max(6, lo.maxX - lo.minX),
          h: Math.max(4, eyeH * 1.1)
        };
      }
      {
        const ro = bboxOf(A.eyeLowerR);   // œil droit
        const eyeH = Math.max(4, ro.maxY - ro.minY);
        zones.sousYeuxD = {
          x: ro.minX,
          y: ro.maxY + eyeH * 0.15,
          w: Math.max(6, ro.maxX - ro.minX),
          h: Math.max(4, eyeH * 1.1)
        };
      }

      // ── COINS DES YEUX / PATTES D'OIE : externes (36 G, 45 D) ────────────
      {
        const p36 = pts[A.eyeOuterL];
        if (p36) {
          const s = Math.max(8, browH * 1.1);
          zones.coinG = { x: p36.x - s, y: p36.y - s * 0.5, w: s, h: s };
        }
        const p45 = pts[A.eyeOuterR];
        if (p45) {
          const s = Math.max(8, browH * 1.1);
          zones.coinD = { x: p45.x, y: p45.y - s * 0.5, w: s, h: s };
        }
      }

      return zones;
    } catch {
      return null;
    }
  },

  /**
   * Échantillonne une ROI vidéo dans un canvas réutilisable et calcule des
   * statistiques pixel : luminance moyenne, rougeur (max(0,R-G)), écart-type
   * de luminance, et densité de contours (gradient type Sobel sur la grille
   * échantillonnée). Tout en une passe d'image.
   * @returns {Object|null} { n, meanLum, redness, lumStd, edge } ou null si ROI hors cadre/trop petite
   */
  _sampleRegion(videoEl, roi) {
    try {
      if (!roi) return null;
      const vw = videoEl.videoWidth || videoEl.width || 0;
      const vh = videoEl.videoHeight || videoEl.height || 0;
      if (!vw || !vh) return null;

      // Clamp dans le cadre vidéo
      let sx = Math.round(roi.x), sy = Math.round(roi.y);
      let sw = Math.round(roi.w), sh = Math.round(roi.h);
      if (sx < 0) { sw += sx; sx = 0; }
      if (sy < 0) { sh += sy; sy = 0; }
      if (sx >= vw || sy >= vh) return null;
      sw = Math.min(sw, vw - sx);
      sh = Math.min(sh, vh - sy);
      if (sw < 5 || sh < 5) return null;   // ROI trop petite → inexploitable

      // Canvas d'échantillonnage fixe (réutilise _analysisCanvas si dispo)
      const gw = 32, gh = 32;
      const c = this._analysisCanvas || document.createElement('canvas');
      c.width = gw; c.height = gh;
      const ctx = c.getContext('2d');
      ctx.drawImage(videoEl, sx, sy, sw, sh, 0, 0, gw, gh);
      const data = ctx.getImageData(0, 0, gw, gh).data;

      const n = gw * gh;
      const lum = new Float32Array(n);
      let sumLum = 0, sumRed = 0;
      for (let p = 0, i = 0; p < n; p++, i += 4) {
        const r = data[i], g = data[i + 1], b = data[i + 2];
        const L = r * 0.299 + g * 0.587 + b * 0.114;
        lum[p] = L;
        sumLum += L;
        sumRed += Math.max(0, r - g);   // proxy rougeur (érythème) — sans seuil arbitraire
      }
      const meanLum = sumLum / n;

      // Écart-type de luminance (variance localisée)
      let varSum = 0;
      for (let p = 0; p < n; p++) { const d = lum[p] - meanLum; varSum += d * d; }
      const lumStd = Math.sqrt(varSum / n);

      // Densité de contours — magnitude gradient type Sobel sur la grille luminance
      let edgeSum = 0, edgeN = 0;
      const at = (xx, yy) => lum[yy * gw + xx];
      for (let yy = 1; yy < gh - 1; yy++) {
        for (let xx = 1; xx < gw - 1; xx++) {
          const gx = (at(xx + 1, yy - 1) + 2 * at(xx + 1, yy) + at(xx + 1, yy + 1))
                   - (at(xx - 1, yy - 1) + 2 * at(xx - 1, yy) + at(xx - 1, yy + 1));
          const gy = (at(xx - 1, yy + 1) + 2 * at(xx, yy + 1) + at(xx + 1, yy + 1))
                   - (at(xx - 1, yy - 1) + 2 * at(xx, yy - 1) + at(xx + 1, yy - 1));
          edgeSum += Math.sqrt(gx * gx + gy * gy);
          edgeN++;
        }
      }
      const edge = edgeN > 0 ? edgeSum / edgeN : 0;

      return { n, meanLum, redness: sumRed / n, lumStd, edge };
    } catch {
      return null;
    }
  },

  /**
   * Mesures par zone → signaux cutanés normalisés 0-100 (100 = problème marqué).
   * Privilégie les ratios inter-zones (robustes à l'éclairage). Chaque signal
   * tombe à null si la/les zone(s) nécessaire(s) ne sont pas exploitables —
   * le scoring fera alors un fallback sur la mesure globale.
   * @returns {Object} { available, brillanceT, rougeurJoues, cernes, rides, uniformite, zonesUsed }
   */
  _analyzeZones(videoEl, detection) {
    const out = { available: false, brillanceT: null, rougeurJoues: null, cernes: null, rides: null, uniformite: null, zonesUsed: 0 };
    try {
      const box = detection && detection.detection && detection.detection.box;
      const landmarks = detection && detection.landmarks;
      const zones = this._getZones(landmarks, box);
      if (!zones) return out;

      // Échantillonner chaque zone (null si hors cadre)
      const S = {};
      let used = 0;
      for (const k of Object.keys(zones)) {
        const s = this._sampleRegion(videoEl, zones[k]);
        S[k] = s;
        if (s) used++;
      }
      out.zonesUsed = used;
      if (used === 0) return out;

      // Référence luminance globale du visage (pour normaliser les ratios)
      const refLum = (S.joueG && S.joueD) ? (S.joueG.meanLum + S.joueD.meanLum) / 2
                   : (S.joueG ? S.joueG.meanLum : (S.joueD ? S.joueD.meanLum : null));

      // ── Brillance zone T (proxy sébum visible) ──────────────────────────
      // Luminance T rapportée à la joue (ratio) + bonus si écart faible (T plus
      // brillant que les joues = peau qui réfléchit). Ratio robuste à la lumière.
      if (S.zoneT && refLum) {
        const ratio = S.zoneT.meanLum / Math.max(1, refLum);   // ~1 = homogène, >1 = T brillant
        // ratio 0.9→1.5 mappé sur 0→100
        out.brillanceT = clamp100((ratio - 0.9) / 0.6 * 100);
      } else if (S.zoneT) {
        // Pas de joue de référence → valeur absolue normalisée (fallback interne)
        out.brillanceT = clamp100((S.zoneT.meanLum - 110) / 1.2);
      }

      // ── Rougeur joues (sensibilité) ──────────────────────────────────────
      // moyenne max(0,R-G) sur les joues, normalisée.
      {
        const reds = [];
        if (S.joueG) reds.push(S.joueG.redness);
        if (S.joueD) reds.push(S.joueD.redness);
        if (reds.length) {
          const r = reds.reduce((a, b) => a + b, 0) / reds.length;
          out.rougeurJoues = clamp100(r / 1.5);   // ~même normalisation que l'ancien redness global
        }
      }

      // ── Cernes : luminance sous-yeux RAPPORTÉE à la joue (ratio) ─────────
      // sous-yeux plus sombre que la joue ⇒ cerne. score = (1 - ratio) amplifié.
      {
        const subs = [];
        if (S.sousYeuxG) subs.push(S.sousYeuxG.meanLum);
        if (S.sousYeuxD) subs.push(S.sousYeuxD.meanLum);
        if (subs.length && refLum) {
          const subLum = subs.reduce((a, b) => a + b, 0) / subs.length;
          const ratio = subLum / Math.max(1, refLum);   // <1 = sous-yeux plus sombre
          out.cernes = clamp100((1 - ratio) * 300);      // 0% diff→0 ; ~33% plus sombre→100
        }
      }

      // ── Rides : densité de contours front + pattes d'oie ────────────────
      // Edge moyen des zones rides, rapporté à l'edge des joues (peau lisse de
      // référence) pour neutraliser netteté caméra / éclairage.
      {
        const wr = [];
        if (S.front) wr.push(S.front.edge);
        if (S.coinG) wr.push(S.coinG.edge);
        if (S.coinD) wr.push(S.coinD.edge);
        if (wr.length) {
          const eWr = wr.reduce((a, b) => a + b, 0) / wr.length;
          const cheekEdges = [];
          if (S.joueG) cheekEdges.push(S.joueG.edge);
          if (S.joueD) cheekEdges.push(S.joueD.edge);
          if (cheekEdges.length) {
            const eCheek = cheekEdges.reduce((a, b) => a + b, 0) / cheekEdges.length;
            const ratio = eWr / Math.max(1, eCheek);   // 1 = aussi lisse que la joue
            out.rides = clamp100((ratio - 1) * 70);    // 1→0, ~2.4×→100
          } else {
            // Pas de joue de référence → edge absolu normalisé
            out.rides = clamp100(eWr * 2.2);
          }
        }
      }

      // ── Uniformité / taches : variance de luminance localisée joues+front ─
      {
        const stds = [];
        if (S.joueG) stds.push(S.joueG.lumStd);
        if (S.joueD) stds.push(S.joueD.lumStd);
        if (S.front) stds.push(S.front.lumStd);
        if (stds.length) {
          const s = stds.reduce((a, b) => a + b, 0) / stds.length;
          out.uniformite = clamp100(s / 0.6);   // même échelle que unevenness global
        }
      }

      out.available = (out.brillanceT != null || out.rougeurJoues != null ||
                       out.cernes != null || out.rides != null || out.uniformite != null);
      return out;
    } catch {
      return out;
    }
  },

  _measureJawDrop(landmarks) {
    if (!landmarks) return 50;
    try {
      const pts = landmarks.positions;
      const isMP = landmarks._src === 'mp';
      // Indices source-aware : menton, coins yeux G/D, centres sourcils G/D
      const I = isMP
        ? { chin: 152, eyeL: 33, eyeR: 263, browL: 105, browR: 334 }
        : { chin: 8,   eyeL: 36, eyeR: 45,  browL: 19,  browR: 24 };

      const eyeLeft = pts[I.eyeL];
      const eyeRight = pts[I.eyeR];
      const eyeY = (eyeLeft.y + eyeRight.y) / 2;
      const jawY = pts[I.chin].y;
      const faceH = jawY - eyeY;

      // BUG CORRIGÉ : diviser par faceH (pas jawY) — indépendant de la position dans le frame
      const browY = (pts[I.browL].y + pts[I.browR].y) / 2; // milieu sourcils
      const totalH = jawY - browY;
      const ratio = totalH > 0 ? faceH / totalH : 0.5;
      return Math.round(Math.max(0, Math.min(100, (1 - ratio) * 200)));
    } catch {
      return 50;
    }
  }
};



// ──────────── js/face-zones.js ────────────
/**
 * NOPAL LIFE — Module Cartographie des Zones Cutanées
 * ─────────────────────────────────────────────────────
 * Mappe les 68 landmarks vladmandic/face-api.js aux 6 zones de la peau,
 * extrait les métriques colorimétrique par zone (luminosité, rougeur,
 * variance texture, uniformité), et dessine la heatmap premium sur canvas.
 *
 * Usage :
 *   const mapper = new FaceZoneMapper(imageCanvas, landmarks);
 *   const zoneData = mapper.analyzeAllZones();
 *   const heatmapRenderer = new FaceHeatmapRenderer(overlayCanvas, zoneData, landmarks);
 *   heatmapRenderer.draw();
 */

// ─── MAPPING LANDMARKS → ZONES ───────────────────────────────────────────────
//
// Référence indices — face-api.js vladmandic, 68 landmarks :
//
//  Jawline    : 0–16   (17 points, arc mâchoire gauche→droite)
//  Sourcil G  : 17–21
//  Sourcil D  : 22–26
//  Nez dos    : 27–30  (pont nasal)
//  Nez base   : 30–35  (ailes + pointe)
//  Œil G      : 36–41
//  Œil D      : 42–47
//  Lèvres ext : 48–59
//  Lèvres int : 60–67
//
// Convention coordonnées : espace pixels relatifs au canvas source
//
const ZONE_LANDMARK_GROUPS = {
  forehead: {
    label: 'Front',
    // Le front n'a pas de landmarks directs — on l'infère depuis :
    //   • Sourcil G : pts 17-21, Sourcil D : pts 22-26
    //   • Haut du crane estimé au-dessus des sourcils
    anchors: { browLeft: [17, 21], browRight: [22, 26] },
    // Expansion verticale vers le haut = 1.6× la hauteur sourcil→base-nez
    relativeExpansion: { top: -1.6, bottom: 0, left: 0, right: 0 }
  },
  eye_area: {
    label: 'Contour yeux',
    // Œil gauche : 36-41, Œil droit : 42-47, Sourcils inclus
    anchors: { eyeLeft: [36, 41], eyeRight: [42, 47], browLeft: [17, 21], browRight: [22, 26] },
    relativeExpansion: { top: -0.5, bottom: 0.4, left: -0.3, right: 0.3 }
  },
  cheek_left: {
    label: 'Joue gauche',
    // Mâchoire gauche pts 1-7, coin œil gauche 36, base nez 31
    anchors: { jaw: [1, 7], eyeCorner: 36, noseSide: 31 },
    relativeExpansion: { top: 0, bottom: 0, left: -0.1, right: 0 }
  },
  cheek_right: {
    label: 'Joue droite',
    // Mâchoire droite pts 9-15, coin œil droit 45, base nez 35
    anchors: { jaw: [9, 15], eyeCorner: 45, noseSide: 35 },
    relativeExpansion: { top: 0, bottom: 0, left: 0, right: 0.1 }
  },
  nose: {
    label: 'Nez',
    // Pont nasal 27-30 + base/ailes 30-35
    anchors: { bridge: [27, 30], base: [30, 35] },
    relativeExpansion: { top: -0.1, bottom: 0.15, left: -0.2, right: 0.2 }
  },
  chin_jaw: {
    label: 'Menton & mâchoire',
    // Partie basse mâchoire 5-11, menton = pt 8
    anchors: { jaw: [5, 11], chin: 8 },
    relativeExpansion: { top: -0.1, bottom: 0.2, left: -0.1, right: 0.1 }
  },
  lips: {
    label: 'Contour lèvres',
    // Lèvres ext 48-59 + lèvres int 60-67
    anchors: { outer: [48, 59], inner: [60, 67] },
    relativeExpansion: { top: -0.3, bottom: 0.3, left: -0.15, right: 0.15 }
  }
};

// ─── CALCUL DES BOUNDING BOXES PAR ZONE ───────────────────────────────────────
/**
 * Calcule les bounding boxes pixel de chaque zone
 * à partir des positions landmarks et du canvas source.
 *
 * SOURCE-AWARE (Palier 2) : `isMP` true ⇒ les `positions` sont les 478 points
 * MediaPipe (au lieu des 68 face-api). Seuls les INDICES changent (résolus via
 * la table M.*) ; toute la géométrie de bounding box est INCHANGÉE. Flag-off
 * (face-api) : comportement identique au pixel près.
 *
 * @param {Array} positions   - landmarks.positions (68 face-api ou 478 MediaPipe, {x,y})
 * @param {number} imgW       - largeur image source
 * @param {number} imgH       - hauteur image source
 * @param {boolean} [isMP]    - true si les points proviennent de MediaPipe
 * @returns {Object}          - { forehead: {x, y, w, h}, eye_area: {...}, ... }
 */
function computeZoneBBoxes(positions, imgW, imgH, isMP) {
  const pts = positions;
  const bboxes = {};

  // ── Helper : bbox d'un groupe d'indices ──────────────────────────────────
  function bboxOf(indices) {
    let minX = Infinity, maxX = -Infinity, minY = Infinity, maxY = -Infinity;
    indices.forEach(i => {
      if (pts[i]) {
        minX = Math.min(minX, pts[i].x);
        maxX = Math.max(maxX, pts[i].x);
        minY = Math.min(minY, pts[i].y);
        maxY = Math.max(maxY, pts[i].y);
      }
    });
    return { minX, maxX, minY, maxY };
  }

  // ── Helper : range d'indices ─────────────────────────────────────────────
  function range(a, b) {
    return Array.from({ length: b - a + 1 }, (_, i) => a + i);
  }

  // ── Normaliseur d'indices 68(face-api) → 478(MediaPipe) ───────────────────
  // GROUPES = listes d'indices (→ bboxOf) ; POINTS = indice unique. Mêmes rôles
  // sémantiques que le mapping de face-analyzer.js (cohérence inter-modules).
  const M = isMP
    ? {
        brows:     [70, 63, 105, 66, 107, 336, 296, 334, 293, 300],        // ≈17-26
        browsEyes: [70, 63, 105, 66, 107, 336, 296, 334, 293, 300,
                    33, 133, 159, 145, 153, 362, 263, 386, 374, 380],      // ≈17-47
        noseTop:   168,                                                    // ≈27
        jawL:      [234, 93, 132, 58, 172, 136, 150],                      // ≈1-7
        jawR:      [454, 323, 361, 288, 397, 365, 379],                    // ≈9-15
        eyeCornerL: 33,  noseSideL: 64,                                    // ≈36 / ≈31
        eyeCornerR: 263, noseSideR: 294,                                   // ≈45 / ≈35
        nose:      [168, 6, 197, 195, 5, 4, 64, 294, 1],                   // ≈27-35
        jawLow:    [136, 150, 152, 377, 378, 365, 397],                    // ≈5-11
        chin:      152,                                                    // ≈8
        mouthBottom: 17,                                                   // ≈57
        lips:      [61, 40, 37, 0, 267, 291, 321, 314, 17, 84, 91,
                    78, 82, 13, 312, 308, 317, 14, 87]                     // ≈48-67
      }
    : {
        brows:     range(17, 26),
        browsEyes: range(17, 47),
        noseTop:   27,
        jawL:      range(1, 7),
        jawR:      range(9, 15),
        eyeCornerL: 36, noseSideL: 31,
        eyeCornerR: 45, noseSideR: 35,
        nose:      range(27, 35),
        jawLow:    range(5, 11),
        chin:      8,
        mouthBottom: 57,
        lips:      range(48, 67)
      };

  // ── Front ────────────────────────────────────────────────────────────────
  {
    const browBB = bboxOf(M.brows);
    const nosePt = pts[M.noseTop]; // pont nasal supérieur
    const browMidY = (browBB.minY + browBB.maxY) / 2;
    const heightBrow2Nose = Math.abs(nosePt.y - browMidY);
    const topY = Math.max(0, browBB.minY - heightBrow2Nose * 1.5);

    bboxes.forehead = {
      x: Math.max(0, browBB.minX - (browBB.maxX - browBB.minX) * 0.1),
      y: topY,
      w: Math.min(imgW, (browBB.maxX - browBB.minX) * 1.2),
      h: browBB.minY - topY + (browBB.maxY - browBB.minY) * 0.3
    };
  }

  // ── Contour yeux ─────────────────────────────────────────────────────────
  {
    const eyeBB = bboxOf(M.browsEyes);
    const padding = (eyeBB.maxX - eyeBB.minX) * 0.08;
    const vPad = (eyeBB.maxY - eyeBB.minY) * 0.5;

    bboxes.eye_area = {
      x: Math.max(0, eyeBB.minX - padding),
      y: Math.max(0, eyeBB.minY - vPad * 0.8),
      w: Math.min(imgW - eyeBB.minX, (eyeBB.maxX - eyeBB.minX) + padding * 2),
      h: (eyeBB.maxY - eyeBB.minY) + vPad * 1.4
    };
  }

  // ── Joue gauche ──────────────────────────────────────────────────────────
  {
    const jawLeft  = bboxOf(M.jawL);
    const eyeLeft  = pts[M.eyeCornerL]; // coin ext. œil gauche
    const noseSide = pts[M.noseSideL];  // aile nez gauche

    const x = Math.max(0, jawLeft.minX - (jawLeft.maxX - jawLeft.minX) * 0.05);
    const y = Math.min(eyeLeft.y, noseSide.y) + (Math.abs(noseSide.y - eyeLeft.y) * 0.1);
    const w = Math.max(noseSide.x - x, (jawLeft.maxX - jawLeft.minX) * 0.9);
    const h = jawLeft.maxY - y - (jawLeft.maxY - jawLeft.minY) * 0.15;

    bboxes.cheek_left = { x, y, w: Math.min(w, imgW - x), h: Math.max(h, 20) };
  }

  // ── Joue droite ──────────────────────────────────────────────────────────
  {
    const jawRight = bboxOf(M.jawR);
    const eyeRight = pts[M.eyeCornerR]; // coin ext. œil droit
    const noseSide = pts[M.noseSideR];  // aile nez droit

    const xEnd = Math.min(imgW, jawRight.maxX + (jawRight.maxX - jawRight.minX) * 0.05);
    const y = Math.min(eyeRight.y, noseSide.y) + (Math.abs(noseSide.y - eyeRight.y) * 0.1);
    const x = noseSide.x;
    const w = xEnd - x;
    const h = jawRight.maxY - y - (jawRight.maxY - jawRight.minY) * 0.15;

    bboxes.cheek_right = { x, y, w: Math.max(w, 20), h: Math.max(h, 20) };
  }

  // ── Nez ──────────────────────────────────────────────────────────────────
  {
    const noseBB = bboxOf(M.nose);
    const pad = (noseBB.maxX - noseBB.minX) * 0.15;

    bboxes.nose = {
      x: Math.max(0, noseBB.minX - pad),
      y: Math.max(0, noseBB.minY - pad * 0.5),
      w: (noseBB.maxX - noseBB.minX) + pad * 2,
      h: (noseBB.maxY - noseBB.minY) + pad
    };
  }

  // ── Menton & mâchoire ────────────────────────────────────────────────────
  {
    const chinBB  = bboxOf(M.jawLow);
    const chinPt  = pts[M.chin];
    const mouthBt = pts[M.mouthBottom]; // lèvre inférieure bas

    const y = Math.max(mouthBt ? mouthBt.y : chinBB.minY, chinBB.minY - (chinBB.maxY - chinBB.minY) * 0.2);
    const h = chinBB.maxY - y + (chinBB.maxY - chinBB.minY) * 0.2;

    bboxes.chin_jaw = {
      x: Math.max(0, chinBB.minX),
      y,
      w: Math.min(imgW - chinBB.minX, chinBB.maxX - chinBB.minX),
      h: Math.max(h, 20)
    };
  }

  // ── Contour lèvres ───────────────────────────────────────────────────────
  {
    const lipsBB = bboxOf(M.lips);
    const pad = (lipsBB.maxX - lipsBB.minX) * 0.12;
    const vPad = (lipsBB.maxY - lipsBB.minY) * 0.4;

    bboxes.lips = {
      x: Math.max(0, lipsBB.minX - pad),
      y: Math.max(0, lipsBB.minY - vPad),
      w: (lipsBB.maxX - lipsBB.minX) + pad * 2,
      h: (lipsBB.maxY - lipsBB.minY) + vPad * 2
    };
  }

  return bboxes;
}

// ─── EXTRACTION MÉTRIQUES PAR ZONE ────────────────────────────────────────────
/**
 * FaceZoneMapper
 * Analyse les pixels de chaque zone et retourne les métriques cutanées.
 *
 * @param {HTMLCanvasElement} sourceCanvas  - canvas contenant la photo capturée
 * @param {Object} landmarks               - objet face-api.js avec .positions
 */
class FaceZoneMapper {
  constructor(sourceCanvas, landmarks) {
    this.canvas = sourceCanvas;
    this.ctx = sourceCanvas.getContext('2d');
    this.W = sourceCanvas.width;
    this.H = sourceCanvas.height;
    this.landmarks = landmarks;
    this.positions = landmarks.positions;
    // Palier 2 : source des points (478 MediaPipe vs 68 face-api) pour le mapping
    this._isMP = !!(landmarks && landmarks._src === 'mp');
    this._bboxes = null;
  }

  getBBoxes() {
    if (!this._bboxes) {
      this._bboxes = computeZoneBBoxes(this.positions, this.W, this.H, this._isMP);
    }
    return this._bboxes;
  }

  /**
   * Analyse toutes les zones et retourne le ZoneProfile complet.
   * @returns {Object} { forehead: ZoneMetrics, eye_area: ..., ... }
   */
  analyzeAllZones() {
    const bboxes = this.getBBoxes();
    const result = {};

    Object.keys(bboxes).forEach(zoneKey => {
      const bb = bboxes[zoneKey];
      try {
        result[zoneKey] = this._analyzeZone(bb, zoneKey);
      } catch (e) {
        // Zone inaccessible (e.g. CORS sur image externe)
        result[zoneKey] = this._fallbackMetrics(zoneKey);
      }
    });

    return result;
  }

  /**
   * Analyse d'une zone unique.
   * @param {{x,y,w,h}} bb  - bounding box en pixels canvas
   * @param {string} zone   - clé zone
   * @returns {ZoneMetrics}
   */
  _analyzeZone(bb, zone) {
    const x = Math.max(0, Math.round(bb.x));
    const y = Math.max(0, Math.round(bb.y));
    const w = Math.max(1, Math.min(Math.round(bb.w), this.W - x));
    const h = Math.max(1, Math.min(Math.round(bb.h), this.H - y));

    if (w < 4 || h < 4) return this._fallbackMetrics(zone);

    const imageData = this.ctx.getImageData(x, y, w, h);
    const data = imageData.data;
    const n = w * h;

    let sumL = 0, sumR = 0, sumG = 0, sumB = 0;
    const grays = new Float32Array(n);

    for (let i = 0, pi = 0; i < data.length; i += 4, pi++) {
      const r = data[i], g = data[i + 1], b = data[i + 2];
      const gray = r * 0.299 + g * 0.587 + b * 0.114;
      sumL += gray;
      // Rougeur : excès rouge sur vert (peau inflammée)
      sumR += Math.max(0, r - g - 15);
      sumG += g;
      sumB += b;
      grays[pi] = gray;
    }

    const meanL = sumL / n;
    const brightness = Math.round((meanL / 255) * 100);

    // Rougeur normalisée 0–100
    const redness = Math.round(Math.min(100, (sumR / n) / 1.4));

    // Variance de luminosité → proxy rides / texture
    let varSum = 0;
    for (let i = 0; i < grays.length; i++) {
      varSum += (grays[i] - meanL) ** 2;
    }
    const stdDev = Math.sqrt(varSum / n);
    const textureVariance = Math.round(Math.min(100, (stdDev / 40) * 100));

    // Uniformité teint : écart-type couleur RGB → hétérogénéité chromatique
    // Un teint uniforme = faible variance R/G/B indépendamment
    const meanR = sumR / n;
    const meanG = sumG / n;
    const meanB = sumB / n;
    let colorVarSum = 0;
    for (let i = 0; i < data.length; i += 4) {
      colorVarSum += (data[i] - meanR) ** 2 + (data[i + 1] - meanG) ** 2 + (data[i + 2] - meanB) ** 2;
    }
    const colorStd = Math.sqrt(colorVarSum / (n * 3));
    const uniformity = Math.round(Math.max(0, 100 - Math.min(100, (colorStd / 45) * 100)));

    // Score zone global (100 = parfait)
    const rawScore = this._computeZoneScore(zone, brightness, redness, textureVariance, uniformity);

    return {
      zone,
      label: ZONE_LANDMARK_GROUPS[zone]?.label || zone,
      bbox: { x, y, w, h },
      metrics: {
        brightness,      // 0-100 : 100 = très lumineux
        redness,         // 0-100 : 100 = très rouge/inflammé
        textureVariance, // 0-100 : 100 = texture très irrégulière
        uniformity       // 0-100 : 100 = teint très uniforme
      },
      score: rawScore   // 0-100 : 100 = zone en parfait état
    };
  }

  /**
   * Score de zone normalisé "positif" (100 = excellent)
   * Pondérations différentes selon les zones.
   */
  _computeZoneScore(zone, brightness, redness, textureVariance, uniformity) {
    // Contribution négative normalisée 0-100
    const rednessPenalty    = redness;
    const texturePenalty    = textureVariance;
    const uniformityBonus   = uniformity;
    const brightnessFactor  = brightness >= 30 && brightness <= 85
      ? 100
      : brightness < 30 ? brightness * 2 : Math.max(0, 100 - (brightness - 85) * 2);

    const WEIGHTS = {
      forehead:    { redness: 0.20, texture: 0.35, uniformity: 0.25, brightness: 0.20 },
      eye_area:    { redness: 0.15, texture: 0.40, uniformity: 0.20, brightness: 0.25 },
      cheek_left:  { redness: 0.30, texture: 0.25, uniformity: 0.30, brightness: 0.15 },
      cheek_right: { redness: 0.30, texture: 0.25, uniformity: 0.30, brightness: 0.15 },
      nose:        { redness: 0.35, texture: 0.25, uniformity: 0.25, brightness: 0.15 },
      chin_jaw:    { redness: 0.20, texture: 0.30, uniformity: 0.25, brightness: 0.25 },
      lips:        { redness: 0.25, texture: 0.20, uniformity: 0.35, brightness: 0.20 }
    };

    const w = WEIGHTS[zone] || WEIGHTS.forehead;
    const penalty = rednessPenalty * w.redness + texturePenalty * w.texture;
    const bonus   = uniformityBonus * w.uniformity + brightnessFactor * w.brightness;

    return Math.round(Math.max(0, Math.min(100, bonus - penalty * 0.6 + 20)));
  }

  _fallbackMetrics(zone) {
    return {
      zone,
      label: ZONE_LANDMARK_GROUPS[zone]?.label || zone,
      bbox: { x: 0, y: 0, w: 0, h: 0 },
      metrics: { brightness: 65, redness: 30, textureVariance: 35, uniformity: 70 },
      score: 65
    };
  }
}

// ─── RENDU HEATMAP PREMIUM ────────────────────────────────────────────────────
/**
 * FaceHeatmapRenderer
 * Dessine la heatmap des zones sur un canvas overlay superposé à la photo.
 *
 * @param {HTMLCanvasElement} overlayCanvas - canvas transparent par-dessus la photo
 * @param {Object} zoneData               - retour de FaceZoneMapper.analyzeAllZones()
 * @param {Object} landmarks              - face-api.js landmarks (pour les contours de zones)
 * @param {Object} [options]              - options visuelles
 */
class FaceHeatmapRenderer {
  constructor(overlayCanvas, zoneData, landmarks, options = {}) {
    this.canvas = overlayCanvas;
    this.ctx = overlayCanvas.getContext('2d');
    this.zoneData = zoneData;
    this.landmarks = landmarks;
    this.W = overlayCanvas.width;
    this.H = overlayCanvas.height;

    // Options avec defaults NOPAL LIFE premium
    this.opts = Object.assign({
      opacity: 0.72,            // Transparence globale heatmap
      labelFont: '500 11px "Inter", sans-serif',
      labelFontMobile: '500 9px "Inter", sans-serif',
      animationMs: 800,         // Durée fade-in
      showLabels: true,
      showScoreInLabel: true
    }, options);

    this._hoveredZone = null;
    this._animStart = null;
    this._rafId = null;
  }

  // ── Palette NOPAL LIFE ──────────────────────────────────────────────────
  // score 0-100 → couleur overlay
  // Pas de rouge agressif : orange profond max, dégradé vers or/vert doux
  static scoreToColor(score) {
    if (score >= 80) {
      // Excellent — or lumineux / vert doux
      return { fill: 'rgba(184, 220, 140, 0.35)', stroke: 'rgba(148, 196, 90, 0.80)', label: '#6A9A40' };
    } else if (score >= 62) {
      // Bon — or NOPAL / beige doré
      return { fill: 'rgba(212, 185, 120, 0.32)', stroke: 'rgba(201, 160, 88, 0.75)', label: '#A07A38' };
    } else if (score >= 42) {
      // Attention — ambre/terre cuite douce
      return { fill: 'rgba(210, 148, 80, 0.35)', stroke: 'rgba(196, 126, 55, 0.80)', label: '#8B5E2A' };
    } else {
      // Besoin d'attention — brique rosée (jamais rouge vif)
      return { fill: 'rgba(195, 110, 90, 0.33)', stroke: 'rgba(178, 90, 72, 0.78)', label: '#8A4030' };
    }
  }

  // ── Labels niveau ────────────────────────────────────────────────────────
  static scoreToBadge(score) {
    if (score >= 80) return 'Excellent';
    if (score >= 62) return 'Bon';
    if (score >= 42) return 'Attention';
    return 'À traiter';
  }

  // ── Dessin principal ─────────────────────────────────────────────────────
  draw(animated = true) {
    if (animated) {
      this._animStart = performance.now();
      this._animate();
    } else {
      this._renderFrame(1.0);
    }
  }

  _animate() {
    const elapsed = performance.now() - this._animStart;
    const progress = Math.min(1, elapsed / this.opts.animationMs);
    // Easing cubic-out
    const eased = 1 - Math.pow(1 - progress, 3);
    this._renderFrame(eased);
    if (progress < 1) {
      this._rafId = requestAnimationFrame(() => this._animate());
    }
  }

  _renderFrame(alpha) {
    const ctx = this.ctx;
    ctx.clearRect(0, 0, this.W, this.H);
    ctx.save();
    ctx.globalAlpha = alpha * this.opts.opacity;

    Object.values(this.zoneData).forEach(zone => {
      if (!zone.bbox || zone.bbox.w < 4) return;
      this._drawZone(zone, alpha);
    });

    ctx.globalAlpha = 1;
    ctx.restore();
  }

  // ── Rendu d'une zone : remplissage + bordure + label ─────────────────────
  _drawZone(zone, alpha) {
    const ctx = this.ctx;
    const { x, y, w, h } = zone.bbox;
    const colors = FaceHeatmapRenderer.scoreToColor(zone.score);
    const isHovered = this._hoveredZone === zone.zone;
    const hoverBoost = isHovered ? 1.5 : 1;

    // Remplissage avec gradient radial pour effet "glow" naturel
    const cx = x + w / 2, cy = y + h / 2;
    const grad = ctx.createRadialGradient(cx, cy, 0, cx, cy, Math.max(w, h) * 0.7);

    // Extraire la couleur de base et appliquer boost hover
    const fillOpacity = (parseFloat(colors.fill.match(/[\d.]+(?=\))/)[0]) * hoverBoost * alpha).toFixed(3);
    const baseColor   = colors.fill.replace(/[\d.]+(?=\))/, '0');

    grad.addColorStop(0,   colors.fill.replace(/[\d.]+(?=\))/, (parseFloat(fillOpacity) * 1.4).toFixed(3)));
    grad.addColorStop(0.6, colors.fill.replace(/[\d.]+(?=\))/, fillOpacity));
    grad.addColorStop(1,   baseColor);

    // Forme arrondie (coinces arrondis adaptés à chaque zone)
    const r = Math.min(w, h) * 0.22;
    ctx.globalAlpha = alpha * this.opts.opacity;
    this._roundRect(x, y, w, h, r);
    ctx.fillStyle = grad;
    ctx.fill();

    // Bordure
    ctx.strokeStyle = colors.stroke;
    ctx.lineWidth   = isHovered ? 2 : 1.2;
    ctx.setLineDash(isHovered ? [] : [4, 3]);
    this._roundRect(x, y, w, h, r);
    ctx.stroke();
    ctx.setLineDash([]);

    // Label
    if (this.opts.showLabels) {
      ctx.globalAlpha = Math.min(1, alpha * 1.4);
      this._drawZoneLabel(zone, colors, isHovered);
    }
  }

  _drawZoneLabel(zone, colors, isHovered) {
    const ctx = this.ctx;
    const { x, y, w, h } = zone.bbox;
    const cx = x + w / 2;
    const cy = y + h / 2;

    const isMobile = this.W < 480;
    ctx.font = isMobile ? this.opts.labelFontMobile : this.opts.labelFont;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    const nameLine  = zone.label;
    const scoreLine = this.opts.showScoreInLabel
      ? `${zone.score}/100 — ${FaceHeatmapRenderer.scoreToBadge(zone.score)}`
      : FaceHeatmapRenderer.scoreToBadge(zone.score);

    const lineH = isMobile ? 13 : 15;
    const totalH = lineH * 2 + 4;
    const startY = cy - totalH / 2 + lineH / 2;

    // Fond pastille pour lisibilité
    const padding = isMobile ? 5 : 7;
    const maxTextW = Math.max(
      ctx.measureText(nameLine).width,
      ctx.measureText(scoreLine).width
    ) + padding * 2;

    const bgX = cx - maxTextW / 2;
    const bgY = startY - lineH / 2 - 2;
    const bgW = maxTextW;
    const bgH = totalH + 4;

    ctx.fillStyle = 'rgba(15, 10, 5, 0.62)';
    this._roundRect(bgX, bgY, bgW, bgH, 5);
    ctx.fill();

    // Zone name
    ctx.fillStyle = '#F5EFE0';
    ctx.fillText(nameLine, cx, startY);

    // Score line
    ctx.fillStyle = colors.label;
    ctx.font = isMobile ? '600 8px "Inter", sans-serif' : '600 10px "Inter", sans-serif';
    ctx.fillText(scoreLine, cx, startY + lineH + 4);
  }

  // ── Tooltip au hover ──────────────────────────────────────────────────────
  /**
   * Attacher les events hover sur le canvas overlay.
   * Appeler après avoir placé le canvas dans le DOM.
   * @param {Function} onZoneHover - callback (zoneKey, zoneData | null)
   */
  attachHoverEvents(onZoneHover) {
    const handler = (e) => {
      const rect = this.canvas.getBoundingClientRect();
      const scaleX = this.W / rect.width;
      const scaleY = this.H / rect.height;
      const mx = (e.clientX - rect.left) * scaleX;
      const my = (e.clientY - rect.top)  * scaleY;

      let found = null;
      Object.entries(this.zoneData).forEach(([key, zone]) => {
        const { x, y, w, h } = zone.bbox;
        if (mx >= x && mx <= x + w && my >= y && my <= y + h) {
          found = key;
        }
      });

      if (found !== this._hoveredZone) {
        this._hoveredZone = found;
        this._renderFrame(1.0);
        if (onZoneHover) onZoneHover(found, found ? this.zoneData[found] : null);
      }
    };

    this.canvas.addEventListener('mousemove', handler);
    this.canvas.addEventListener('touchmove', (e) => {
      e.preventDefault();
      handler(e.touches[0]);
    }, { passive: false });
    this.canvas.addEventListener('mouseleave', () => {
      this._hoveredZone = null;
      this._renderFrame(1.0);
      if (onZoneHover) onZoneHover(null, null);
    });
  }

  // ── Utilitaire roundRect compatible tous navigateurs ─────────────────────
  _roundRect(x, y, w, h, r) {
    const ctx = this.ctx;
    const rc = Math.min(r, w / 2, h / 2);
    ctx.beginPath();
    ctx.moveTo(x + rc, y);
    ctx.lineTo(x + w - rc, y);
    ctx.quadraticCurveTo(x + w, y, x + w, y + rc);
    ctx.lineTo(x + w, y + h - rc);
    ctx.quadraticCurveTo(x + w, y + h, x + w - rc, y + h);
    ctx.lineTo(x + rc, y + h);
    ctx.quadraticCurveTo(x, y + h, x, y + h - rc);
    ctx.lineTo(x, y + rc);
    ctx.quadraticCurveTo(x, y, x + rc, y);
    ctx.closePath();
  }

  destroy() {
    if (this._rafId) cancelAnimationFrame(this._rafId);
  }
}

// ─── COMPOSANT HTML COMPLET ───────────────────────────────────────────────────
/**
 * buildHeatmapComponent
 * Génère le HTML du composant cartographie et l'insère dans le DOM.
 * À appeler dans initResultsStep() AVANT les CTAs produits.
 *
 * @param {string} containerId         - ID de l'élément parent
 * @param {string} capturedImageDataUrl - Data URL de la photo capturée
 * @param {Object} zoneData            - retour analyzeAllZones()
 * @returns {HTMLElement}              - le composant inséré
 */
function buildHeatmapComponent(containerId, capturedImageDataUrl, zoneData) {
  const parent = document.getElementById(containerId);
  if (!parent) return null;

  // ── Structure HTML ───────────────────────────────────────────────────────
  const wrapper = document.createElement('div');
  wrapper.className = 'nl-heatmap-wrapper';
  wrapper.innerHTML = `
    <div class="nl-heatmap-header">
      <span class="nl-heatmap-badge">CARTOGRAPHIE CUTANÉE</span>
      <h3 class="nl-heatmap-title">Analyse zone par zone</h3>
      <p class="nl-heatmap-subtitle">Survolez chaque zone pour le détail</p>
    </div>
    <div class="nl-heatmap-visual">
      <div class="nl-heatmap-canvas-wrap" id="nl-heatmap-canvas-wrap" data-mode="${capturedImageDataUrl ? 'photo' : 'schema'}">
        ${capturedImageDataUrl
          ? `<img class="nl-heatmap-photo" id="nl-heatmap-photo" src="${capturedImageDataUrl}" alt="Votre visage analysé" />`
          : `<svg id="nl-heatmap-photo" class="nl-heatmap-schema" viewBox="0 0 300 380" xmlns="http://www.w3.org/2000/svg">
              <ellipse cx="150" cy="180" rx="110" ry="140" fill="rgba(250,247,242,0.06)" stroke="rgba(201,149,106,0.4)" stroke-width="2"/>
              <ellipse cx="110" cy="145" rx="22" ry="14" fill="none" stroke="rgba(201,149,106,0.35)" stroke-width="1.5"/>
              <ellipse cx="190" cy="145" rx="22" ry="14" fill="none" stroke="rgba(201,149,106,0.35)" stroke-width="1.5"/>
              <path d="M130 200 Q150 218 170 200" fill="none" stroke="rgba(201,149,106,0.35)" stroke-width="1.5"/>
              <line x1="150" y1="160" x2="150" y2="185" stroke="rgba(201,149,106,0.25)" stroke-width="1.5"/>
              <text x="150" y="355" text-anchor="middle" fill="rgba(201,149,106,0.5)" font-size="11" font-family="Inter">Visage schématique</text>
            </svg>`
        }
        <canvas class="nl-heatmap-overlay" id="nl-heatmap-overlay"></canvas>
      </div>
      <div class="nl-heatmap-legend">
        <div class="nl-legend-row">
          <span class="nl-legend-swatch" style="background:rgba(148,196,90,0.65)"></span>
          <span>Excellent (80–100)</span>
        </div>
        <div class="nl-legend-row">
          <span class="nl-legend-swatch" style="background:rgba(201,160,88,0.65)"></span>
          <span>Bon (62–79)</span>
        </div>
        <div class="nl-legend-row">
          <span class="nl-legend-swatch" style="background:rgba(196,126,55,0.65)"></span>
          <span>Attention (42–61)</span>
        </div>
        <div class="nl-legend-row">
          <span class="nl-legend-swatch" style="background:rgba(178,90,72,0.65)"></span>
          <span>À traiter (0–41)</span>
        </div>
      </div>
    </div>
    <div class="nl-heatmap-tooltip" id="nl-heatmap-tooltip" style="display:none">
      <div class="nl-tt-zone" id="nl-tt-zone"></div>
      <div class="nl-tt-score" id="nl-tt-score"></div>
      <div class="nl-tt-metrics" id="nl-tt-metrics"></div>
    </div>
    <div class="nl-heatmap-zones-list" id="nl-heatmap-zones-list"></div>
  `;
  parent.appendChild(wrapper);

  // ── Initialisation canvas après insertion DOM ───────────────────────────
  const photo   = wrapper.querySelector('#nl-heatmap-photo');
  const overlay = wrapper.querySelector('#nl-heatmap-overlay');
  const tooltip = wrapper.querySelector('#nl-heatmap-tooltip');

  function setupOverlay() {
    // Gestion photo réelle vs SVG schématique
    const isPhoto = photo.tagName === 'IMG';
    const w = isPhoto ? (photo.naturalWidth  || photo.offsetWidth  || 300) : 300;
    const h = isPhoto ? (photo.naturalHeight || photo.offsetHeight || 380) : 380;
    overlay.width  = w;
    overlay.height = h;
    overlay.style.width  = '100%';
    overlay.style.height = '100%';

    const renderer = new FaceHeatmapRenderer(overlay, zoneData);
    renderer.draw(true);

    // Hover tooltip
    renderer.attachHoverEvents((zoneKey, data) => {
      if (!data) {
        tooltip.style.display = 'none';
        return;
      }
      wrapper.querySelector('#nl-tt-zone').textContent  = data.label;
      wrapper.querySelector('#nl-tt-score').textContent = `Score : ${data.score}/100 — ${FaceHeatmapRenderer.scoreToBadge(data.score)}`;
      wrapper.querySelector('#nl-tt-metrics').innerHTML = `
        <span>Éclat : ${data.metrics.brightness}%</span>
        <span>Rougeur : ${data.metrics.redness}%</span>
        <span>Texture : ${data.metrics.textureVariance}%</span>
        <span>Uniformité : ${data.metrics.uniformity}%</span>
      `;
      tooltip.style.display = 'block';
    });
  }

  // Photo réelle : attendre le chargement. SVG : setup immédiat (requestAnimationFrame pour layout)
  if (photo.tagName === 'IMG') {
    if (photo.complete && photo.naturalWidth > 0) {
      setupOverlay();
    } else {
      photo.addEventListener('load', setupOverlay);
      photo.addEventListener('error', () => setTimeout(setupOverlay, 100)); // fallback
    }
  } else {
    // SVG ou autre élément — attendre que le DOM soit layout
    requestAnimationFrame(setupOverlay);
  }

  // ── Liste récapitulative des zones ──────────────────────────────────────
  const listEl = wrapper.querySelector('#nl-heatmap-zones-list');
  const sortedZones = Object.values(zoneData).sort((a, b) => a.score - b.score);

  listEl.innerHTML = sortedZones.map(zone => {
    const colors = FaceHeatmapRenderer.scoreToColor(zone.score);
    return `
      <div class="nl-zone-item">
        <div class="nl-zone-dot" style="background:${colors.stroke}"></div>
        <span class="nl-zone-name">${zone.label}</span>
        <div class="nl-zone-bar-wrap">
          <div class="nl-zone-bar" data-target="${zone.score}" style="width:0%;background:${colors.stroke}"></div>
        </div>
        <span class="nl-zone-score">${zone.score}</span>
      </div>
    `;
  }).join('');

  // Animation barres
  requestAnimationFrame(() => {
    wrapper.querySelectorAll('.nl-zone-bar').forEach(bar => {
      bar.style.transition = 'width 1s cubic-bezier(0.4, 0, 0.2, 1)';
      setTimeout(() => { bar.style.width = bar.dataset.target + '%'; }, 100);
    });
  });

  return wrapper;
}

// ─── CSS INTÉGRÉ (peut être externalisé dans nopal-diagnostic.css) ────────────
const HEATMAP_CSS = `
/* ── NOPAL LIFE — Heatmap Component ───────────────────────────── */
.nl-heatmap-wrapper {
  background: linear-gradient(160deg, rgba(30,22,14,0.95) 0%, rgba(15,10,5,0.98) 100%);
  border: 1px solid rgba(200,169,110,0.25);
  border-radius: 20px;
  padding: 28px 24px 24px;
  margin: 32px 0;
}

.nl-heatmap-header { text-align: center; margin-bottom: 20px; }

.nl-heatmap-badge {
  display: inline-block;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.22em;
  color: #7A5A18; /* or soutenu — wrapper heatmap forcé blanc par le CSS */
  border: 1px solid rgba(200,169,110,0.35);
  border-radius: 3px;
  padding: 3px 10px;
  margin-bottom: 10px;
}

.nl-heatmap-title {
  font-size: 19px;
  font-weight: 600;
  color: #2A1A0F; /* marron très sombre — était #20392E (vert foncé) */
  margin: 0 0 6px;
}

.nl-heatmap-subtitle {
  font-size: 13px;
  color: #3A2A1A; /* marron-gris foncé — était #4A4A42 (gris-vert) */
  margin: 0;
}

.nl-heatmap-visual {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 20px;
  align-items: start;
}

@media (max-width: 560px) {
  .nl-heatmap-visual { grid-template-columns: 1fr; }
}

.nl-heatmap-canvas-wrap {
  position: relative;
  border-radius: 14px;
  overflow: hidden;
  background: #0a0705;
  /* Cartographie du visage agrandie ~+50% (360 -> 540). width:100% du track grille
     => clampe a la largeur dispo, jamais de debordement (desktop pousse a 540 via
     l'override @media >=1100px dans styles.css). */
  width: 100%;
  max-width: 540px;
  margin: 0 auto;
}

.nl-heatmap-photo {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 14px;
  filter: brightness(0.92) contrast(1.04);
}

.nl-heatmap-overlay {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  cursor: crosshair;
  border-radius: 14px;
}

/* Légende */
.nl-heatmap-legend {
  display: flex;
  flex-direction: column;
  gap: 9px;
  padding: 12px 0;
  min-width: 130px;
}

@media (max-width: 560px) {
  .nl-heatmap-legend {
    flex-direction: row;
    flex-wrap: wrap;
    min-width: unset;
    gap: 8px 16px;
  }
}

.nl-legend-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #3A2A1A; /* marron-gris foncé — était #4A4A42 (gris-vert) */
}

.nl-legend-swatch {
  width: 12px; height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* Tooltip */
.nl-heatmap-tooltip {
  background: rgba(20,14,8,0.92);
  border: 1px solid rgba(200,169,110,0.30);
  border-radius: 10px;
  padding: 12px 16px;
  margin-top: 14px;
  backdrop-filter: blur(8px);
}

.nl-tt-zone {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #C8A96E;
  margin-bottom: 4px;
}

.nl-tt-score {
  font-size: 13px;
  color: #F5EFE0;
  margin-bottom: 10px;
}

.nl-tt-metrics {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.nl-tt-metrics span {
  font-size: 10px;
  color: rgba(245,239,224,0.55);
  background: rgba(245,239,224,0.06);
  border-radius: 4px;
  padding: 3px 7px;
}

/* Liste zones */
.nl-heatmap-zones-list {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.nl-zone-item {
  display: grid;
  grid-template-columns: 10px 110px 1fr 28px;
  align-items: center;
  gap: 8px;
}

.nl-zone-dot {
  width: 8px; height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.nl-zone-name {
  font-size: 13px;
  color: #2A1A0F; /* marron très sombre — était #2E4034 (vert foncé doux) */
  white-space: nowrap;
}

.nl-zone-bar-wrap {
  background: rgba(245,239,224,0.07);
  border-radius: 3px;
  height: 5px;
  overflow: hidden;
}

.nl-zone-bar {
  height: 100%;
  border-radius: 3px;
}

.nl-zone-score {
  font-size: 13px;
  font-weight: 700;
  color: #2A1A0F; /* marron très sombre — était #2E4034 (vert foncé doux) */
  text-align: right;
}
`;

// Injecter le CSS une seule fois
function injectHeatmapStyles() {
  if (document.getElementById('nl-heatmap-styles')) return;
  const style = document.createElement('style');
  style.id = 'nl-heatmap-styles';
  style.textContent = HEATMAP_CSS;
  document.head.appendChild(style);
}



// ──────────── js/radar-premium.js ────────────
/**
 * NOPAL LIFE — Radar Chart Premium
 * ────────────────────────────────────────────────────────────────────────────
 * Remplace le radar Canvas natif 5 dimensions de app.js par un radar
 * Chart.js complet 8 dimensions, premium, animé, avec tooltips.
 *
 * IMPORTANT : Les scores entrant de scoring.js sont en "problème"
 * (100 = grave). Ce module les INVERSE → radar "positif" (100 = parfait).
 *
 * Dépendances :
 *   <script src="https://cdn.jsdelivr.net/npm/chart.js@4.4.4/dist/chart.umd.min.js"></script>
 *
 * Usage dans app.js :
 *   import { drawRadarPremium } from './radar-premium.js';
 *   // Remplacer drawRadarChart(profile.scores) par :
 *   drawRadarPremium('radar-canvas', profile.scores);
 */

// ─── CONFIGURATION DES 8 DIMENSIONS ──────────────────────────────────────────
// Ordre optimisé pour la lisibilité du radar (répartition visuelle équilibrée)
const RADAR_DIMENSIONS = [
  { key: 'rides',        label: 'Rides\n& ridules',    shortLabel: 'Rides'      },
  { key: 'contour_yeux', label: 'Contour\ndes yeux',   shortLabel: 'Yeux'       },
  { key: 'relachement',  label: 'Fermeté',              shortLabel: 'Fermeté'    },
  { key: 'eclat',        label: 'Éclat',                shortLabel: 'Éclat'      },
  { key: 'secheresse',   label: 'Hydratation',          shortLabel: 'Hydrat.'    },
  { key: 'taches',       label: 'Uniformité\ndu teint', shortLabel: 'Uniformité' },
  { key: 'pores',        label: 'Pores\n& texture',     shortLabel: 'Texture'    },
  { key: 'sensibilite',  label: 'Sérénité',             shortLabel: 'Sérénité'   }
];

/**
 * Inversion des scores : problème → bien-être
 * Dimensions "éclat" et "secheresse" dans scoring.js sont déjà orientés
 * positivement ou négativement selon la logique métier — on harmonise tout.
 *
 * Règle :
 * - rides, relachement, taches, sensibilite, pores, contour_yeux : 100=problème → inverser
 * - eclat : déjà 100=bien (lumineux) → conserver
 * - secheresse : 100=peau très sèche → inverser (100 inversé = très hydraté)
 *
 * @param {Object} scores - scores bruts scoring.js
 * @returns {number[]}    - tableau de 8 valeurs 0-100 positives, dans l'ordre RADAR_DIMENSIONS
 */
function invertScoresForRadar(scores) {
  const POSITIVE_DIMS = new Set(['eclat']); // seules dimensions déjà positives

  return RADAR_DIMENSIONS.map(dim => {
    const raw = scores[dim.key] ?? 50;
    const val = POSITIVE_DIMS.has(dim.key) ? raw : 100 - raw;
    return Math.max(0, Math.min(100, Math.round(val)));
  });
}

// ─── PLUGIN GRADIENT FILL ────────────────────────────────────────────────────
// Plugin Chart.js inline pour le remplissage gradient or/crème du radar
const gradientFillPlugin = {
  id: 'nopalRadarGradient',
  beforeDraw(chart) {
    if (chart.config.type !== 'radar') return;
    // Le gradient backgroundColor est recalculé à chaque draw via la fonction
    // NE PAS appeler chart.update() ici — boucle infinie garantie
    // Le gradient sera recréé automatiquement si le canvas est redimensionné
  }
};

// ─── PLUGIN POINTS COLORÉS PAR SCORE ─────────────────────────────────────────
// Colore chaque point du radar selon son niveau
const coloredPointsPlugin = {
  id: 'nopalColoredPoints',
  afterDatasetsDraw(chart) {
    if (chart.config.type !== 'radar') return;
    const ctx = chart.ctx;
    const meta = chart.getDatasetMeta(0);
    const data = chart.data.datasets[0].data;
    const POINT_R = 5;

    meta.data.forEach((point, i) => {
      const val = data[i];
      let color;
      if      (val >= 80) color = '#94C45A';  // excellent — vert doux
      else if (val >= 62) color = '#C9A058';  // bon — or NOPAL
      else if (val >= 42) color = '#C47E37';  // attention — ambre
      else                color = '#B25A48';  // à traiter — brique rosée

      // Halo extérieur
      ctx.beginPath();
      ctx.arc(point.x, point.y, POINT_R + 3, 0, Math.PI * 2);
      ctx.fillStyle = color.replace(')', ', 0.20)').replace('rgb', 'rgba').replace('#', '');
      // Utiliser la fonction hexToRgba pour la conversion
      ctx.fillStyle = hexToRgba(color, 0.22);
      ctx.fill();

      // Point principal
      ctx.beginPath();
      ctx.arc(point.x, point.y, POINT_R, 0, Math.PI * 2);
      ctx.fillStyle = color;
      ctx.fill();

      // Liseré blanc
      ctx.beginPath();
      ctx.arc(point.x, point.y, POINT_R, 0, Math.PI * 2);
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.40)';
      ctx.lineWidth = 1;
      ctx.stroke();
    });
  }
};

function hexToRgba(hex, alpha) {
  const n = parseInt(hex.replace('#', ''), 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
}

// ─── PLUGIN SCORE LABELS AU-DESSUS DES POINTS ────────────────────────────────
const scoreLabelPlugin = {
  id: 'nopalScoreLabels',
  afterDatasetsDraw(chart) {
    if (chart.config.type !== 'radar') return;
    const ctx   = chart.ctx;
    const meta  = chart.getDatasetMeta(0);
    const data  = chart.data.datasets[0].data;
    const isMob = chart.width < 400;
    const fSize = isMob ? 9 : 10;

    ctx.font         = `700 ${fSize}px "Inter", sans-serif`;
    ctx.textAlign    = 'center';
    ctx.textBaseline = 'middle';

    meta.data.forEach((point, i) => {
      const val = data[i];
      // Décaler le label vers l'extérieur depuis le centre
      const cx = chart.scales.r.xCenter;
      const cy = chart.scales.r.yCenter;
      const dx = point.x - cx;
      const dy = point.y - cy;
      const len = Math.sqrt(dx * dx + dy * dy) || 1;
      const offset = isMob ? 14 : 16;
      const lx = point.x + (dx / len) * offset;
      const ly = point.y + (dy / len) * offset;

      // Fond pastille
      const tw = ctx.measureText(`${val}`).width + 6;
      ctx.fillStyle = 'rgba(15, 10, 5, 0.70)';
      ctx.beginPath();
      ctx.roundRect ? ctx.roundRect(lx - tw / 2, ly - 8, tw, 15, 4) : ctx.rect(lx - tw / 2, ly - 8, tw, 15);
      ctx.fill();

      // Texte score
      ctx.fillStyle = val >= 80 ? '#94C45A' : val >= 62 ? '#C9A058' : val >= 42 ? '#C47E37' : '#B25A48';
      ctx.fillText(`${val}`, lx, ly + 0.5);
    });
  }
};

// ─── PLUGIN LIGNE D'AXE PERSONNALISÉE ────────────────────────────────────────
// Remplace les axes gris par défaut par des lignes or très légères
const customAxesPlugin = {
  id: 'nopalCustomAxes',
  beforeDatasetsDraw(chart) {
    if (chart.config.type !== 'radar') return;
    const ctx   = chart.ctx;
    const scale = chart.scales.r;
    const cx    = scale.xCenter;
    const cy    = scale.yCenter;
    const N     = chart.data.labels.length;

    // Rédessinons les grilles en or très léger
    ctx.save();
    for (let lvl = 1; lvl <= 5; lvl++) {
      const r = (scale.drawingArea * lvl) / 5;
      ctx.beginPath();
      for (let i = 0; i < N; i++) {
        const angle = (i / N) * 2 * Math.PI - Math.PI / 2;
        const x = cx + r * Math.cos(angle);
        const y = cy + r * Math.sin(angle);
        i === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
      }
      ctx.closePath();
      ctx.strokeStyle = lvl === 5
        ? 'rgba(200,169,110,0.22)'
        : 'rgba(200,169,110,0.10)';
      ctx.lineWidth = 0.8;
      ctx.stroke();
    }
    ctx.restore();
  }
};

// ─── FONCTION PRINCIPALE : drawRadarPremium ───────────────────────────────────
/**
 * Crée ou met à jour le radar chart premium sur le canvas cible.
 * Remplace directement l'ancienne fonction drawRadarChart(scores) de app.js.
 *
 * @param {string} canvasId   - ID du <canvas> HTML
 * @param {Object} rawScores  - scores bruts scoring.js (0-100, 100=problème)
 * @param {Object} [opts]     - overrides optionnels
 * @returns {Chart}           - instance Chart.js
 */
function drawRadarPremium(canvasId, rawScores, opts = {}) {
  const canvas = document.getElementById(canvasId);
  if (!canvas) {
    console.warn(`[Nopal Radar] Canvas #${canvasId} introuvable`);
    return null;
  }

  // Détruire l'instance précédente si elle existe
  const existingChart = Chart.getChart(canvas);
  if (existingChart) existingChart.destroy();

  const ctx = canvas.getContext('2d');
  const isMobile = canvas.offsetWidth < 420;
  const dpr = window.devicePixelRatio || 1;
  // Radar agrandi ~+50% (caps 340->510 mobile, 480->720 desktop). La taille reste
  // bornee par la largeur reelle du conteneur (offsetWidth) -> jamais de debordement.
  const size = isMobile ? Math.min(canvas.offsetWidth, 510) : Math.min(canvas.offsetWidth, 720);

  canvas.width  = size * dpr;
  canvas.height = size * dpr;
  canvas.style.width  = `${size}px`;
  canvas.style.height = `${size}px`;
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

  // Inverser les scores pour le rendu positif
  const positiveData = invertScoresForRadar(rawScores);

  // Gradient de remplissage or → crème
  const gradient = ctx.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size * 0.42);
  gradient.addColorStop(0,   'rgba(212, 185, 118, 0.28)');
  gradient.addColorStop(0.5, 'rgba(201, 160, 88,  0.20)');
  gradient.addColorStop(1,   'rgba(245, 239, 224, 0.08)');

  // Labels multiligne (Chart.js 4 supporte les tableaux de strings)
  const labels = RADAR_DIMENSIONS.map(d =>
    isMobile ? [d.shortLabel] : d.label.split('\n')
  );

  const chartConfig = {
    type: 'radar',
    data: {
      labels,
      datasets: [{
        label: 'Votre peau',
        data: positiveData,
        // Remplissage gradient
        backgroundColor: gradient,
        // Contour principal
        borderColor: '#C9A058',
        borderWidth: 2,
        // Points — désactivés ici car gérés par coloredPointsPlugin
        pointRadius: 0,
        pointHoverRadius: 0,
        // Remplissage lissé
        tension: 0.25
      }]
    },
    plugins: [gradientFillPlugin, coloredPointsPlugin, scoreLabelPlugin, customAxesPlugin],
    options: {
      responsive: false,
      animation: {
        duration: opts.animationMs ?? 1100,
        delay: opts.animationDelay ?? 150,
        easing: 'easeInOutQuart',
        // Animation "draw from center" : les valeurs partent de 0 → final
        onProgress: null
      },
      layout: {
        padding: isMobile ? 28 : 36
      },
      scales: {
        r: {
          min: 0,
          max: 100,
          grid: {
            display: false
          },
          angleLines: {
            display: true,
            color: 'rgba(200, 169, 110, 0.15)',
            lineWidth: 0.8
          },
          ticks: {
            display: false,
            stepSize: 20
          },
          pointLabels: {
            display: true,
            font: (ctx) => ({
              family: '"Playfair Display", "Inter", sans-serif',
              size: isMobile ? 9 : 11,
              style: 'italic',
              weight: '500'
            }),
            color: '#2A1A0F',
            padding: isMobile ? 6 : 10,
            callback: (label) => label
          }
        }
      },
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          enabled: true,
          backgroundColor: 'rgba(15, 10, 5, 0.88)',
          borderColor: 'rgba(200, 169, 110, 0.35)',
          borderWidth: 1,
          titleColor: '#C9A058',
          bodyColor: '#F5EFE0',
          padding: { x: 14, y: 10 },
          cornerRadius: 10,
          callbacks: {
            title(items) {
              const idx   = items[0]?.dataIndex ?? 0;
              const label = RADAR_DIMENSIONS[idx]?.label.replace('\n', ' ') || '';
              return label;
            },
            label(item) {
              const val    = item.raw;
              const badge  = val >= 80 ? 'Excellent' : val >= 62 ? 'Bon' : val >= 42 ? 'Attention' : 'À traiter';
              return `Score : ${val}/100 — ${badge}`;
            },
            labelColor(item) {
              const val   = item.raw;
              const color = val >= 80 ? '#94C45A' : val >= 62 ? '#C9A058' : val >= 42 ? '#C47E37' : '#B25A48';
              return { backgroundColor: color, borderColor: color, borderRadius: 3 };
            }
          }
        }
      }
    }
  };

  return new Chart(ctx, chartConfig);
}

// ─── ANIMATION "DRAW FROM CENTER" personnalisée ──────────────────────────────
// Chart.js 4 n'a pas de mode "dessin radial depuis le centre" natif.
// On l'obtient en interpolant les data de 0 → cibles sur la durée de l'animation.
function drawRadarWithEntryAnimation(canvasId, rawScores, opts = {}) {
  const canvas = document.getElementById(canvasId);
  if (!canvas || typeof Chart === 'undefined') {
    return drawRadarPremium(canvasId, rawScores, opts);
  }

  const targets  = invertScoresForRadar(rawScores);
  const zeros    = targets.map(() => 0);
  const duration = opts.animationMs ?? 1100;
  const startMs  = performance.now();

  // Créer d'abord avec valeurs 0
  const fakeScores = Object.fromEntries(
    RADAR_DIMENSIONS.map((d, i) => [d.key, 0])
  );
  const chart = drawRadarPremium(canvasId, fakeScores, { ...opts, animationMs: 0 });
  if (!chart) return null;

  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

  function tick() {
    const elapsed  = performance.now() - startMs;
    const progress = Math.min(1, elapsed / duration);
    const eased    = easeOutCubic(progress);

    chart.data.datasets[0].data = targets.map(v => Math.round(v * eased));
    chart.update('none');   // 'none' = pas d'animation Chart.js (on gère manuellement)

    if (progress < 1) {
      requestAnimationFrame(tick);
    } else {
      // Animation terminée — stopper Chart.js pour libérer le GPU
      chart.stop();
      chart.update('none'); // Rendu final stable
    }
  }

  requestAnimationFrame(tick);
  return chart;
}

// ─── COMPOSANT WRAPPER COMPLET (HTML + Chart) ─────────────────────────────────
/**
 * buildRadarComponent
 * Crée le wrapper HTML du radar et instancie le chart.
 * À appeler dans initResultsStep() à la place du canvas seul.
 *
 * @param {string} containerId  - ID du conteneur parent
 * @param {Object} rawScores    - scores bruts de buildFinalProfile().scores
 * @param {Object} profile      - profil complet (pour le titre personnalisé)
 * @returns {Chart}             - instance Chart.js
 */
function buildRadarComponent(containerId, rawScores, profile = {}) {
  const parent = document.getElementById(containerId);
  if (!parent) return null;

  // Calculer les 2 points forts et la zone à travailler
  const inverted = invertScoresForRadar(rawScores);
  const withLabels = RADAR_DIMENSIONS.map((d, i) => ({ ...d, val: inverted[i] }));
  const sorted = [...withLabels].sort((a, b) => b.val - a.val);
  const top2   = sorted.slice(0, 2).map(d => d.label.replace('\n', ' '));
  const bottom1 = sorted[sorted.length - 1];

  parent.innerHTML = `
    <div class="nl-radar-wrapper">
      <div class="nl-radar-header">
        <span class="nl-radar-badge">PROFIL CUTANÉ 8 DIMENSIONS</span>
        <h3 class="nl-radar-title">Votre empreinte peau</h3>
        <p class="nl-radar-subtitle">
          Forces : <strong>${top2.join(' · ')}</strong>
          &nbsp;·&nbsp;
          Priorité : <strong>${bottom1.label.replace('\n', ' ')}</strong>
        </p>
      </div>
      <div class="nl-radar-canvas-wrap">
        <canvas id="radar-canvas-premium"></canvas>
      </div>
      <div class="nl-radar-legend">
        ${RADAR_DIMENSIONS.map((d, i) => {
          const val  = inverted[i];
          const col  = val >= 80 ? '#94C45A' : val >= 62 ? '#C9A058' : val >= 42 ? '#C47E37' : '#B25A48';
          const badge = val >= 80 ? 'Excellent' : val >= 62 ? 'Bon' : val >= 42 ? 'Attention' : 'À traiter';
          return `
            <div class="nl-radar-legend-item">
              <span class="nl-radar-legend-label">${d.shortLabel}</span>
              <div class="nl-radar-legend-bar-wrap">
                <div class="nl-radar-legend-bar" data-val="${val}" style="width:0%;background:${col}"></div>
              </div>
              <span class="nl-radar-legend-val" style="color:${col}">${val}</span>
            </div>
          `;
        }).join('')}
      </div>
    </div>
  `;

  // Injecter CSS
  injectRadarStyles();

  // Attendre le prochain frame pour s'assurer que le canvas est dans le DOM
  requestAnimationFrame(() => {
    // Animer les barres légende
    parent.querySelectorAll('.nl-radar-legend-bar').forEach(bar => {
      bar.style.transition = 'width 1.1s cubic-bezier(0.4, 0, 0.2, 1)';
      setTimeout(() => { bar.style.width = bar.dataset.val + '%'; }, 200);
    });
  });

  // Créer le radar
  const chart = drawRadarWithEntryAnimation('radar-canvas-premium', rawScores);
  return chart;
}

// ─── CSS DU COMPOSANT RADAR ───────────────────────────────────────────────────
const RADAR_CSS = `
/* ── NOPAL LIFE — Radar Premium ────────────────────────────────── */
.nl-radar-wrapper {
  background: linear-gradient(160deg, rgba(30,22,14,0.95) 0%, rgba(15,10,5,0.98) 100%);
  border: 1px solid rgba(200,169,110,0.25);
  border-radius: 20px;
  padding: 28px 24px 24px;
  margin: 32px 0;
}

.nl-radar-header { text-align: center; margin-bottom: 18px; }

.nl-radar-badge {
  display: inline-block;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.22em;
  color: #7A5A18; /* or soutenu — lisible sur fond blanc (wrapper forcé blanc par le CSS) */
  border: 1px solid rgba(200,169,110,0.35);
  border-radius: 3px;
  padding: 3px 10px;
  margin-bottom: 10px;
}

.nl-radar-title {
  font-size: 19px;
  font-weight: 600;
  color: #2A1A0F; /* marron très sombre — était #20392E (vert foncé) */
  margin: 0 0 6px;
  font-family: "Playfair Display", serif;
  font-style: italic;
}

.nl-radar-subtitle {
  font-size: 13px;
  color: #3A2A1A; /* marron-gris foncé — était #4A4A42 (gris-vert) */
  margin: 0;
}

.nl-radar-subtitle strong { color: #2A1A0F; font-weight: 600; }

.nl-radar-canvas-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 0 16px;
}

#radar-canvas-premium {
  max-width: 100%;
  height: auto !important;
}

/* Légende barres */
.nl-radar-legend {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 16px;
}

@media (max-width: 380px) {
  .nl-radar-legend { grid-template-columns: 1fr; }
}

.nl-radar-legend-item {
  display: grid;
  grid-template-columns: 68px 1fr 26px;
  align-items: center;
  gap: 6px;
}

.nl-radar-legend-label {
  font-size: 13px;
  color: #3A2A1A; /* marron-gris foncé — était #4A4A42 (gris-vert) */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nl-radar-legend-bar-wrap {
  background: rgba(245,239,224,0.07);
  border-radius: 3px;
  height: 4px;
  overflow: hidden;
}

.nl-radar-legend-bar { height: 100%; border-radius: 3px; }

.nl-radar-legend-val {
  font-size: 13px;
  font-weight: 700;
  text-align: right;
}
`;

function injectRadarStyles() {
  if (document.getElementById('nl-radar-styles')) return;
  const style = document.createElement('style');
  style.id = 'nl-radar-styles';
  style.textContent = RADAR_CSS;
  document.head.appendChild(style);
}

// ─── GUIDE D'INTÉGRATION ──────────────────────────────────────────────────────
/*
 * Dans app.js, remplacer la fonction drawRadarChart(scores) existante :
 *
 *   AVANT (app.js ligne ~468) :
 *   ─────────────────────────
 *   drawRadarChart(profile.scores);
 *
 *   APRÈS :
 *   ──────
 *   // Dans initResultsStep(), remplacer l'appel drawRadarChart par :
 *   buildRadarComponent('results-radar-container', profile.scores, profile);
 *
 *   Et dans le HTML des résultats, ajouter le conteneur :
 *   <div id="results-radar-container"></div>
 *   (à la place du <canvas id="radar-canvas"> existant)
 *
 * Ajouter Chart.js dans le HTML avant le bundle :
 *   <script src="https://cdn.jsdelivr.net/npm/chart.js@4.4.4/dist/chart.umd.min.js"></script>
 *
 * Ou via import ESM (si bundler) :
 *   import Chart from 'chart.js/auto';
 *   window.Chart = Chart;
 */



// ──────────── js/integrations.js ────────────
/**
 * NOPAL LIFE SKIN INTELLIGENCE™ — Module Intégrations
 * EmailJS · Klaviyo (Airtable supprimé — données stockées dans Klaviyo)
 */

const CONFIG = {
  // ── EmailJS ─────────────────────────────────────────────────────────
  emailjs: {
    publicKey:    '-V0MkeVcNXp5fiE0Z',   // ✅
    serviceId:    'service_qf4vbky',     // ✅
    templateId:   'cq3hmgq',             // ✅
  },

  // ── Klaviyo (remplace Airtable — clé publique, sûre côté client) ─────
  klaviyo: {
    publicApiKey: 'ULwGjD',   // ✅ Nopal Life
    listId:       'RP63XG',   // ✅ Diagnostic Skin Intelligence
  },

  // ── Site ─────────────────────────────────────────────────────────────
  site: {
    url:        'https://nopal-life.com',
    diagnostic: 'https://nopal-life.com/pages/diagnostic',
  }
};

// ════════════════════════════════════════════════════════════════════════
// MODULE 1 — EMAIL RÉSULTATS (EmailJS)
// ════════════════════════════════════════════════════════════════════════

const EmailService = {

  _loaded: false,

  /** Charge EmailJS depuis CDN (une seule fois) */
  async init() {
    if (this._loaded) return;
    await new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = 'https://cdn.jsdelivr.net/npm/@emailjs/browser@4/dist/email.min.js';
      s.onload = () => { emailjs.init(CONFIG.emailjs.publicKey); this._loaded = true; resolve(); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
  },

  /**
   * Envoie les résultats du diagnostic par email
   * @param {Object} profile - Profil cutané calculé
   * @param {Object} userData - { firstName, email }
   * @param {Array}  topProducts - Top 4 produits recommandés
   */
  async sendResults(profile, userData, topProducts) {
    // Guard C10 : ne pas envoyer si email fictif (continuer sans données)
    if (!userData.email || userData.email.startsWith('anonyme@') || userData.email === '') {
      console.log('[EmailService] Email fictif ignoré — pas d\'envoi');
      return { success: true, skipped: true };
    }

    try {
      await this.init();

      // Score global moyen
      const scores = profile.scores || {};
      const scoreValues = Object.values(scores).filter(v => typeof v === 'number');
      const globalScore = scoreValues.length
        ? Math.round(scoreValues.reduce((a, b) => a + b, 0) / scoreValues.length)
        : 50;

      const params = {
        // ── Variables attendues par le template EmailJS ──────────────────
        first_name:    userData.firstName || 'Cliente',   // {{first_name}}
        to_email:      userData.email,                    // {{to_email}}
        skin_type:     this._labelSkinType(profile.skinType),  // {{skin_type}}
        skin_age:      profile.skinAge || '',              // {{skin_age}}
        global_score:  globalScore,                        // {{global_score}}
        top_concern:   this._labelDimension(profile.topConcerns && profile.topConcerns[0]), // {{top_concern}}
        diagnostic_url: CONFIG.site.diagnostic,            // {{diagnostic_url}}

        // ── Données complémentaires (utilisables si template étendu) ────
        from_name:     'Nopal Life',
        reply_to:      'contact@nopal-life.com',
        chrono_age:    profile.chronoAge || '',
        age_delta:     profile.ageDelta > 0 ? `+${profile.ageDelta}` : `${profile.ageDelta || 0}`,
        top_concern_2: this._labelDimension(profile.topConcerns && profile.topConcerns[1]),
        top_concern_3: this._labelDimension(profile.topConcerns && profile.topConcerns[2]),
        diagnostic_text: profile.diagnosticText || '',
        product_1_name:  (topProducts && topProducts[0]) ? (topProducts[0].shortName || topProducts[0].name) : '',
        product_2_name:  (topProducts && topProducts[1]) ? (topProducts[1].shortName || topProducts[1].name) : '',
        product_3_name:  (topProducts && topProducts[2]) ? (topProducts[2].shortName || topProducts[2].name) : '',
        shop_url:        `${CONFIG.site.url}/collections/soins-de-visage-naturels`,
        j30_url:         `${CONFIG.site.diagnostic}?retour=j30&email=${encodeURIComponent(userData.email || '')}`,
        date: new Date().toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }),
      };

      const result = await emailjs.send(CONFIG.emailjs.serviceId, CONFIG.emailjs.templateId, params);
      console.log('[EmailService] Email envoyé :', result.text);
      return { success: true };

    } catch (err) {
      console.warn('[EmailService] Échec envoi email :', err);
      return { success: false, error: err };
    }
  },

  _labelSkinType(type) {
    const labels = {
      // Nouvelles options Q1 (6 routines)
      peau_mature:      'Peau mature',
      peau_seche:       'Peau sèche',
      peau_grasse:      'Peau grasse',
      peau_sensible:    'Peau sensible',
      eclat:            'Éclat',
      peau_deshydratee: 'Peau déshydratée',
      // Compat anciens labels
      seche: 'Sèche', normale: 'Normale', mixte: 'Mixte', grasse: 'Grasse', sensible: 'Sensible'
    };
    return labels[type] || type;
  },

  _labelDimension(dim) {
    const labels = {
      rides: 'Rides & ridules', relachement: 'Fermeté', secheresse: 'Hydratation',
      eclat: 'Éclat', taches: 'Uniformité du teint', sensibilite: 'Sérénité',
      contour_yeux: 'Contour des yeux', pores: 'Pores & texture', peau_mature: 'Âge cutané'
    };
    return labels[dim] || dim;
  }
};


// ════════════════════════════════════════════════════════════════════════
// MODULE 2 — CRM KLAVIYO
// ════════════════════════════════════════════════════════════════════════

const KlaviyoService = {

  _loaded: false,

  /** Retourne true si on est en développement local — Klaviyo doit rester silencieux */
  _isLocalDev() {
    const host = window.location.hostname;
    return host === 'localhost' || host === '127.0.0.1' || host === '' || host.startsWith('192.168.');
  },

  /** Charge le snippet Klaviyo (une seule fois) */
  async init() {
    // Ne jamais charger Klaviyo en développement local (évite la popup newsletter)
    if (this._isLocalDev()) {
      console.log('[Klaviyo] Mode local — script non chargé (popup newsletter désactivée)');
      return;
    }
    if (this._loaded) return;
    if (CONFIG.klaviyo.publicApiKey.includes('<')) return; // pas encore configuré
    await new Promise((resolve) => {
      const s = document.createElement('script');
      s.async = true;
      s.src = `https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${CONFIG.klaviyo.publicApiKey}`;
      s.onload = () => { this._loaded = true; resolve(); };
      s.onerror = () => resolve(); // non bloquant
      document.head.appendChild(s);
    });
  },

  /**
   * Identifie le profil dans Klaviyo avec toutes les propriétés du diagnostic
   */
  async identifyProfile(profile, userData, scanMethod) {
    await this.init();
    if (typeof klaviyo === 'undefined') return;

    // Score global moyen
    const scores = profile.scores || {};
    const scoreVals = Object.values(scores).filter(v => typeof v === 'number');
    const globalScore = scoreVals.length
      ? Math.round(scoreVals.reduce((a, b) => a + b, 0) / scoreVals.length)
      : 50;

    const diagCount = this._getDiagnosticCount(userData.email);

    const properties = {
      // ── Identité ──────────────────────────────────────────────────────
      '$email':           userData.email,
      '$first_name':      userData.firstName,

      // ── Profil cutané (remplace Airtable) ─────────────────────────────
      skin_type:                this._labelSkinType(profile.skinType),
      skin_age:                 profile.skinAge,
      chrono_age:               profile.chronoAge,
      skin_age_delta:           profile.ageDelta,
      hormonal_stage:           profile.hormonalStage || 'non_renseigne',
      age_range:                profile.ageRange,

      // ── Scores 8 dimensions ───────────────────────────────────────────
      score_global:             globalScore,
      score_rides:              scores.rides              || 0,
      score_relachement:        scores.relachement        || 0,
      score_secheresse:         scores.secheresse         || 0,
      score_eclat:              scores.eclat              || 0,
      score_taches:             scores.taches             || 0,
      score_sensibilite:        scores.sensibilite        || 0,
      score_contour_yeux:       scores.contour_yeux       || 0,
      score_pores:              scores.pores              || 0,
      score_peau_mature:        scores.peau_mature        || 0,

      // ── Top préoccupations ────────────────────────────────────────────
      top_concern_1:            (profile.topConcerns || [])[0] || '',
      top_concern_2:            (profile.topConcerns || [])[1] || '',
      top_concern_3:            (profile.topConcerns || [])[2] || '',

      // ── Diagnostic metadata ───────────────────────────────────────────
      scan_visuel:              scanMethod === 'camera' ? 'oui' : 'non',
      stade_diagnostic:         diagCount <= 1 ? 'J0' : diagCount === 2 ? 'J30' : diagCount === 3 ? 'J60' : 'J90',
      diagnostic_count:         diagCount,
      last_diagnostic_date:     new Date().toISOString(),
      diagnostic_text:          profile.diagnosticText || '',
      marketing_consent:        userData.marketingConsent ? 'oui' : 'non',

      // ── Liens suivi ───────────────────────────────────────────────────
      diagnostic_url:           CONFIG.site.diagnostic,
      j30_url:                  `${CONFIG.site.diagnostic}?retour=j30&email=${encodeURIComponent(userData.email || '')}`,
      j60_url:                  `${CONFIG.site.diagnostic}?retour=j60&email=${encodeURIComponent(userData.email || '')}`,
    };

    klaviyo.identify(properties);
    console.log('[Klaviyo] Profil identifié (complet) :', userData.email);
  },

  /**
   * Déclenche l'event "Diagnostic Completed" avec les propriétés complètes
   */
  async trackDiagnosticCompleted(profile, userData, topProducts) {
    await this.init();
    if (typeof klaviyo === 'undefined') return;

    const eventProps = {
      // Profil
      skin_type:       this._labelSkinType(profile.skinType),
      skin_age:        profile.skinAge,
      hormonal_stage:  profile.hormonalStage || 'non_renseigne',
      top_concern:     profile.topConcerns[0] || '',

      // Produits recommandés (pour personnaliser l'email)
      product_1_sku:   topProducts[0]?.id || '',
      product_1_name:  topProducts[0]?.shortName || '',
      product_1_compat: topProducts[0]?.compatibility || 0,
      product_2_sku:   topProducts[1]?.id || '',
      product_2_name:  topProducts[1]?.shortName || '',
      product_3_sku:   topProducts[2]?.id || '',
      product_3_name:  topProducts[2]?.shortName || '',

      // Scores clés
      score_rides:     profile.scores.rides,
      score_firmness:  profile.scores.relachement,
      score_hydration: profile.scores.secheresse,

      // Valeur
      diagnostic_number: this._getDiagnosticCount(userData.email),
      timestamp:         new Date().toISOString(),
    };

    klaviyo.track('Diagnostic Completed', eventProps);
    console.log('[Klaviyo] Event Diagnostic Completed tracké');
  },

  /**
   * Déclenche l'event "J30 Diagnostic" (comparaison avec J0)
   */
  async trackJ30(profile, userData, improvementData) {
    await this.init();
    if (typeof klaviyo === 'undefined') return;

    klaviyo.track('J30 Diagnostic Completed', {
      improvement_rides:       improvementData.rides || 0,
      improvement_firmness:    improvementData.relachement || 0,
      improvement_hydration:   improvementData.secheresse || 0,
      improvement_global:      improvementData.global || 0,
      skin_age_now:            profile.skinAge,
      skin_age_j0:             improvementData.skinAgeJ0 || profile.skinAge,
      skin_age_progress:       (improvementData.skinAgeJ0 || profile.skinAge) - profile.skinAge,
    });
  },

  /**
   * Abonne l'email à la liste Klaviyo (pour les flows)
   */
  async subscribeToList(email, firstName) {
    if (this._isLocalDev()) return; // pas d'abonnement réel en local
    if (CONFIG.klaviyo.publicApiKey.includes('<')) return;
    try {
      await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${CONFIG.klaviyo.publicApiKey}`, {
        method: 'POST',
        headers: { 'content-type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              list_id: CONFIG.klaviyo.listId,
              email: email,
              custom_source: 'Diagnostic Skin Intelligence',
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email, first_name: firstName }
                }
              }
            }
          }
        })
      });
      console.log('[Klaviyo] Abonnement liste OK :', email);
    } catch (err) {
      console.warn('[Klaviyo] Abonnement liste échoué :', err);
    }
  },

  _getDiagnosticCount(email) {
    try {
      const existing = JSON.parse(localStorage.getItem('nopal_diagnostics') || '[]');
      return existing.filter(d => d.email === email).length;
    } catch { return 1; }
  },

  _labelSkinType(type) {
    // C11 : synchronisé avec EmailService (6 nouveaux types + aliases)
    const labels = {
      peau_mature: 'Peau mature', peau_seche: 'Peau sèche', peau_grasse: 'Peau grasse',
      peau_sensible: 'Peau sensible', eclat: 'Éclat', peau_deshydratee: 'Peau déshydratée',
      seche: 'Peau sèche', normale: 'Éclat', mixte: 'Peau grasse',
      grasse: 'Peau grasse', sensible: 'Peau sensible',
    };
    return labels[type] || type;
  }
};


// MODULE 3 — Airtable supprimé. Données stockées dans Klaviyo (clé publique sûre).
// Le suivi J0/J30/J60 est assuré par LongitudinalTracker (localStorage).


// ════════════════════════════════════════════════════════════════════════
// MODULE 4 — SUIVI LONGITUDINAL J0/J30/J60
// ════════════════════════════════════════════════════════════════════════

const LongitudinalTracker = {

  /**
   * Calcule l'amélioration entre deux diagnostics
   * @returns {Object} Pourcentages d'amélioration par dimension + score global
   */
  computeImprovement(currentScores, previousScores) {
    const dimensions = ['rides', 'relachement', 'secheresse', 'eclat', 'taches', 'sensibilite', 'contour_yeux', 'pores', 'peau_mature'];
    const improvements = {};
    let totalImprovement = 0;
    let count = 0;

    dimensions.forEach(dim => {
      const prev = previousScores[dim] || 50;
      const curr = currentScores[dim] || 50;
      // Amélioration = réduction du score problème (score plus bas = mieux pour most dims)
      const delta = prev - curr;
      const pct = prev > 0 ? Math.round((delta / prev) * 100) : 0;
      improvements[dim] = { delta, pct, improved: delta > 0 };
      totalImprovement += delta;
      count++;
    });

    improvements.global = Math.round(totalImprovement / count);
    improvements.globalPct = count > 0 ? Math.round((totalImprovement / (count * 50)) * 100) : 0;

    return improvements;
  },

  /**
   * Détermine si c'est un diagnostic J0, J30 ou J60
   * @returns {string} 'J0' | 'J30' | 'J60' | 'subsequent'
   */
  getDiagnosticStage(email) {
    try {
      const existing = JSON.parse(localStorage.getItem('nopal_diagnostics') || '[]');
      const userDiags = existing.filter(d => d.email === email);
      if (userDiags.length === 0) return 'J0';
      if (userDiags.length === 1) return 'J30';
      if (userDiags.length === 2) return 'J60';
      return 'subsequent';
    } catch { return 'J0'; }
  },

  /**
   * Génère le texte de progression pour l'affichage
   */
  generateProgressText(improvements, stage) {
    const global = improvements.global || 0;
    const emoji = global > 5 ? '🌟' : global > 0 ? '✨' : '💪';

    if (global > 10) {
      return `${emoji} Progression remarquable : votre peau s'est améliorée de ${global} points depuis votre diagnostic ${stage === 'J60' ? 'J0' : 'J30'}.`;
    } else if (global > 0) {
      return `${emoji} Bonne progression : +${global} points d'amélioration. Continuez votre routine !`;
    } else {
      return `💪 Les résultats prennent du temps. Restez fidèle à votre routine Nopal Life.`;
    }
  },

  /**
   * Vérifie si l'URL contient un email de retour (ex: ?retour=j30&email=...)
   * Utilisé pour le retour J30/J60
   */
  /** Récupère le diagnostic J0 depuis localStorage (remplace Airtable) */
  getPreviousDiagnosticLocal(email) {
    try {
      const existing = JSON.parse(localStorage.getItem('nopal_diagnostics') || '[]');
      const prev = existing
        .filter(d => d.email === email)
        .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
      return prev.length > 0 ? prev[0] : null;
    } catch { return null; }
  },

  getReturnParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      isReturn: params.has('retour'),
      stage:    params.get('retour') || 'j0',
      email:    params.get('email') || ''
    };
  }
};


// ════════════════════════════════════════════════════════════════════════
// ORCHESTRATEUR — Appelé après chaque diagnostic complet
// ════════════════════════════════════════════════════════════════════════

/**
 * Point d'entrée unique appelé depuis app.js après calcul du profil
 * Gère toutes les intégrations de manière non-bloquante
 */
async function runPostDiagnosticIntegrations(profile, userData, answers, topProducts, scanMethod = 'questionnaire_only') {
  console.log('[Intégrations] Démarrage post-diagnostic pour :', userData.email);

  // Lancer en parallèle, ne jamais bloquer l'UX
  const tasks = [
    // 1. Email résultats automatique
    EmailService.sendResults(profile, userData, topProducts)
      .then(() => console.log('[Intégrations] ✓ Email envoyé'))
      .catch(e => console.warn('[Intégrations] Email échoué :', e)),

    // 2. Klaviyo — profil complet (remplace Airtable) + event + opt-in marketing
    KlaviyoService.identifyProfile(profile, userData, scanMethod)
      .then(() => KlaviyoService.trackDiagnosticCompleted(profile, userData, topProducts))
      .then(() => {
        if (userData.marketingConsent === true) {
          return KlaviyoService.subscribeToList(userData.email, userData.firstName);
        }
        console.log('[Klaviyo] Abonnement liste ignoré — opt-in marketing non coché');
      })
      .then(() => console.log('[Intégrations] ✓ Klaviyo ok'))
      .catch(e => console.warn('[Intégrations] Klaviyo échoué :', e)),
  ];

  Promise.allSettled(tasks).then(() => {
    console.log('[Intégrations] Toutes intégrations complètes');
  });
}

/**
 * Récupère le diagnostic précédent pour un email donné
 * Utilisé au démarrage du diagnostic retour J30/J60
 */
async function getPreviousDiagnosticForReturn(email) {
  // Airtable supprimé — récupération depuis localStorage via LongitudinalTracker
  return LongitudinalTracker.getPreviousDiagnosticLocal(email);
}



// ──────────── js/services/pdf.js ────────────
/**
 * NOPAL LIFE — SKIN INTELLIGENCE™
 * Service de génération PDF 12 pages — style luxe ivoire / or rosé / brun
 *
 * Usage :
 *   import { generateDiagnosticPDF } from './services/pdf.js';
 *   await generateDiagnosticPDF(profile, products, userData);
 *
 * Dépendances (CDN defer dans index.html) :
 *   jsPDF 2.5.1  → window.jspdf.jsPDF
 *   html2canvas 1.4.1 → window.html2canvas
 */

// ─── PALETTE & TYPOGRAPHIE ────────────────────────────────────────────────────
const C = {
  ivory:     '#FDF8F4',
  gold:      '#C9956A',
  goldLight: '#E8C9A0',
  brown:     '#3D2314',
  brownMid:  '#7A5C42',
  brownLight:'#B08060',
  cream:     '#F0E8DC',
  creamDark: '#D8C8B4',
  white:     '#FFFFFF',
  darkBg:    '#2A1A0E',
  greenSoft: '#5B7A5B',
  redSoft:   '#C06050',
  textMain:  '#3D2314',
  textLight: '#7A5C42',
  border:    'rgba(201,149,106,0.25)',
  borderGold:'rgba(201,149,106,0.6)',
};

// Dimensions score → label français
const DIM_LABELS = {
  rides:        'Rides & ridules',
  relachement:  'Fermeté',
  secheresse:   'Hydratation',
  eclat:        'Éclat',
  taches:       'Uniformité',
  sensibilite:  'Sérénité',
  contour_yeux: 'Contour des yeux',
  pores:        'Pores & texture',
  peau_mature:  'Âge cutané',
};

const DIM_DESCRIPTIONS = {
  rides:        'Profondeur et densité des rides visibles',
  relachement:  'Tonicité et redéfinition du contour facial',
  secheresse:   'Niveau d\'hydratation et confort cutané',
  eclat:        'Luminosité et vivacité du teint',
  taches:       'Uniformité et régularité du teint',
  sensibilite:  'Réactivité et confort de la peau',
  contour_yeux: 'Fraîcheur et jeunesse du regard',
  pores:        'Finesse de grain et texture',
  peau_mature:  'Indice global de maturité cutanée',
};

// ─── UTILITAIRES CSS INLINE ───────────────────────────────────────────────────
const S = {
  page: `
    width:794px; min-height:1123px; background:${C.ivory};
    font-family:'Inter',sans-serif; color:${C.textMain};
    position:relative; overflow:hidden; box-sizing:border-box;
    padding:0;
  `,
  header: (small = false) => `
    background:${C.brown}; padding:${small ? '18px 40px' : '28px 40px'};
    display:flex; align-items:center; justify-content:space-between;
  `,
  body: `padding:36px 40px 32px; flex:1;`,
  footer: `
    background:${C.cream}; border-top:2px solid ${C.borderGold};
    padding:14px 40px; display:flex; align-items:center;
    justify-content:space-between; position:absolute; bottom:0; left:0; right:0;
  `,
  h1: `font-family:'Playfair Display',serif; font-size:28px; font-weight:600; color:${C.gold}; margin:0;`,
  h2: `font-family:'Playfair Display',serif; font-size:20px; font-weight:600; color:${C.brown}; margin:0 0 16px;`,
  h3: `font-family:'Playfair Display',serif; font-size:15px; font-weight:500; color:${C.brownMid}; margin:0 0 10px;`,
  sectionTitle: `
    font-family:'Playfair Display',serif; font-size:17px; font-weight:600;
    color:${C.brown}; border-bottom:2px solid ${C.borderGold};
    padding-bottom:8px; margin:0 0 18px; letter-spacing:0.02em;
  `,
  eyebrow: `
    font-family:'Inter',sans-serif; font-size:10px; font-weight:600;
    letter-spacing:0.18em; text-transform:uppercase; color:${C.goldLight}; margin:0 0 6px;
  `,
  badge: (bg = C.gold) => `
    display:inline-block; background:${bg}; color:${C.ivory};
    font-size:9px; font-weight:700; letter-spacing:0.12em;
    text-transform:uppercase; padding:3px 9px; border-radius:20px;
  `,
  logoMark: `
    width:32px; height:32px; border-radius:50%; background:${C.gold};
    display:flex; align-items:center; justify-content:center;
    font-size:14px; color:${C.ivory}; font-weight:700; flex-shrink:0;
  `,
};

// ─── HELPER : Créer un élément page ───────────────────────────────────────────
function makePage(id) {
  const div = document.createElement('div');
  div.id = id;
  div.style.cssText = S.page;
  return div;
}

// ─── HELPER : En-tête de page ─────────────────────────────────────────────────
function makePageHeader(pageNum, title, small = false) {
  return `
    <div style="${S.header(small)}">
      <div style="display:flex;align-items:center;gap:12px;">
        <div style="${S.logoMark}">✦</div>
        <div>
          <p style="${S.eyebrow}">Nopal Life Skin Intelligence™</p>
          <h1 style="font-family:'Playfair Display',serif;font-size:${small?'14px':'16px'};
                     font-weight:600;color:${C.gold};margin:0;">${title}</h1>
        </div>
      </div>
      <div style="text-align:right;">
        <p style="font-family:'Inter',sans-serif;font-size:11px;color:${C.goldLight};margin:0;">
          Page ${pageNum} / 12
        </p>
      </div>
    </div>
  `;
}

// ─── HELPER : Pied de page ────────────────────────────────────────────────────
function makePageFooter(prenom, date) {
  return `
    <div style="${S.footer}">
      <p style="font-size:10px;color:${C.brownMid};margin:0;">
        Diagnostic personnalisé — ${prenom} — ${date}
      </p>
      <p style="font-size:10px;color:${C.brownMid};margin:0;">
        nopal-life.com · contact@nopal-life.com
      </p>
    </div>
  `;
}

// ─── HELPER : Barre de score ──────────────────────────────────────────────────
function scoreBar(score, showLabel = true, compact = false) {
  // score = valeur "problème" (100 = grave) — on affiche la valeur telle quelle avec couleur sémantique
  const pct = Math.max(0, Math.min(100, score));
  const color = pct >= 70 ? C.redSoft : pct >= 45 ? C.gold : C.greenSoft;
  const label = pct >= 70 ? 'Élevé' : pct >= 45 ? 'Modéré' : 'Faible';
  const h = compact ? '8px' : '10px';
  return `
    <div style="display:flex;align-items:center;gap:${compact ? 8 : 10}px;width:100%;">
      <div style="flex:1;background:${C.creamDark};border-radius:6px;height:${h};overflow:hidden;">
        <div style="width:${pct}%;height:100%;background:${color};
                    border-radius:6px;transition:width 0.4s;"></div>
      </div>
      ${showLabel ? `<span style="font-size:${compact?'10px':'11px'};color:${color};
        font-weight:600;min-width:${compact?'20px':'48px'};text-align:right;">
        ${compact ? pct : label}
      </span>` : ''}
    </div>
  `;
}

// ─── HELPER : Score global /100 ───────────────────────────────────────────────
function computeGlobalScore(scores) {
  const vals = Object.values(scores);
  if (!vals.length) return 50;
  const avg = vals.reduce((a, b) => a + b, 0) / vals.length;
  // Inverser : problème moyen élevé = score global bas
  return Math.max(0, Math.min(100, Math.round(100 - avg)));
}

// ─── HELPER : Couleur delta âge ───────────────────────────────────────────────
function deltaColor(ageDelta) {
  if (ageDelta > 2) return C.redSoft;
  if (ageDelta < -2) return C.greenSoft;
  return C.goldLight;
}

// ─── HELPER : Formater la date ────────────────────────────────────────────────
function formatDate(d = new Date()) {
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' });
}

// ─── HELPER : Projections J30/J60/J90 ────────────────────────────────────────
function project(s0, t) {
  return Math.round(s0 + (100 - s0) * (1 - Math.exp(-0.4 * t)));
}


// ══════════════════════════════════════════════════════════════════════════════
//   PAGES TEMPLATES
// ══════════════════════════════════════════════════════════════════════════════

// ─── PAGE 1 : COUVERTURE ──────────────────────────────────────────────────────
function buildPage1(userData, profile) {
  const page = makePage('pdf-p1');
  const prenom = userData.firstName || 'Votre diagnostic';
  const date = formatDate();
  const globalScore = computeGlobalScore(profile.scores || {});

  page.innerHTML = `
    <!-- Fond dégradé brun luxe -->
    <div style="position:absolute;inset:0;
      background:linear-gradient(170deg, ${C.brown} 0%, #5C3420 55%, #8B5C38 100%);"></div>

    <!-- Filigrane figuier (SVG décoratif) -->
    <div style="position:absolute;right:-40px;top:80px;opacity:0.06;font-size:340px;
                line-height:1;color:${C.goldLight};pointer-events:none;user-select:none;">
      ✦
    </div>
    <div style="position:absolute;left:-20px;bottom:120px;opacity:0.04;font-size:260px;
                line-height:1;color:${C.goldLight};pointer-events:none;user-select:none;
                transform:rotate(-15deg);">
      ✦
    </div>

    <!-- Ligne or haut -->
    <div style="position:absolute;top:0;left:0;right:0;height:4px;
                background:linear-gradient(90deg, transparent, ${C.gold}, transparent);"></div>

    <!-- Contenu centré -->
    <div style="position:relative;z-index:1;display:flex;flex-direction:column;
                align-items:center;justify-content:center;min-height:1123px;
                padding:60px 60px 80px;text-align:center;">

      <!-- Logo -->
      <div style="width:72px;height:72px;border-radius:50%;
                  background:${C.gold};display:flex;align-items:center;justify-content:center;
                  font-size:28px;color:${C.ivory};margin-bottom:28px;
                  box-shadow:0 4px 24px rgba(201,149,106,0.4);">✦</div>

      <!-- Marque -->
      <p style="font-family:'Inter',sans-serif;font-size:11px;font-weight:700;
                letter-spacing:0.22em;text-transform:uppercase;color:${C.goldLight};margin:0 0 8px;">
        Nopal Life
      </p>
      <h1 style="font-family:'Playfair Display',serif;font-size:36px;font-weight:600;
                 color:${C.ivory};margin:0 0 4px;line-height:1.2;">
        Skin Intelligence™
      </h1>
      <p style="font-family:'Inter',sans-serif;font-size:12px;color:rgba(253,248,244,0.55);
                letter-spacing:0.12em;margin:0 0 48px;">RAPPORT DIAGNOSTIQUE PERSONNALISÉ</p>

      <!-- Séparateur or -->
      <div style="width:80px;height:2px;background:${C.gold};margin-bottom:48px;
                  box-shadow:0 0 12px rgba(201,149,106,0.5);"></div>

      <!-- Prénom -->
      <p style="font-family:'Inter',sans-serif;font-size:12px;font-weight:500;
                letter-spacing:0.14em;text-transform:uppercase;color:${C.goldLight};margin:0 0 10px;">
        Établi pour
      </p>
      <h2 style="font-family:'Playfair Display',serif;font-size:48px;font-weight:600;
                 color:${C.gold};margin:0 0 6px;font-style:italic;">
        ${prenom}
      </h2>
      <p style="font-family:'Inter',sans-serif;font-size:13px;color:rgba(253,248,244,0.65);margin:0 0 60px;">
        ${date}
      </p>

      <!-- Score global -->
      <div style="background:rgba(253,248,244,0.06);border:1px solid rgba(201,149,106,0.4);
                  border-radius:16px;padding:28px 48px;margin-bottom:60px;
                  backdrop-filter:blur(8px);">
        <p style="font-family:'Inter',sans-serif;font-size:11px;font-weight:600;
                  letter-spacing:0.16em;text-transform:uppercase;color:${C.goldLight};margin:0 0 10px;">
          Score global de beauté
        </p>
        <div style="font-family:'Playfair Display',serif;font-size:64px;font-weight:600;
                    color:${C.gold};line-height:1;margin-bottom:4px;">
          ${globalScore}<span style="font-size:24px;color:${C.goldLight};">/100</span>
        </div>
        <p style="font-family:'Inter',sans-serif;font-size:12px;color:rgba(253,248,244,0.5);margin:0;">
          Calculé sur 9 dimensions cutanées
        </p>
      </div>

      <!-- Sommaire pages -->
      <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;width:100%;max-width:560px;">
        ${[
          ['P.2','Score & âge cutané'],
          ['P.3','Profil radar 8D'],
          ['P.4','Cartographie'],
          ['P.5-6','12 métriques'],
          ['P.7','Priorités'],
          ['P.8-9','4 produits'],
          ['P.10','Projections'],
          ['P.11','Conseils'],
          ['P.12','Code promo'],
        ].map(([num,label]) => `
          <div style="background:rgba(253,248,244,0.04);border:1px solid rgba(201,149,106,0.2);
                      border-radius:8px;padding:8px 12px;text-align:left;">
            <p style="font-family:'Inter',sans-serif;font-size:9px;font-weight:700;
                      letter-spacing:0.14em;color:${C.gold};margin:0 0 2px;">${num}</p>
            <p style="font-family:'Inter',sans-serif;font-size:10px;color:rgba(253,248,244,0.7);
                      margin:0;">${label}</p>
          </div>
        `).join('')}
      </div>
    </div>

    <!-- Ligne or bas -->
    <div style="position:absolute;bottom:0;left:0;right:0;height:4px;
                background:linear-gradient(90deg,transparent,${C.gold},transparent);"></div>
  `;

  return page;
}

// ─── PAGE 2 : SCORE GLOBAL + ÂGE CUTANÉ ──────────────────────────────────────
function buildPage2(userData, profile) {
  const page = makePage('pdf-p2');
  const prenom = userData.firstName || 'Votre diagnostic';
  const date = formatDate();
  const globalScore = computeGlobalScore(profile.scores || {});
  const { skinAge = 40, chronoAge = 40, ageDelta = 0, diagnosticText = '' } = profile;
  const dc = deltaColor(ageDelta);

  const deltaMsg = ageDelta > 2
    ? `Votre peau paraît ${ageDelta} ans plus âgée que votre âge chronologique. Un soin ciblé peut corriger cela rapidement.`
    : ageDelta < -2
    ? `Excellente nouvelle : votre peau paraît ${Math.abs(ageDelta)} ans plus jeune que votre âge réel !`
    : 'Votre peau est en parfaite cohérence avec votre âge chronologique.';

  // Anneau score SVG
  const circumference = 2 * Math.PI * 54;
  const strokeDash = (globalScore / 100) * circumference;
  const scoreColor = globalScore >= 70 ? C.greenSoft : globalScore >= 45 ? C.gold : C.redSoft;

  page.innerHTML = `
    ${makePageHeader(2, 'Score global & âge cutané')}
    <div style="${S.body}">
      <h2 style="${S.sectionTitle}">Score de beauté personnalisé</h2>

      <!-- Score + anneau -->
      <div style="display:flex;align-items:center;gap:48px;margin-bottom:36px;">
        <!-- Anneau SVG -->
        <div style="flex-shrink:0;">
          <svg width="140" height="140" viewBox="0 0 140 140">
            <!-- Fond anneau -->
            <circle cx="70" cy="70" r="54" fill="none"
                    stroke="${C.creamDark}" stroke-width="10"/>
            <!-- Arc score -->
            <circle cx="70" cy="70" r="54" fill="none"
                    stroke="${scoreColor}" stroke-width="10"
                    stroke-linecap="round"
                    stroke-dasharray="${strokeDash.toFixed(1)} ${circumference.toFixed(1)}"
                    transform="rotate(-90 70 70)"/>
            <!-- Texte score -->
            <text x="70" y="62" text-anchor="middle"
                  font-family="Playfair Display,serif" font-size="32" font-weight="600"
                  fill="${C.brown}">${globalScore}</text>
            <text x="70" y="80" text-anchor="middle"
                  font-family="Inter,sans-serif" font-size="12"
                  fill="${C.brownLight}">/100</text>
            <text x="70" y="96" text-anchor="middle"
                  font-family="Inter,sans-serif" font-size="9" letter-spacing="1"
                  fill="${C.brownMid}">BEAUTÉ GLOBALE</text>
          </svg>
        </div>

        <!-- Texte score + jauges niveaux -->
        <div style="flex:1;">
          <p style="font-family:'Inter',sans-serif;font-size:13px;color:${C.textLight};
                    line-height:1.7;margin:0 0 20px;">${diagnosticText || deltaMsg}</p>

          <!-- Niveaux de référence -->
          <div style="display:flex;flex-direction:column;gap:6px;">
            ${[
              [90,'Peau idéale',C.greenSoft],
              [70,'Peau équilibrée',C.goldLight],
              [50,'Besoins modérés',C.gold],
              [30,'Besoins importants',C.redSoft],
            ].map(([s,l,c]) => `
              <div style="display:flex;align-items:center;gap:8px;">
                <div style="width:28px;height:5px;border-radius:3px;background:${c};flex-shrink:0;"></div>
                <span style="font-size:10px;color:${C.textLight};">${s}+ — ${l}</span>
              </div>
            `).join('')}
          </div>
        </div>
      </div>

      <!-- Séparateur -->
      <div style="height:1px;background:${C.border};margin-bottom:28px;"></div>

      <!-- Âge cutané -->
      <h2 style="${S.sectionTitle}">Âge cutané estimé</h2>
      <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:16px;margin-bottom:28px;">

        <!-- Âge cutané -->
        <div style="background:${C.cream};border:1px solid ${C.borderGold};border-radius:14px;
                    padding:22px;text-align:center;">
          <p style="font-family:'Inter',sans-serif;font-size:10px;font-weight:600;
                    letter-spacing:0.14em;text-transform:uppercase;color:${C.brownLight};margin:0 0 8px;">
            Âge cutané
          </p>
          <p style="font-family:'Playfair Display',serif;font-size:42px;font-weight:600;
                    color:${C.brown};margin:0 0 2px;line-height:1;">
            ${skinAge}
          </p>
          <p style="font-family:'Inter',sans-serif;font-size:11px;color:${C.brownLight};margin:0;">ans</p>
        </div>

        <!-- Âge chronologique -->
        <div style="background:${C.cream};border:1px solid ${C.border};border-radius:14px;
                    padding:22px;text-align:center;">
          <p style="font-family:'Inter',sans-serif;font-size:10px;font-weight:600;
                    letter-spacing:0.14em;text-transform:uppercase;color:${C.brownLight};margin:0 0 8px;">
            Âge réel
          </p>
          <p style="font-family:'Playfair Display',serif;font-size:42px;font-weight:600;
                    color:${C.brownMid};margin:0 0 2px;line-height:1;">
            ${chronoAge}
          </p>
          <p style="font-family:'Inter',sans-serif;font-size:11px;color:${C.brownLight};margin:0;">ans</p>
        </div>

        <!-- Delta -->
        <div style="background:${C.cream};border:2px solid ${dc};border-radius:14px;
                    padding:22px;text-align:center;">
          <p style="font-family:'Inter',sans-serif;font-size:10px;font-weight:600;
                    letter-spacing:0.14em;text-transform:uppercase;color:${C.brownLight};margin:0 0 8px;">
            Écart
          </p>
          <p style="font-family:'Playfair Display',serif;font-size:38px;font-weight:600;
                    color:${dc};margin:0 0 2px;line-height:1;">
            ${ageDelta > 0 ? '+' : ''}${ageDelta}
          </p>
          <p style="font-family:'Inter',sans-serif;font-size:11px;color:${C.brownLight};margin:0;">ans</p>
        </div>
      </div>

      <!-- Message delta -->
      <div style="background:${C.cream};border-left:4px solid ${dc};
                  border-radius:0 10px 10px 0;padding:16px 20px;">
        <p style="font-family:'Inter',sans-serif;font-size:13px;color:${C.textMain};
                  line-height:1.7;margin:0;">
          ${deltaMsg}
        </p>
      </div>
    </div>
    ${makePageFooter(prenom, date)}
  `;

  return page;
}

// ─── PAGE 3 : RADAR CHART (capture de l'existant) ────────────────────────────
// Cette page est construite en deux temps :
//   1. Wrapper HTML avec cadre luxe
//   2. Le canvas radar existant est capturé par html2canvas et inséré en base64
async function buildPage3(userData, profile) {
  const page = makePage('pdf-p3');
  const prenom = userData.firstName || 'Votre diagnostic';
  const date = formatDate();

  page.innerHTML = `
    ${makePageHeader(3, 'Profil cutané — 8 dimensions')}
    <div style="${S.body}">
      <h2 style="${S.sectionTitle}">Votre empreinte cutanée</h2>
      <p style="font-family:'Inter',sans-serif;font-size:13px;color:${C.textLight};
                line-height:1.6;margin:0 0 24px;">
        Ce radar représente vos 8 dimensions cutanées mesurées. Un point proche du centre indique
        un soin faible dans cette dimension — plus le profil est étendu, plus votre peau est équilibrée.
      </p>

      <!-- Zone radar -->
      <div id="pdf-p3-radar-zone"
           style="background:${C.cream};border:1px solid ${C.border};border-radius:16px;
                  padding:24px;display:flex;justify-content:center;align-items:center;
                  min-height:420px;margin-bottom:24px;">
        <!-- Le canvas radar sera inséré ici via JS -->
        <p id="pdf-p3-loading" style="color:${C.brownLight};font-size:13px;">
          Chargement du radar…
        </p>
      </div>

      <!-- Légende dimensions -->
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;">
        ${Object.entries(DIM_LABELS)
          .filter(([k]) => k !== 'peau_mature')
          .map(([k, label]) => {
            const score = (profile.scores || {})[k] ?? 50;
            const pct = Math.max(0, Math.min(100, 100 - score)); // inverser pour radar positif
            const c = pct >= 70 ? C.greenSoft : pct >= 45 ? C.gold : C.redSoft;
            return `
              <div style="display:flex;align-items:center;gap:8px;padding:6px 0;">
                <div style="width:10px;height:10px;border-radius:50%;
                            background:${c};flex-shrink:0;"></div>
                <span style="font-size:11px;color:${C.textMain};flex:1;">${label}</span>
                <span style="font-size:11px;font-weight:600;color:${c};">${pct}/100</span>
              </div>
            `;
          }).join('')}
      </div>
    </div>
    ${makePageFooter(prenom, date)}
  `;

  return page;
}

// ─── PAGE 4 : CARTOGRAPHIE DU VISAGE ─────────────────────────────────────────
async function buildPage4(userData, profile) {
  const page = makePage('pdf-p4');
  const prenom = userData.firstName || 'Votre diagnostic';
  const date = formatDate();

  page.innerHTML = `
    ${makePageHeader(4, 'Cartographie du visage')}
    <div style="${S.body}">
      <h2 style="${S.sectionTitle}">Zones cutanées analysées</h2>
      <p style="font-family:'Inter',sans-serif;font-size:13px;color:${C.textLight};
                line-height:1.6;margin:0 0 20px;">
        La cartographie identifie les zones prioritaires de votre visage. Les zones colorées
        en rouge signalent les besoins les plus urgents.
      </p>

      <!-- Zone heatmap -->
      <div id="pdf-p4-heatmap-zone"
           style="background:${C.cream};border:1px solid ${C.border};border-radius:16px;
                  padding:20px;display:flex;justify-content:center;align-items:center;
                  min-height:360px;margin-bottom:24px;">
        <p id="pdf-p4-loading" style="color:${C.brownLight};font-size:13px;">
          Chargement de la cartographie…
        </p>
      </div>

      <!-- Tableau zones -->
      <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;">
        ${[
          ['Front', 'rides', 'peau_mature'],
          ['Contour yeux', 'contour_yeux', 'relachement'],
          ['Joues', 'sensibilite', 'eclat'],
          ['Nez / Zone T', 'pores', null],
          ['Menton', 'relachement', 'peau_mature'],
          ['Teint global', 'taches', 'eclat'],
        ].map(([zone, dim1, dim2]) => {
          const s1 = (profile.scores || {})[dim1] ?? 50;
          const s2 = dim2 ? ((profile.scores || {})[dim2] ?? 50) : null;
          const avg = s2 !== null ? Math.round((s1 + s2) / 2) : s1;
          const color = avg >= 70 ? C.redSoft : avg >= 45 ? C.gold : C.greenSoft;
          return `
            <div style="background:${C.cream};border:1px solid ${C.border};
                        border-radius:10px;padding:12px;text-align:center;">
              <p style="font-size:10px;font-weight:600;letter-spacing:0.1em;
                        text-transform:uppercase;color:${C.brownLight};margin:0 0 6px;">${zone}</p>
              <p style="font-family:'Playfair Display',serif;font-size:22px;font-weight:600;
                        color:${color};margin:0 0 2px;">${Math.round(100 - avg)}</p>
              <p style="font-size:9px;color:${C.brownMid};margin:0;">/100</p>
            </div>
          `;
        }).join('')}
      </div>
    </div>
    ${makePageFooter(prenom, date)}
  `;

  return page;
}

// ─── PAGES 5-6 : 12 MÉTRIQUES ────────────────────────────────────────────────
function buildMetricPage(pageNum, userData, profile, startIdx) {
  const page = makePage(`pdf-p${pageNum}`);
  const prenom = userData.firstName || 'Votre diagnostic';
  const date = formatDate();
  const allDims = Object.keys(DIM_LABELS);
  const dims = allDims.slice(startIdx, startIdx + 5); // 5 dimensions par page (≤ 9 total, 5+4)

  page.innerHTML = `
    ${makePageHeader(pageNum, `Métriques cutanées — ${pageNum === 5 ? 'Part. 1' : 'Part. 2'}`)}
    <div style="${S.body}">
      <h2 style="${S.sectionTitle}">
        Analyse détaillée ${pageNum === 5 ? '(1/2)' : '(2/2)'}
      </h2>

      <div style="display:flex;flex-direction:column;gap:20px;">
        ${dims.map(dim => {
          const score = (profile.scores || {})[dim] ?? 50;
          const label = DIM_LABELS[dim] || dim;
          const desc = DIM_DESCRIPTIONS[dim] || '';
          const positiveScore = 100 - score; // "bien-être"
          const sev = score >= 70 ? 'high' : score >= 45 ? 'medium' : 'low';
          const sevLabel = sev === 'high' ? 'Besoin important' : sev === 'medium' ? 'Besoin modéré' : 'État satisfaisant';
          const sevColor = sev === 'high' ? C.redSoft : sev === 'medium' ? C.gold : C.greenSoft;

          const interp = score >= 70
            ? `Ce paramètre nécessite une attention particulière. Les actifs ciblés peuvent améliorer cette zone significativement.`
            : score >= 45
            ? `Ce paramètre est dans une plage modérée. Un soin régulier maintiendra et améliorera votre état cutané.`
            : `Ce paramètre est en bon état. Continuez votre routine pour préserver ce niveau.`;

          return `
            <div style="background:${C.cream};border:1px solid ${C.border};
                        border-radius:12px;padding:18px;position:relative;overflow:hidden;">

              <!-- Barre de fond décorative -->
              <div style="position:absolute;left:0;top:0;bottom:0;width:4px;background:${sevColor};
                          border-radius:4px 0 0 4px;"></div>

              <div style="padding-left:10px;">
                <div style="display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:10px;">
                  <div>
                    <h3 style="font-family:'Playfair Display',serif;font-size:15px;font-weight:600;
                                color:${C.brown};margin:0 0 2px;">${label}</h3>
                    <p style="font-size:11px;color:${C.brownLight};margin:0;">${desc}</p>
                  </div>
                  <div style="text-align:right;flex-shrink:0;margin-left:16px;">
                    <p style="font-family:'Playfair Display',serif;font-size:26px;font-weight:600;
                              color:${sevColor};margin:0;line-height:1;">
                      ${positiveScore}
                    </p>
                    <p style="font-size:10px;color:${C.brownMid};margin:0;">/100</p>
                  </div>
                </div>

                <!-- Barre -->
                <div style="margin-bottom:10px;">${scoreBar(score, true)}</div>

                <!-- Badge sévérité -->
                <div style="display:flex;align-items:center;justify-content:space-between;">
                  <span style="${S.badge(sevColor)}">${sevLabel}</span>
                  <p style="font-size:11px;color:${C.textLight};margin:0;max-width:400px;
                            font-style:italic;line-height:1.5;">${interp}</p>
                </div>
              </div>
            </div>
          `;
        }).join('')}
      </div>
    </div>
    ${makePageFooter(prenom, date)}
  `;

  return page;
}

// ─── PAGE 7 : PRIORITÉS + DIAGNOSTIC ─────────────────────────────────────────
function buildPage7(userData, profile) {
  const page = makePage('pdf-p7');
  const prenom = userData.firstName || 'Votre diagnostic';
  const date = formatDate();
  const { needsHighlights = [], diagnosticText = '', topConcerns = [] } = profile;

  const highlights = needsHighlights.length
    ? needsHighlights
    : (topConcerns || []).map(k => ({
        key: k, label: DIM_LABELS[k] || k,
        score: (profile.scores || {})[k] ?? 50,
        severity: ((profile.scores || {})[k] ?? 50) >= 70 ? 'high' : 'medium'
      }));

  const sevColors = { high: C.redSoft, medium: C.gold, low: C.greenSoft };
  const sevLabels = { high: 'Priorité haute', medium: 'Priorité modérée', low: 'Satisfaisant' };

  page.innerHTML = `
    ${makePageHeader(7, 'Priorités beauté & diagnostic')}
    <div style="${S.body}">

      <!-- 3 priorités -->
      <h2 style="${S.sectionTitle}">Vos 3 priorités beauté</h2>
      <div style="display:flex;flex-direction:column;gap:14px;margin-bottom:32px;">
        ${highlights.slice(0, 3).map((h, i) => {
          const sc = sevColors[h.severity] || C.gold;
          const sl = sevLabels[h.severity] || '';
          return `
            <div style="background:${C.cream};border:1px solid ${sc};
                        border-radius:12px;padding:16px 20px;
                        display:flex;align-items:center;gap:16px;">
              <div style="width:36px;height:36px;border-radius:50%;background:${sc};
                          display:flex;align-items:center;justify-content:center;
                          font-family:'Playfair Display',serif;font-size:16px;font-weight:700;
                          color:${C.ivory};flex-shrink:0;">${i + 1}</div>
              <div style="flex:1;">
                <h3 style="font-family:'Playfair Display',serif;font-size:15px;
                            color:${C.brown};margin:0 0 6px;">${h.label}</h3>
                <div>${scoreBar(h.score, true, true)}</div>
              </div>
              <div style="text-align:right;flex-shrink:0;">
                <span style="${S.badge(sc)}">${sl}</span>
                <p style="font-size:12px;color:${C.textLight};margin:4px 0 0;font-weight:600;">
                  Score : ${h.score}/100
                </p>
              </div>
            </div>
          `;
        }).join('')}
      </div>

      <!-- Diagnostic narratif -->
      <h2 style="${S.sectionTitle}">Votre diagnostic personnalisé</h2>
      <div style="background:${C.cream};border:1px solid ${C.borderGold};
                  border-radius:14px;padding:24px;margin-bottom:24px;">
        <div style="display:flex;gap:14px;align-items:flex-start;">
          <div style="width:40px;height:40px;border-radius:50%;background:${C.gold};
                      display:flex;align-items:center;justify-content:center;
                      font-size:18px;flex-shrink:0;">✦</div>
          <div>
            <p style="font-family:'Playfair Display',serif;font-size:15px;font-weight:500;
                      color:${C.brown};margin:0 0 10px;font-style:italic;">
              Analyse de votre profil cutané
            </p>
            <p style="font-family:'Inter',sans-serif;font-size:13px;color:${C.textLight};
                      line-height:1.8;margin:0;">
              ${diagnosticText || `Votre profil cutané a été analysé sur 9 dimensions. Les priorités identifiées guident la sélection de vos actifs botaniques pour des résultats visibles en 30 jours.`}
            </p>
          </div>
        </div>
      </div>

      <!-- Note botaniques -->
      <div style="background:rgba(91,122,91,0.08);border:1px solid rgba(91,122,91,0.3);
                  border-radius:12px;padding:16px 20px;">
        <p style="font-family:'Inter',sans-serif;font-size:11px;font-weight:600;
                  color:${C.greenSoft};margin:0 0 6px;letter-spacing:0.1em;text-transform:uppercase;">
          ✦ Notre philosophie botanique
        </p>
        <p style="font-family:'Inter',sans-serif;font-size:12px;color:${C.textLight};
                  line-height:1.7;margin:0;">
          La figue de barbarie est l'huile végétale la plus riche en vitamine E de la planète.
          Associée aux actifs botaniques de la gamme Nopal Life, elle répond précisément
          aux besoins identifiés dans votre diagnostic pour une peau transformée en 4 semaines.
        </p>
      </div>
    </div>
    ${makePageFooter(prenom, date)}
  `;

  return page;
}

// ─── PAGES 8-9 : PRODUITS (2 par page) ───────────────────────────────────────
function buildProductPage(pageNum, userData, products, startIdx) {
  const page = makePage(`pdf-p${pageNum}`);
  const prenom = userData.firstName || 'Votre diagnostic';
  const date = formatDate();
  const pageProd = (products || []).slice(startIdx, startIdx + 2);

  page.innerHTML = `
    ${makePageHeader(pageNum, `Votre sélection — ${pageNum === 8 ? 'Part. 1' : 'Part. 2'}`)}
    <div style="${S.body}">
      <h2 style="${S.sectionTitle}">
        Produits recommandés pour votre profil ${pageNum === 8 ? '(1/2)' : '(2/2)'}
      </h2>

      <div style="display:flex;flex-direction:column;gap:20px;">
        ${pageProd.map((p, i) => {
          const absIdx = startIdx + i;
          const compat = p.compatibility ?? 80;
          const badgeBg = p.badgeColor || C.gold;
          const circumference = 2 * Math.PI * 20;
          const strokeDash = (compat / 100) * circumference;

          return `
            <div style="background:${C.cream};border:1px solid ${absIdx === 0 ? C.borderGold : C.border};
                        border-radius:16px;padding:22px;
                        ${absIdx === 0 ? `box-shadow:0 2px 16px rgba(201,149,106,0.15);` : ''}">

              <!-- Entête produit -->
              <div style="display:flex;align-items:flex-start;gap:16px;margin-bottom:16px;">

                <!-- Anneau compatibilité -->
                <div style="flex-shrink:0;text-align:center;">
                  <svg width="56" height="56" viewBox="0 0 56 56">
                    <circle cx="28" cy="28" r="20" fill="none"
                            stroke="${C.creamDark}" stroke-width="4"/>
                    <circle cx="28" cy="28" r="20" fill="none"
                            stroke="${C.gold}" stroke-width="4"
                            stroke-linecap="round"
                            stroke-dasharray="${strokeDash.toFixed(1)} ${circumference.toFixed(1)}"
                            transform="rotate(-90 28 28)"/>
                    <text x="28" y="32" text-anchor="middle"
                          font-family="Inter,sans-serif" font-size="10" font-weight="700"
                          fill="${C.brown}">${compat}%</text>
                  </svg>
                  <p style="font-size:9px;color:${C.brownMid};margin:2px 0 0;
                            text-align:center;">Compatibilité</p>
                </div>

                <!-- Infos produit -->
                <div style="flex:1;">
                  <div style="display:flex;align-items:center;gap:8px;margin-bottom:4px;">
                    <h3 style="font-family:'Playfair Display',serif;font-size:16px;
                                font-weight:600;color:${C.brown};margin:0;">
                      ${p.shortName || p.name}
                    </h3>
                    ${p.badge ? `<span style="${S.badge(badgeBg)}">${p.badge}</span>` : ''}
                  </div>
                  <p style="font-family:'Inter',sans-serif;font-size:12px;color:${C.gold};
                            font-style:italic;margin:0 0 6px;">${p.tagline || ''}</p>
                  <p style="font-family:'Inter',sans-serif;font-size:12px;color:${C.textLight};
                            line-height:1.6;margin:0;">
                    ${(p.description || '').substring(0, 160)}${(p.description || '').length > 160 ? '…' : ''}
                  </p>
                </div>

                <!-- Prix -->
                <div style="flex-shrink:0;text-align:right;">
                  <p style="font-family:'Playfair Display',serif;font-size:22px;font-weight:600;
                            color:${C.brown};margin:0 0 2px;">${(p.price || 0).toFixed(2)} €</p>
                  <p style="font-size:10px;color:${C.brownLight};margin:0;">prix indicatif</p>
                </div>
              </div>

              <!-- Ingrédients clés -->
              <div style="background:rgba(201,149,106,0.08);border-radius:8px;
                          padding:10px 14px;margin-bottom:12px;">
                <p style="font-size:10px;font-weight:600;letter-spacing:0.1em;
                          text-transform:uppercase;color:${C.brownLight};margin:0 0 6px;">
                  Ingrédients clés
                </p>
                <p style="font-size:11px;color:${C.textMain};margin:0;line-height:1.6;">
                  ${(p.keyIngredients || []).join(' · ')}
                </p>
              </div>

              <!-- Usage + CTA -->
              <div style="display:flex;align-items:center;justify-content:space-between;gap:12px;">
                <div style="flex:1;">
                  <p style="font-size:10px;font-weight:600;letter-spacing:0.1em;
                            text-transform:uppercase;color:${C.brownLight};margin:0 0 3px;">
                    Utilisation
                  </p>
                  <p style="font-size:11px;color:${C.textLight};margin:0;line-height:1.5;">
                    ${p.usage || ''}
                  </p>
                </div>
                <div style="background:${C.brown};color:${C.ivory};padding:8px 16px;
                            border-radius:20px;font-size:10px;font-weight:600;
                            letter-spacing:0.1em;text-transform:uppercase;flex-shrink:0;">
                  nopal-life.com${p.url || ''}
                </div>
              </div>
            </div>
          `;
        }).join('')}
      </div>
    </div>
    ${makePageFooter(prenom, date)}
  `;

  return page;
}

// ─── PAGE 10 : PROJECTIONS J30/J60/J90 ───────────────────────────────────────
function buildPage10(userData, profile) {
  const page = makePage('pdf-p10');
  const prenom = userData.firstName || 'Votre diagnostic';
  const date = formatDate();

  const dims = [
    { key: 'secheresse', label: 'Hydratation' },
    { key: 'relachement', label: 'Fermeté' },
    { key: 'eclat',      label: 'Éclat' },
    { key: 'rides',      label: 'Rides' },
  ];

  const paliers = [
    { t: 0, label: 'Aujourd\'hui' },
    { t: 1, label: 'J+30' },
    { t: 2, label: 'J+60' },
    { t: 3, label: 'J+90' },
  ];

  // Calculer les données de projection
  const projData = dims.map(d => {
    const rawScore = (profile.scores || {})[d.key] ?? 50;
    const s0 = 100 - rawScore; // inverser → "amélioration" croissante
    return {
      label: d.label,
      values: paliers.map(p => p.t === 0 ? s0 : project(s0, p.t)),
    };
  });

  page.innerHTML = `
    ${makePageHeader(10, 'Projections J30 · J60 · J90')}
    <div style="${S.body}">
      <h2 style="${S.sectionTitle}">Votre évolution estimée avec la routine</h2>
      <p style="font-family:'Inter',sans-serif;font-size:13px;color:${C.textLight};
                line-height:1.6;margin:0 0 24px;">
        Ces projections sont calculées sur la base de l'utilisation régulière de votre routine personnalisée.
        Les résultats individuels peuvent varier selon la régularité et le type de peau.
      </p>

      <!-- Tableau de projections -->
      <div style="background:${C.cream};border:1px solid ${C.border};border-radius:14px;
                  overflow:hidden;margin-bottom:24px;">

        <!-- En-tête tableau -->
        <div style="display:grid;grid-template-columns:160px 1fr 1fr 1fr 1fr;
                    background:${C.brown};padding:12px 16px;">
          <p style="font-size:10px;font-weight:700;letter-spacing:0.12em;
                    text-transform:uppercase;color:${C.goldLight};margin:0;">Dimension</p>
          ${paliers.map(p => `
            <p style="font-size:10px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;
                      color:${p.t === 0 ? C.goldLight : C.ivory};margin:0;text-align:center;">
              ${p.label}
            </p>
          `).join('')}
        </div>

        <!-- Lignes données -->
        ${projData.map((d, ri) => `
          <div style="display:grid;grid-template-columns:160px 1fr 1fr 1fr 1fr;
                      padding:12px 16px;
                      ${ri % 2 === 0 ? `background:${C.ivory};` : `background:${C.cream};`}
                      border-top:1px solid ${C.border};">
            <p style="font-family:'Playfair Display',serif;font-size:13px;
                      color:${C.brown};margin:0;font-weight:500;">${d.label}</p>
            ${d.values.map((v, ti) => {
              const improvement = ti > 0 ? v - d.values[0] : 0;
              const impColor = improvement > 0 ? C.greenSoft : C.textLight;
              return `
                <div style="text-align:center;">
                  <p style="font-family:'Playfair Display',serif;font-size:18px;
                            font-weight:600;color:${ti === 0 ? C.brownMid : C.brown};
                            margin:0;line-height:1;">${v}</p>
                  <p style="font-size:9px;color:${C.brownLight};margin:0;">/100</p>
                  ${ti > 0 ? `<p style="font-size:10px;color:${impColor};margin:2px 0 0;font-weight:600;">
                    +${improvement}pts
                  </p>` : ''}
                </div>
              `;
            }).join('')}
          </div>
        `).join('')}
      </div>

      <!-- Graphique visuel barres empilées -->
      <div style="background:${C.cream};border:1px solid ${C.border};border-radius:12px;padding:18px;">
        <p style="font-family:'Playfair Display',serif;font-size:14px;font-weight:500;
                  color:${C.brown};margin:0 0 16px;">Progression estimée par dimension</p>

        ${projData.map(d => {
          const j0 = d.values[0];
          const j90 = d.values[3];
          const gain = j90 - j0;
          return `
            <div style="margin-bottom:14px;">
              <div style="display:flex;justify-content:space-between;margin-bottom:4px;">
                <span style="font-size:11px;color:${C.textMain};font-weight:500;">${d.label}</span>
                <span style="font-size:11px;color:${C.greenSoft};font-weight:600;">
                  +${gain}pts en 90 jours
                </span>
              </div>
              <!-- Barre J0 -->
              <div style="background:${C.creamDark};border-radius:6px;height:12px;
                          overflow:hidden;position:relative;">
                <div style="width:${j0}%;height:100%;background:${C.brownLight};
                            border-radius:6px;position:absolute;left:0;"></div>
                <div style="width:${j90}%;height:100%;
                            background:linear-gradient(90deg,transparent ${j0}%,${C.gold} ${j0}%);
                            border-radius:6px;position:absolute;left:0;opacity:0.7;"></div>
              </div>
              <div style="display:flex;justify-content:space-between;margin-top:3px;">
                <span style="font-size:9px;color:${C.brownMid};">Aujourd'hui: ${j0}/100</span>
                <span style="font-size:9px;color:${C.gold};">J+90: ${j90}/100</span>
              </div>
            </div>
          `;
        }).join('')}

        <p style="font-size:10px;color:${C.brownLight};margin:12px 0 0;font-style:italic;">
          * Estimations calculées sur base d'utilisation régulière bi-quotidienne des produits recommandés.
        </p>
      </div>
    </div>
    ${makePageFooter(prenom, date)}
  `;

  return page;
}

// ─── PAGE 11 : CONSEILS + DISCLAIMER ─────────────────────────────────────────
function buildPage11(userData, profile) {
  const page = makePage('pdf-p11');
  const prenom = userData.firstName || 'Votre diagnostic';
  const date = formatDate();
  const { skinType = 'normale', hormonalStage, topConcerns = [] } = profile;

  const skinTypeAdvice = {
    seche:    'Privilégiez des soins riches et nourrissants. Évitez les nettoyants moussants agressifs. Appliquez votre sérum sur peau légèrement humide.',
    normale:  'Votre peau est équilibrée. Maintenez une routine régulière matin et soir. Concentrez-vous sur la prévention et la protection solaire.',
    mixte:    'Adaptez les textures selon les zones : riche sur les joues, léger sur la zone T. Évitez les produits occlusifs sur le front et le nez.',
    grasse:   'Optez pour des textures gel, sérum ou fluide. Choisissez des actifs matifiants (niacinamide, zinc). Évitez les huiles non-comédo.',
    sensible: 'Testez chaque nouveau produit 48h sur la zone du poignet avant application visage. Évitez les acides forts, parfums et alcool dans les formules.',
    mature:   'Augmentez les concentrations d\'actifs anti-âge. Privilégiez les peptides et les céramides. La régularité est clé pour les résultats.',
  };

  const hormonalAdvice = hormonalStage === 'menopause' || hormonalStage === 'perimenopause'
    ? 'En phase de ménopause ou péri-ménopause, la peau paraît souvent moins dense et moins ferme. Les actifs à l\'effet tenseur visible et les actifs botaniques (bakuchiol, figue de barbarie) sont particulièrement indiqués pour raviver l\'aspect tonique de la peau.'
    : '';

  const topConcernAdvices = (topConcerns || []).slice(0, 3).map(c => {
    const advices = {
      rides: 'Pour les rides : appliquez sérum et crème avec des gestes de massage ascendants. Le sérum bakuchiol le soir aide à lisser l\'aspect des ridules.',
      relachement: 'Pour la fermeté : les peptides tenseurs et les céramides appliqués soir sur peau propre sont les plus efficaces. Ajoutez des mouvements de lifting manuel.',
      secheresse: 'Pour l\'hydratation : appliquez votre sérum HA sur peau légèrement humide pour amplifier l\'effet repulpant. Hydratez de l\'intérieur (1,5L d\'eau/jour).',
      eclat: 'Pour l\'éclat : l\'exfoliation douce 1-2x/semaine + la vitamine C le matin sont incontournables. Protégez toujours avec un SPF.',
      taches: 'Pour l\'uniformité : la vitamine C stabilisée le matin + protection SPF quotidienne = combo anti-taches n°1. Évitez l\'exposition solaire sans protection.',
      sensibilite: 'Pour la sensibilité : moins de produits, plus de douceur. Une routine minimaliste en 3 étapes (nettoyant doux, sérum apaisant, crème protectrice) suffit.',
      contour_yeux: 'Pour le contour des yeux : appliquez le sérum yeux avec l\'annulaire en tapotant, jamais en frottant. La caféine le matin dégonfle efficacement.',
      pores: 'Pour les pores : le niacinamide est votre meilleur allié. Combiné à l\'acide glycolique 2x/semaine, il réduit visiblement le grain de peau.',
    };
    return advices[c] || '';
  }).filter(Boolean);

  page.innerHTML = `
    ${makePageHeader(11, 'Conseils personnalisés')}
    <div style="${S.body}">
      <h2 style="${S.sectionTitle}">Conseils adaptés à votre profil</h2>

      <!-- Conseil type de peau -->
      <div style="background:${C.cream};border:1px solid ${C.borderGold};
                  border-radius:12px;padding:18px;margin-bottom:16px;">
        <p style="font-family:'Inter',sans-serif;font-size:10px;font-weight:700;
                  letter-spacing:0.12em;text-transform:uppercase;
                  color:${C.gold};margin:0 0 8px;">
          ✦ Peau ${skinType} — conseils spécifiques
        </p>
        <p style="font-family:'Inter',sans-serif;font-size:13px;color:${C.textMain};
                  line-height:1.7;margin:0;">
          ${skinTypeAdvice[skinType] || skinTypeAdvice['normale']}
        </p>
      </div>

      ${hormonalAdvice ? `
        <div style="background:rgba(91,122,91,0.08);border:1px solid rgba(91,122,91,0.3);
                    border-radius:12px;padding:16px 18px;margin-bottom:16px;">
          <p style="font-size:10px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;
                    color:${C.greenSoft};margin:0 0 8px;">Équilibre hormonal</p>
          <p style="font-size:13px;color:${C.textMain};line-height:1.7;margin:0;">
            ${hormonalAdvice}
          </p>
        </div>
      ` : ''}

      <!-- Conseils priorités -->
      ${topConcernAdvices.length ? `
        <div style="display:flex;flex-direction:column;gap:12px;margin-bottom:20px;">
          ${topConcernAdvices.map((advice, i) => `
            <div style="display:flex;gap:12px;align-items:flex-start;">
              <div style="width:24px;height:24px;border-radius:50%;background:${C.gold};
                          display:flex;align-items:center;justify-content:center;
                          font-size:11px;font-weight:700;color:${C.ivory};flex-shrink:0;">
                ${i + 1}
              </div>
              <p style="font-size:12px;color:${C.textMain};line-height:1.7;margin:0;">
                ${advice}
              </p>
            </div>
          `).join('')}
        </div>
      ` : ''}

      <!-- Habitudes de vie -->
      <div style="background:${C.cream};border:1px solid ${C.border};
                  border-radius:12px;padding:16px 18px;margin-bottom:20px;">
        <p style="font-size:11px;font-weight:600;letter-spacing:0.1em;text-transform:uppercase;
                  color:${C.brownLight};margin:0 0 10px;">Hygiène de vie & peau</p>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;">
          ${[
            ['Sommeil','7-9h par nuit pour une peau qui paraît reposée'],
            ['Hydratation','1,5L d\'eau minimum, thé vert antioxydant'],
            ['Alimentation','Oméga-3, zinc, vitamine C dans votre assiette'],
            ['SPF','Protection solaire chaque matin, même par temps nuageux'],
            ['Stress','Méditation ou cohérence cardiaque : effet visible sur la peau'],
            ['Gestes','Mouvements ascendants, jamais de friction'],
          ].map(([t, d]) => `
            <div style="display:flex;gap:8px;align-items:flex-start;">
              <div style="width:6px;height:6px;border-radius:50%;background:${C.gold};
                          margin-top:5px;flex-shrink:0;"></div>
              <div>
                <p style="font-size:11px;font-weight:600;color:${C.brown};margin:0;">${t}</p>
                <p style="font-size:10px;color:${C.textLight};margin:0;line-height:1.5;">${d}</p>
              </div>
            </div>
          `).join('')}
        </div>
      </div>

      <!-- Disclaimer -->
      <div style="background:rgba(61,35,20,0.05);border:1px solid ${C.border};
                  border-radius:8px;padding:12px 16px;">
        <p style="font-size:10px;color:${C.brownMid};line-height:1.7;margin:0;">
          <strong style="color:${C.brown};">Avertissement :</strong> Ce diagnostic est fourni
          à titre informatif et indicatif uniquement. Il ne constitue pas un avis médical ou
          dermatologique. Consultez un professionnel de santé pour tout problème cutané persistant.
          Les résultats peuvent varier selon les individus.
        </p>
      </div>
    </div>
    ${makePageFooter(prenom, date)}
  `;

  return page;
}

// ─── PAGE 12 : CTA FINALE ─────────────────────────────────────────────────────
function buildPage12(userData, products) {
  const page = makePage('pdf-p12');
  const prenom = userData.firstName || 'Votre diagnostic';
  const date = formatDate();
  const totalRoutine = (products || []).reduce((s, p) => s + (p.price || 0), 0);
  const discounted = (totalRoutine * 0.90).toFixed(2);

  page.innerHTML = `
    <!-- Fond dégradé luxe -->
    <div style="position:absolute;inset:0;
      background:linear-gradient(165deg, ${C.brown} 0%, #4A2816 60%, #6B3C20 100%);"></div>

    <!-- Ligne or haut -->
    <div style="position:absolute;top:0;left:0;right:0;height:4px;
                background:linear-gradient(90deg,transparent,${C.gold},transparent);"></div>

    <div style="position:relative;z-index:1;display:flex;flex-direction:column;
                align-items:center;padding:60px 60px 80px;text-align:center;min-height:1123px;">

      <!-- Header -->
      <div style="width:60px;height:60px;border-radius:50%;background:${C.gold};
                  display:flex;align-items:center;justify-content:center;
                  font-size:24px;color:${C.ivory};margin-bottom:24px;">✦</div>
      <p style="font-family:'Inter',sans-serif;font-size:11px;font-weight:700;
                letter-spacing:0.2em;text-transform:uppercase;color:${C.goldLight};margin:0 0 8px;">
        Passez à l'action
      </p>
      <h1 style="font-family:'Playfair Display',serif;font-size:32px;font-weight:600;
                 color:${C.ivory};margin:0 0 12px;line-height:1.2;">
        Votre routine personnalisée<br>vous attend
      </h1>
      <p style="font-family:'Inter',sans-serif;font-size:14px;color:rgba(253,248,244,0.65);
                margin:0 0 48px;max-width:500px;line-height:1.6;">
        Débutez votre transformation en 30 jours avec les actifs botaniques
        sélectionnés précisément pour votre profil cutané.
      </p>

      <!-- Code promo -->
      <div style="background:rgba(253,248,244,0.06);border:2px solid ${C.gold};
                  border-radius:20px;padding:32px 48px;margin-bottom:48px;
                  box-shadow:0 4px 32px rgba(201,149,106,0.25);">
        <p style="font-family:'Inter',sans-serif;font-size:11px;font-weight:700;
                  letter-spacing:0.2em;text-transform:uppercase;color:${C.goldLight};margin:0 0 12px;">
          Votre avantage diagnostic
        </p>
        <div style="background:${C.gold};border-radius:12px;padding:14px 32px;
                    display:inline-block;margin-bottom:16px;">
          <span style="font-family:'Playfair Display',serif;font-size:32px;font-weight:700;
                       color:${C.ivory};letter-spacing:0.06em;">DIAG10</span>
        </div>
        <p style="font-family:'Inter',sans-serif;font-size:14px;color:${C.ivory};
                  font-weight:600;margin:0 0 6px;">
          −10% sur votre routine personnalisée
        </p>
        ${totalRoutine > 0 ? `
          <p style="font-family:'Inter',sans-serif;font-size:13px;
                    color:rgba(253,248,244,0.6);margin:0;">
            Votre routine :
            <span style="text-decoration:line-through;color:rgba(253,248,244,0.4);">
              ${totalRoutine.toFixed(2)} €
            </span>
            → <strong style="color:${C.goldLight};">${discounted} €</strong>
          </p>
        ` : ''}
        <p style="font-family:'Inter',sans-serif;font-size:11px;color:rgba(253,248,244,0.45);
                  margin:8px 0 0;">Code valable 30 jours · Une utilisation</p>
      </div>

      <!-- Produits en grille -->
      ${(products || []).length > 0 ? `
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;
                    width:100%;max-width:560px;margin-bottom:40px;">
          ${(products || []).slice(0, 4).map(p => `
            <div style="background:rgba(253,248,244,0.05);border:1px solid rgba(201,149,106,0.3);
                        border-radius:12px;padding:14px 16px;text-align:left;">
              ${p.badge ? `<span style="${S.badge()}display:block;margin-bottom:6px;">${p.badge}</span>` : ''}
              <p style="font-family:'Playfair Display',serif;font-size:13px;color:${C.ivory};
                        font-weight:500;margin:0 0 4px;">${p.shortName || p.name}</p>
              <p style="font-size:10px;color:${C.goldLight};font-style:italic;margin:0 0 6px;">
                ${p.tagline || ''}
              </p>
              <p style="font-size:12px;font-weight:700;color:${C.gold};margin:0;">
                ${(p.price || 0).toFixed(2)} €
              </p>
            </div>
          `).join('')}
        </div>
      ` : ''}

      <!-- Liens & contacts -->
      <div style="display:flex;flex-direction:column;align-items:center;gap:12px;margin-bottom:40px;">
        <div style="background:${C.gold};color:${C.ivory};padding:14px 40px;
                    border-radius:30px;font-size:13px;font-weight:700;
                    letter-spacing:0.08em;text-transform:uppercase;">
          nopal-life.com/collections/soins-de-visage-naturels
        </div>
        <p style="font-size:12px;color:rgba(253,248,244,0.5);margin:0;">
          contact@nopal-life.com · nopal-life.com
        </p>
      </div>

      <!-- Footer mentions -->
      <div style="border-top:1px solid rgba(201,149,106,0.25);padding-top:20px;
                  max-width:580px;width:100%;">
        <p style="font-size:11px;color:rgba(253,248,244,0.4);line-height:1.7;margin:0;text-align:center;">
          Rapport généré le ${date} · ${prenom} · Nopal Life Skin Intelligence™<br>
          Ce diagnostic est indicatif et non médical. Nopal Life — cosmétiques botaniques naturels.<br>
          Données protégées RGPD · Suppression sur demande : contact@nopal-life.com
        </p>
      </div>
    </div>

    <!-- Ligne or bas -->
    <div style="position:absolute;bottom:0;left:0;right:0;height:4px;
                background:linear-gradient(90deg,transparent,${C.gold},transparent);"></div>
  `;

  return page;
}


// ══════════════════════════════════════════════════════════════════════════════
//   MOTEUR DE CAPTURE HTML → PDF
// ══════════════════════════════════════════════════════════════════════════════

/**
 * Capture un élément DOM en image base64 via html2canvas
 * @param {HTMLElement} el
 * @param {Object} opts - options html2canvas
 * @returns {Promise<string>} dataURL PNG
 */
async function captureElement(el, opts = {}) {
  // Timeout 5s — html2canvas peut se bloquer sur canvas Chart.js
  const timeout = new Promise((_, reject) =>
    setTimeout(() => reject(new Error('html2canvas timeout')), 5000)
  );
  const capture = window.html2canvas(el, {
    scale: 2,
    backgroundColor: C.ivory,
    useCORS: true,
    allowTaint: true,
    logging: false,
    ignoreElements: el2 => el2.tagName === 'IFRAME',
    ...opts,
  });
  const canvas = await Promise.race([capture, timeout]);
  return canvas.toDataURL('image/png');
}

/**
 * Injecte un contenu capturé (dataURL) dans un div cible du PDF
 * @param {HTMLElement} page - page DOM
 * @param {string} targetId - id du div de destination
 * @param {string} dataUrl - image capturée
 * @param {number} maxHeight - hauteur max de l'image (px CSS)
 */
function injectCapture(page, targetId, dataUrl, maxHeight = 400) {
  const zone = page.querySelector(`#${targetId}`);
  if (!zone) return;
  zone.innerHTML = '';
  const img = document.createElement('img');
  img.src = dataUrl;
  img.style.cssText = `max-width:100%;max-height:${maxHeight}px;border-radius:10px;display:block;margin:0 auto;`;
  zone.appendChild(img);
}

/**
 * Capture le radar Chart.js directement depuis le canvas natif (rapide, sans html2canvas)
 * Fallback sur html2canvas si le canvas natif ne répond pas
 * @returns {Promise<string|null>}
 */
async function captureRadarFromDOM() {
  try {
    const radarContainer = document.getElementById('results-radar-container');
    if (!radarContainer) return null;

    // ① Essai direct sur le canvas Chart.js (le plus rapide)
    const nativeCanvas = radarContainer.querySelector('canvas');
    if (nativeCanvas && nativeCanvas.width > 0) {
      try {
        const dataUrl = nativeCanvas.toDataURL('image/png');
        if (dataUrl && dataUrl.length > 100) {
          console.log('[PDF] Radar capturé via canvas natif ✓');
          return dataUrl;
        }
      } catch(e) { /* canvas tainted ou vide — continuer */ }
    }

    // ② Fallback html2canvas avec timeout 5s
    console.log('[PDF] Radar: fallback html2canvas');
    return await captureElement(radarContainer, { backgroundColor: C.cream, scale: 1.5 });

  } catch (err) {
    console.warn('[PDF] Capture radar failed:', err.message);
    return null;
  }
}

/**
 * Capture la heatmap (canvas 2D) directement puis fallback html2canvas
 * @returns {Promise<string|null>}
 */
async function captureHeatmapFromDOM() {
  try {
    const heatmapContainer = document.getElementById('results-heatmap-container');
    if (!heatmapContainer) return null;

    // ① Essai direct canvas natif
    const nativeCanvas = heatmapContainer.querySelector('canvas');
    if (nativeCanvas && nativeCanvas.width > 0) {
      try {
        const dataUrl = nativeCanvas.toDataURL('image/png');
        if (dataUrl && dataUrl.length > 100) {
          console.log('[PDF] Heatmap capturée via canvas natif ✓');
          return dataUrl;
        }
      } catch(e) { /* tainted */ }
    }

    // ② Fallback html2canvas avec timeout 5s
    console.log('[PDF] Heatmap: fallback html2canvas');
    return await captureElement(heatmapContainer, { backgroundColor: C.cream, scale: 1.5 });

  } catch (err) {
    console.warn('[PDF] Capture heatmap failed:', err.message);
    return null;
  }
}

/**
 * Ajoute un overlay de chargement sur le bouton PDF
 */
function showPDFProgress(message = 'Génération du PDF…') {
  const btn = document.getElementById('btn-download-pdf');
  if (btn) {
    btn.textContent = message;
    btn.disabled = true;
  }
}

function updatePDFProgress(msg) {
  const btn = document.getElementById('btn-download-pdf');
  if (btn) btn.textContent = msg;
}


// ══════════════════════════════════════════════════════════════════════════════
//   FONCTION PRINCIPALE — jsPDF 100% natif, zéro html2canvas
//   Génération < 1 seconde, compatible tous navigateurs/plateformes
// ══════════════════════════════════════════════════════════════════════════════

/**
 * Génère et télécharge le rapport PDF Nopal Life Skin Intelligence™
 * Version jsPDF native — pas d'html2canvas, aucun blocage possible
 *
 * @param {Object} profile   - Profil complet depuis scoring.js
 * @param {Array}  products  - Produits recommandés
 * @param {Object} userData  - { firstName, email }
 */
async function generateDiagnosticPDF(profile, products, userData = {}) {
  // ── 0. Vérification jsPDF uniquement (plus besoin de html2canvas) ─────────
  let waited = 0;
  while (!window.jspdf && waited < 6000) {
    await new Promise(r => setTimeout(r, 200));
    waited += 200;
  }
  if (!window.jspdf) {
    alert('La bibliothèque PDF est en cours de chargement. Veuillez réessayer dans quelques secondes.');
    return;
  }

  const { jsPDF } = window.jspdf;

  const sp = { scores: {}, skinAge: 40, chronoAge: 40, ageDelta: 0, diagnosticText: '',
               needsHighlights: [], topConcerns: [], skinType: 'eclat', ageRange: '41_48', ...profile };
  const prods = Array.isArray(products) ? products : [];
  const ud = { firstName: 'Cliente', email: '', ...userData };
  const prenom = ud.firstName || 'Cliente';

  showPDFProgress('Génération du rapport…');

  // Récupérer le radar depuis le canvas existant (instantané)
  let radarDataUrl = null;
  try {
    const rc = document.querySelector('#results-radar-container canvas');
    if (rc && rc.width > 0) radarDataUrl = rc.toDataURL('image/png');
  } catch(e) {}

  // ── Init jsPDF ────────────────────────────────────────────────────────────
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4', compress: true });
  const W = 210, H = 297;
  const M = 18; // margin

  // Palettes RGB
  const BROWN  = [42, 26, 14];
  const GOLD   = [201, 149, 106];
  const IVORY  = [253, 248, 244];
  const CREAM  = [240, 232, 220];
  const BLIGHT = [176, 128, 96];
  const WHITE  = [255, 255, 255];
  const RED    = [220, 80, 60];
  const AMBER  = [220, 160, 60];
  const GREEN  = [80, 160, 80];

  // Helper: définir couleur fill
  function setFill(rgb) { doc.setFillColor(rgb[0], rgb[1], rgb[2]); }
  function setDraw(rgb) { doc.setDrawColor(rgb[0], rgb[1], rgb[2]); }
  function setTxt(rgb)  { doc.setTextColor(rgb[0], rgb[1], rgb[2]); }

  // Helper: texte avec retour à la ligne
  function wrapText(text, x, y, maxW, lineH) {
    const words = (text || '').split(' ');
    let line = '';
    let cy = y;
    words.forEach(function(w) {
      const test = line ? line + ' ' + w : w;
      if (doc.getTextWidth(test) > maxW && line) {
        doc.text(line, x, cy);
        cy += lineH;
        line = w;
      } else { line = test; }
    });
    if (line) { doc.text(line, x, cy); cy += lineH; }
    return cy;
  }

  // Helper: barre de score colorée
  function drawScoreBar(x, y, w, h, score, label, showLabel) {
    const color = score >= 70 ? RED : score >= 45 ? AMBER : GREEN;
    setFill(CREAM); setDraw(CREAM);
    doc.roundedRect(x, y, w, h, 1, 1, 'F');
    const filled = Math.max(3, (score / 100) * w);
    setFill(color);
    doc.roundedRect(x, y, filled, h, 1, 1, 'F');
    if (showLabel) {
      setTxt(BROWN);
      doc.setFontSize(7.5);
      doc.text(label || '', x, y - 1.5);
      doc.setFontSize(7.5);
      setTxt(BLIGHT);
      doc.text(String(score) + '/100', x + w - 14, y + h - 0.5);
    }
  }

  // Helper: footer page
  function drawFooter(pageNum) {
    setFill(CREAM); doc.rect(0, H - 10, W, 10, 'F');
    setTxt(BLIGHT); doc.setFontSize(7);
    doc.text('NOPAL LIFE — SKIN INTELLIGENCE™', M, H - 4);
    doc.text('Rapport confidentiel • nopal-life.com', W - M, H - 4, { align: 'right' });
    doc.text('Page ' + pageNum, W / 2, H - 4, { align: 'center' });
  }

  const SKIN_LABELS = {
    peau_mature: 'Peau Mature', peau_seche: 'Peau Sèche', peau_grasse: 'Peau Grasse',
    peau_sensible: 'Peau Sensible', eclat: 'Éclat', peau_deshydratee: 'Peau Déshydratée',
    seche: 'Peau Sèche', grasse: 'Peau Grasse', sensible: 'Peau Sensible', normale: 'Éclat',
  };
  const DIM_LABELS_PDF = {
    rides: 'Rides & ridules', relachement: 'Fermeté', secheresse: 'Hydratation',
    eclat: 'Éclat', taches: 'Uniformité', sensibilite: 'Sérénité',
    contour_yeux: 'Contour des yeux', pores: 'Pores & texture', peau_mature: 'Âge cutané',
  };

  const scores = sp.scores || {};
  const dims = Object.keys(DIM_LABELS_PDF);
  const skinLabel = SKIN_LABELS[sp.skinType] || sp.skinType;
  const today = new Date().toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' });
  const avgScore = dims.length
    ? Math.round(dims.reduce(function(s, d) { return s + (scores[d] || 50); }, 0) / dims.length)
    : 50;

  // ══════════════════════════════════════════════════════════════════════════
  // PAGE 1 — COUVERTURE
  // ══════════════════════════════════════════════════════════════════════════
  setFill(BROWN); doc.rect(0, 0, W, H, 'F');

  // Bande dorée en haut
  setFill(GOLD); doc.rect(0, 0, W, 2, 'F');

  // Logo text
  setTxt(WHITE); doc.setFontSize(28); doc.setFont('helvetica', 'bold');
  doc.text('NOPAL LIFE®', W / 2, 55, { align: 'center' });
  setTxt(GOLD); doc.setFontSize(10); doc.setFont('helvetica', 'normal');
  doc.text('SKIN INTELLIGENCE™', W / 2, 65, { align: 'center' });
  doc.text('—  TECHNOLOGIE PROTÉGÉE PAR BREVET  —', W / 2, 72, { align: 'center' });

  // Ligne or
  setDraw(GOLD); doc.setLineWidth(0.5); doc.line(M + 20, 80, W - M - 20, 80);

  // Titre rapport
  setTxt(WHITE); doc.setFontSize(16); doc.setFont('helvetica', 'bold');
  doc.text('RAPPORT DIAGNOSTIC', W / 2, 100, { align: 'center' });
  doc.text('PERSONNALISÉ', W / 2, 112, { align: 'center' });

  setTxt(GOLD); doc.setFontSize(11); doc.setFont('helvetica', 'normal');
  doc.text('Votre profil cutané sur 8 dimensions', W / 2, 124, { align: 'center' });

  // Cadre client
  setFill([60, 38, 20]); doc.roundedRect(M + 15, 140, W - 2 * M - 30, 50, 3, 3, 'F');
  setTxt(GOLD); doc.setFontSize(8.5); doc.setFont('helvetica', 'normal');
  doc.text('Préparé pour', W / 2, 153, { align: 'center' });
  setTxt(WHITE); doc.setFontSize(16); doc.setFont('helvetica', 'bold');
  doc.text(prenom, W / 2, 163, { align: 'center' });
  setTxt(BLIGHT); doc.setFontSize(8.5); doc.setFont('helvetica', 'normal');
  doc.text('Type de peau : ' + skinLabel, W / 2, 172, { align: 'center' });
  doc.text('Âge cutané estimé : ' + sp.skinAge + ' ans', W / 2, 179, { align: 'center' });

  // Date
  setTxt(BLIGHT); doc.setFontSize(9);
  doc.text(today, W / 2, 210, { align: 'center' });

  // Footer p1
  setFill(GOLD); doc.rect(0, H - 2, W, 2, 'F');
  setTxt(BLIGHT); doc.setFontSize(7);
  doc.text('Ce rapport est fourni à titre indicatif et ne remplace pas un avis médical ou dermatologique.', W / 2, H - 6, { align: 'center' });

  // ══════════════════════════════════════════════════════════════════════════
  // PAGE 2 — SCORE GLOBAL + ÂGE CUTANÉ
  // ══════════════════════════════════════════════════════════════════════════
  doc.addPage();
  setFill(IVORY); doc.rect(0, 0, W, H, 'F');

  // Header
  setFill(BROWN); doc.rect(0, 0, W, 22, 'F');
  setTxt(GOLD); doc.setFontSize(8); doc.text('NOPAL LIFE', M, 10);
  setTxt(WHITE); doc.setFontSize(13); doc.setFont('helvetica', 'bold');
  doc.text('Votre Score Global', W / 2, 14, { align: 'center' });
  setTxt(BLIGHT); doc.setFontSize(7); doc.setFont('helvetica', 'normal');
  doc.text(prenom + ' • ' + today, W / 2, 20, { align: 'center' });

  // Grand score
  const scoreColor = avgScore >= 65 ? RED : avgScore >= 40 ? AMBER : GREEN;
  setFill(CREAM); doc.circle(W / 2, 62, 28, 'F');
  setFill(scoreColor); doc.circle(W / 2, 62, 24, 'F');
  setTxt(WHITE); doc.setFontSize(26); doc.setFont('helvetica', 'bold');
  doc.text(String(avgScore), W / 2, 68, { align: 'center' });
  setTxt(WHITE); doc.setFontSize(9); doc.setFont('helvetica', 'normal');
  doc.text('/100', W / 2, 76, { align: 'center' });

  // Âge cutané
  doc.setFontSize(11); setTxt(BROWN); doc.setFont('helvetica', 'bold');
  doc.text('Âge cutané estimé', W / 2, 102, { align: 'center' });
  doc.setFontSize(28); setTxt(scoreColor);
  doc.text(String(sp.skinAge) + ' ans', W / 2, 116, { align: 'center' });
  doc.setFontSize(9); setTxt(BLIGHT); doc.setFont('helvetica', 'normal');
  doc.text('vs âge chronologique : ' + sp.chronoAge + ' ans', W / 2, 124, { align: 'center' });

  const deltaMsg = sp.ageDelta > 3
    ? 'Votre peau paraît légèrement plus âgée. Un soin ciblé peut corriger cela.'
    : sp.ageDelta < -3
    ? 'Votre peau paraît plus jeune que votre âge. Continuez !'
    : 'Votre âge cutané est cohérent avec votre âge chronologique.';
  doc.setFontSize(9); setTxt(BROWN);
  wrapText(deltaMsg, M + 10, 134, W - 2 * M - 20, 5.5);

  // Type de peau
  setFill(CREAM); doc.roundedRect(M, 148, W - 2 * M, 20, 2, 2, 'F');
  setTxt(BROWN); doc.setFontSize(8); doc.setFont('helvetica', 'bold');
  doc.text('Type de peau diagnostiqué', M + 6, 156);
  doc.setFontSize(12); setTxt(GOLD);
  doc.text(skinLabel, W - M - 5, 158, { align: 'right' });
  setTxt(BLIGHT); doc.setFontSize(7.5); doc.setFont('helvetica', 'normal');
  doc.text('Préoccupation prioritaire : ' + (DIM_LABELS_PDF[sp.topConcerns[0]] || ''), M + 6, 164);

  // Texte diagnostic
  if (sp.diagnosticText) {
    doc.setFontSize(8.5); setTxt(BROWN);
    wrapText(sp.diagnosticText, M, 180, W - 2 * M, 5);
  }

  drawFooter(2);

  // ══════════════════════════════════════════════════════════════════════════
  // PAGE 3 — PROFIL 8 DIMENSIONS
  // ══════════════════════════════════════════════════════════════════════════
  doc.addPage();
  setFill(IVORY); doc.rect(0, 0, W, H, 'F');

  setFill(BROWN); doc.rect(0, 0, W, 22, 'F');
  setTxt(WHITE); doc.setFontSize(13); doc.setFont('helvetica', 'bold');
  doc.text('Profil Cutané — 8 Dimensions', W / 2, 14, { align: 'center' });
  setTxt(BLIGHT); doc.setFontSize(7); doc.setFont('helvetica', 'normal');
  doc.text(prenom + ' • ' + today, W / 2, 20, { align: 'center' });

  // Radar image (si disponible)
  let yAfterRadar = 32;
  if (radarDataUrl) {
    try {
      doc.addImage(radarDataUrl, 'PNG', W / 2 - 40, 28, 80, 80);
      yAfterRadar = 112;
    } catch(e) { yAfterRadar = 32; }
  }

  // Barres 8 dimensions
  const barX = M, barW = W - 2 * M - 25;
  const BAR_H = 6, GAP = 11;
  let by = yAfterRadar;

  doc.setFont('helvetica', 'normal');
  dims.forEach(function(d) {
    const s = scores[d] || 0;
    const lbl = DIM_LABELS_PDF[d] || d;
    drawScoreBar(barX, by, barW, BAR_H, s, lbl, true);
    by += GAP;
  });

  // Légende
  by += 3;
  setTxt(GREEN); doc.setFontSize(7); doc.text('■ < 40 : Satisfaisant', M, by);
  setTxt(AMBER); doc.text('■ 40-69 : À surveiller', M + 48, by);
  setTxt(RED);   doc.text('■ ≥ 70 : Prioritaire', M + 96, by);

  drawFooter(3);

  // ══════════════════════════════════════════════════════════════════════════
  // PAGE 4 — TOP PRÉOCCUPATIONS
  // ══════════════════════════════════════════════════════════════════════════
  doc.addPage();
  setFill(IVORY); doc.rect(0, 0, W, H, 'F');

  setFill(BROWN); doc.rect(0, 0, W, 22, 'F');
  setTxt(WHITE); doc.setFontSize(13); doc.setFont('helvetica', 'bold');
  doc.text('Vos Préoccupations Prioritaires', W / 2, 14, { align: 'center' });
  setTxt(BLIGHT); doc.setFontSize(7); doc.setFont('helvetica', 'normal');
  doc.text(prenom + ' • ' + today, W / 2, 20, { align: 'center' });

  let cy4 = 32;
  const concerns = sp.needsHighlights && sp.needsHighlights.length
    ? sp.needsHighlights.slice(0, 4)
    : (sp.topConcerns || []).slice(0, 4).map(function(k) {
        return { key: k, label: DIM_LABELS_PDF[k] || k, score: scores[k] || 50, severity: (scores[k] || 50) >= 70 ? 'high' : 'medium' };
      });

  concerns.forEach(function(h, idx) {
    const boxH = 48;
    const sColor = h.severity === 'high' ? RED : h.severity === 'medium' ? AMBER : GREEN;
    setFill(CREAM); doc.roundedRect(M, cy4, W - 2 * M, boxH, 2, 2, 'F');
    // Barre latérale couleur
    setFill(sColor); doc.roundedRect(M, cy4, 3, boxH, 1, 1, 'F');
    // Label + score
    setTxt(BROWN); doc.setFontSize(11); doc.setFont('helvetica', 'bold');
    doc.text(h.label || '', M + 8, cy4 + 9);
    setTxt(sColor); doc.setFontSize(9);
    doc.text(String(h.score || 0) + '/100', W - M - 4, cy4 + 9, { align: 'right' });
    // Barre score
    drawScoreBar(M + 8, cy4 + 12, W - 2 * M - 14, 4, h.score || 0, '', false);
    // Advice
    const ADVICES = {
      rides: 'Sérum repulpant matin + soir, massage ascendant. Résultats en 4-6 semaines.',
      relachement: 'Crème fermeté + huile figue de barbarie en dernière étape. Mouvements ascendants.',
      secheresse: 'Sérum HA multi-formes sur peau humide + huile FdB pour sceller. 2x/jour.',
      eclat: 'Vitamine C le matin + gommage doux 2x/semaine. Résultats en 2-3 semaines.',
      taches: 'Vitamine C + AHA 2x/semaine soir. Protection solaire indispensable le matin.',
      sensibilite: 'Nettoyant doux sans sulfates + huile FdB apaisante. Éviter exfoliants 4 semaines.',
      contour_yeux: 'Sérum contour des yeux matin + soir, tapotements. Massage drainant le matin.',
      pores: 'Tonique BHA 3x/semaine soir + gel hydratant léger. Résultats en 3-6 semaines.',
      peau_mature: 'Routine complète nuit + jour. Crème de nuit à la figue de Barbarie + huile FdB soir.',
    };
    const adv = ADVICES[h.key] || 'Appliquez votre routine Nopal Life matin et soir avec régularité.';
    setTxt(BROWN); doc.setFontSize(7.5); doc.setFont('helvetica', 'normal');
    wrapText('💡 ' + adv, M + 8, cy4 + 22, W - 2 * M - 14, 4.5);
    // "Refaire diagnostic"
    setTxt(GOLD); doc.setFontSize(7);
    doc.text('Refaites ce diagnostic gratuitement dans 4-6 semaines pour mesurer votre progression.', M + 8, cy4 + 44);
    cy4 += boxH + 5;
  });

  drawFooter(4);

  // ══════════════════════════════════════════════════════════════════════════
  // PAGE 5 — ROUTINE PRODUITS
  // ══════════════════════════════════════════════════════════════════════════
  doc.addPage();
  setFill(IVORY); doc.rect(0, 0, W, H, 'F');

  setFill(BROWN); doc.rect(0, 0, W, 22, 'F');
  setTxt(WHITE); doc.setFontSize(13); doc.setFont('helvetica', 'bold');
  doc.text('Votre Routine Personnalisée', W / 2, 14, { align: 'center' });
  setTxt(GOLD); doc.setFontSize(8); doc.setFont('helvetica', 'normal');
  doc.text(skinLabel + ' • ' + prenom, W / 2, 20, { align: 'center' });

  let cy5 = 30;
  // Intro
  setTxt(BROWN); doc.setFontSize(8.5);
  cy5 = wrapText('Votre routine a été composée spécifiquement pour votre type de peau par nos experts dermocosméticiens. L\'Huile de Figue de Barbarie Nopal Life est au cœur de chaque routine.', M, cy5, W - 2 * M, 5);
  cy5 += 3;

  if (prods.length === 0) {
    setTxt(BLIGHT); doc.setFontSize(9);
    doc.text('Visitez nopal-life.com pour découvrir votre routine complète.', M, cy5);
  } else {
    prods.slice(0, 6).forEach(function(p, i) {
      const prodH = 22;
      const isSignature = p.id === 'SN-HFB-15';
      setFill(isSignature ? GOLD : CREAM);
      doc.roundedRect(M, cy5, W - 2 * M, prodH, 2, 2, 'F');
      // Numéro
      setFill(isSignature ? WHITE : GOLD);
      doc.circle(M + 8, cy5 + prodH / 2, 5, 'F');
      setTxt(isSignature ? GOLD : WHITE); doc.setFontSize(8); doc.setFont('helvetica', 'bold');
      doc.text(String(i + 1), M + 8, cy5 + prodH / 2 + 1, { align: 'center' });
      // Nom produit
      setTxt(isSignature ? WHITE : BROWN);
      doc.setFontSize(9); doc.setFont('helvetica', 'bold');
      doc.text((p.shortName || p.name || '').substring(0, 45), M + 17, cy5 + 8);
      // Catégorie + prix
      setTxt(isSignature ? [255,240,200] : BLIGHT);
      doc.setFontSize(7.5); doc.setFont('helvetica', 'normal');
      doc.text((p.category || '') + ' • ' + (p.price ? p.price.toFixed(2) + ' €' : ''), M + 17, cy5 + 15);
      if (p.tagline) {
        doc.text((p.tagline || '').substring(0, 60), M + 17, cy5 + 20);
      }
      cy5 += prodH + 3;
    });
  }

  // CTA
  cy5 += 4;
  setFill(GOLD); doc.roundedRect(M, cy5, W - 2 * M, 16, 3, 3, 'F');
  setTxt(WHITE); doc.setFontSize(10); doc.setFont('helvetica', 'bold');
  doc.text('Ajouter ma routine au panier →', W / 2, cy5 + 10, { align: 'center' });
  setTxt(WHITE); doc.setFontSize(7); doc.setFont('helvetica', 'normal');
  doc.text('nopal-life.com/collections/soins-de-visage-naturels', W / 2, cy5 + 14, { align: 'center' });

  drawFooter(5);

  // ══════════════════════════════════════════════════════════════════════════
  // PAGE 6 — PROJECTIONS + CTA FINALE
  // ══════════════════════════════════════════════════════════════════════════
  doc.addPage();
  setFill(IVORY); doc.rect(0, 0, W, H, 'F');

  setFill(BROWN); doc.rect(0, 0, W, 22, 'F');
  setTxt(WHITE); doc.setFontSize(13); doc.setFont('helvetica', 'bold');
  doc.text('Projections & Évolution', W / 2, 14, { align: 'center' });
  setTxt(BLIGHT); doc.setFontSize(7); doc.setFont('helvetica', 'normal');
  doc.text(prenom + ' • ' + today, W / 2, 20, { align: 'center' });

  // Projections J30/J60/J90
  let cy6 = 32;
  setTxt(BROWN); doc.setFontSize(9); doc.setFont('helvetica', 'bold');
  doc.text('Avec votre routine Nopal Life, voici les améliorations attendues :', M, cy6);
  cy6 += 10;

  const projections = [
    { label: 'J+30', color: AMBER, title: 'Premières améliorations visibles',
      text: 'Hydratation renforcée, peau plus confortable. Éclat naturel accru. Réduction des tiraillements.' },
    { label: 'J+60', color: [180, 140, 60], title: 'Transformation progressive',
      text: 'Rides de déshydratation visiblement réduites. Teint plus uniforme. Fermeté améliorée.' },
    { label: 'J+90', color: GREEN, title: 'Résultats durables',
      text: 'Profil cutané significativement amélioré. Barrière renforcée. Résultats mesurables au diagnostic.' },
  ];

  projections.forEach(function(proj) {
    setFill(CREAM); doc.roundedRect(M, cy6, W - 2 * M, 36, 2, 2, 'F');
    setFill(proj.color); doc.roundedRect(M, cy6, 14, 36, 2, 2, 'F');
    setTxt(WHITE); doc.setFontSize(8); doc.setFont('helvetica', 'bold');
    doc.text(proj.label, M + 7, cy6 + 20, { align: 'center' });
    setTxt(BROWN); doc.setFontSize(9.5); doc.setFont('helvetica', 'bold');
    doc.text(proj.title, M + 20, cy6 + 10);
    setTxt(BROWN); doc.setFontSize(8); doc.setFont('helvetica', 'normal');
    wrapText(proj.text, M + 20, cy6 + 18, W - 2 * M - 24, 5);
    cy6 += 40;
  });

  // Invitation diagnostic de suivi
  cy6 += 5;
  setFill([240, 220, 200]); doc.roundedRect(M, cy6, W - 2 * M, 28, 3, 3, 'F');
  setTxt(BROWN); doc.setFontSize(11); doc.setFont('helvetica', 'bold');
  doc.text('📅 Refaites votre diagnostic gratuitement', M + 8, cy6 + 10);
  setTxt(BROWN); doc.setFontSize(8.5); doc.setFont('helvetica', 'normal');
  wrapText('Dans 4 à 6 semaines, repassez ce diagnostic pour mesurer objectivement l’évolution de votre peau et ajuster votre protocole selon vos progrès.', M + 8, cy6 + 18, W - 2 * M - 14, 5);
  cy6 += 33;

  // URL
  setTxt(GOLD); doc.setFontSize(9.5); doc.setFont('helvetica', 'bold');
  doc.text('nopal-life.com/pages/diagnostic', W / 2, cy6 + 8, { align: 'center' });

  // Footer final
  cy6 += 20;
  setFill(BROWN); doc.roundedRect(M, cy6, W - 2 * M, 24, 3, 3, 'F');
  setTxt(GOLD); doc.setFontSize(9); doc.setFont('helvetica', 'bold');
  doc.text('NOPAL LIFE — SKIN INTELLIGENCE™', W / 2, cy6 + 9, { align: 'center' });
  setTxt(WHITE); doc.setFontSize(7.5); doc.setFont('helvetica', 'normal');
  doc.text('Soins naturels à base de figue de barbarie • Formules 100% naturelles', W / 2, cy6 + 16, { align: 'center' });
  doc.text('nopal-life.com  •  contact@nopal-life.com', W / 2, cy6 + 21, { align: 'center' });

  drawFooter(6);

  // ── Métadonnées ─────────────────────────────────────────────────────────────
  doc.setProperties({
    title: 'Diagnostic Nopal Life — ' + prenom,
    subject: 'Rapport Skin Intelligence™ — Diagnostic cutané personnalisé',
    author: 'Nopal Life — nopal-life.com',
    creator: 'Nopal Life Skin Intelligence™',
  });

  // ── Téléchargement immédiat ────────────────────────────────────────────────
  const dateStr = new Date().toISOString().slice(0, 10).replace(/-/g, '');
  const prenomSlug = (prenom || 'diagnostic').toLowerCase()
    .normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  const filename = 'diagnostic-nopal-' + prenomSlug + '-' + dateStr + '.pdf';

  // Libérer en Blob URL (compatible tous navigateurs + Safari iOS)
  const pdfBlob = doc.output('blob');
  const blobUrl = URL.createObjectURL(pdfBlob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  setTimeout(function() {
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  }, 1000);

  // Réinitialiser le bouton
  const btn = document.getElementById('btn-download-pdf');
  if (btn) {
    btn.textContent = '↓ Télécharger mon rapport PDF (6 pages)';
    btn.disabled = false;
  }

  console.log('[Nopal Life] PDF généré : ' + filename);
}




// ──────────── js/services/diagnostic-texts.js ────────────
/**
 * NOPAL LIFE SKIN INTELLIGENCE™ — Textes de résultats enrichis
 * Rédigés par agents experts dermocosméticiens
 * Chaque dimension : 3 niveaux (low/medium/high) + conseil d'utilisation
 * Invite systématique à refaire le diagnostic dans 4-6 semaines
 */

const DIAGNOSTIC_DATA = {
  rides: {
    labelFr: 'Rides & ridules',
    low: {
      explanation: "Votre peau affiche un très bon capital jeunesse : elle présente une apparence de fermeté et de rebond, et conserve un aspect dense et tonique. Le grain de peau paraît frais et reposé, ce qui donne au visage un galbe naturel bien dessiné. C'est le moment idéal pour ancrer une routine préventive et préserver visiblement ce capital dans la durée."
    },
    medium: {
      explanation: "Des ridules de surface commencent à s'installer : la peau perd un peu de son apparence de fermeté et de rebond, et l'aspect du teint paraît moins lisse. Ce phénomène, accentué par les variations d'hydratation et l'exposition aux facteurs oxydants (UV, pollution), crée de petits plissements qui deviennent plus visibles lorsque la peau manque d'eau. Un soutien ciblé aide à atténuer l'aspect de ces ridules et à raviver le rebond visible de la peau."
    },
    high: {
      explanation: "Les rides présentes traduisent une apparence relâchée du visage : la peau a perdu une part de son aspect dense et tonique, son grain paraît moins lisse et les sillons se creusent visiblement. Cette perte de rebond et de volume apparents marque les traits. Une routine combinée — repulpante, fermeté et confort — aide à lisser l'aspect des rides et à soutenir visiblement la peau."
    },
    conseil: "Adoptez une routine en deux temps, matin et soir. Le matin, après nettoyage, appliquez un sérum concentré en actifs repulpants (huile de figue de barbarie riche en acide linoléique, vitamine E native) pour soutenir le confort de la barrière lipidique, puis scellez avec une crème de jour protectrice. Le soir, misez sur un soin de nuit nourrissant à l'aspect densifiant en massage circulaire sur les zones de tension : front, contour des yeux, plis naso-labiaux. Ajoutez un soin contour des yeux spécifique matin et soir, tapotez délicatement du coin interne vers le coin externe. Les premiers effets de rebond visible sont perceptibles dès 3 semaines ; une amélioration durable de l'aspect du galbe s'observe entre 6 et 8 semaines. Refaites votre diagnostic gratuitement dans 4 à 6 semaines pour mesurer l'évolution de votre peau et ajuster votre routine selon vos progrès."
  },

  relachement: {
    labelFr: 'Fermeté',
    low: {
      explanation: "Votre peau affiche une belle tonicité : elle présente une apparence de fermeté et de rebond optimale, et les contours du visage restent bien définis. Votre épiderme conserve cet aspect dense et tonique caractéristique d'une peau d'apparence jeune et en pleine forme. C'est un capital précieux à entretenir plutôt qu'à corriger."
    },
    medium: {
      explanation: "Votre peau commence à signaler quelques premiers signes de relâchement : elle perd un peu de son apparence de fermeté et de son rebond visible. Concrètement, l'aspect de la peau paraît moins tonique après une pression, et les contours du visage — ovale, mâchoire, zone du cou — peuvent sembler légèrement moins nets. Ce processus est naturel et, surtout, son apparence s'améliore tout à fait avec les bons actifs ciblés."
    },
    high: {
      explanation: "Le relâchement est ici perceptible : la peau a perdu une part significative de son apparence de fermeté et de son aspect dense et tonique. Le visage paraît moins soutenu, et la peau donne une impression d'affaissement visible. Les contours faciaux s'estompent et le galbe semble moins dessiné. Il est temps d'agir avec des actifs ciblés et une routine adaptée pour raviver l'aspect tonique de la peau."
    },
    conseil: "Commencez votre routine par un sérum fermeté concentré en actifs à l'effet tenseur visible — à appliquer matin et soir sur peau propre et légèrement humide, en mouvements ascendants et en insistant sur l'ovale du visage, la mâchoire et le cou. Complétez avec une crème riche en huile de figue de barbarie (riche en acide linoléique et vitamine E) pour nourrir intensément la peau et soutenir son apparence de fermeté. Pour des résultats visibles sur l'aspect tonique, comptez 6 à 8 semaines d'utilisation régulière, deux fois par jour sans interruption. Revenez refaire ce diagnostic gratuitement dans 4 à 6 semaines : c'est le meilleur moyen d'observer l'évolution réelle de votre fermeté et d'ajuster votre protocole si nécessaire."
  },

  secheresse: {
    labelFr: 'Hydratation',
    low: {
      explanation: "Votre peau présente un niveau d'hydratation optimal — son film hydrolipidique est intact et joue pleinement son rôle de bouclier protecteur. Les cellules de l'épiderme retiennent efficacement leur eau intracellulaire grâce à un bon équilibre en NMF (Natural Moisturizing Factors), ce qui se traduit par un toucher souple, un teint uniforme et une absence d'inconfort. C'est le signe d'une barrière cutanée fonctionnelle et d'une routine adaptée à vos besoins actuels."
    },
    medium: {
      explanation: "Votre peau traverse des épisodes d'inconfort — tiraillements après le nettoyage, légère sensibilité aux variations de température ou texture qui manque de souplesse. Ces signaux indiquent que votre film hydrolipidique est fragilisé : les lipides intercellulaires, notamment les céramides, ne retiennent plus l'eau avec la même efficacité, ce qui accélère la perte insensible en eau (TEWL) et crée un déficit d'hydratation dans l'épiderme. Sans rééquilibrage ciblé, cette situation peut s'installer durablement et sensibiliser davantage la peau aux agressions extérieures."
    },
    high: {
      explanation: "Votre peau exprime clairement un manque d'hydratation marqué : la barrière cutanée est fragilisée, les cornéocytes manquent de l'eau nécessaire à leur cohésion, et le grain de peau paraît moins frais. Concrètement, les lipides intercellulaires sont insuffisants pour « sceller » l'eau à l'intérieur des cellules, ce qui engendre une perte hydrique continue, une sensation de peau cartonnée ou tiraillée, et parfois de petites squames fines en apparence. Ce type de déshydratation cutanée — distinct de la sécheresse constitutionnelle — peut toucher tous les types de peau et appelle une action ciblée et régulière pour améliorer durablement son confort et son aspect."
    },
    conseil: "Commencez par un sérum hydratant concentré en acide hyaluronique (haute et basse masse moléculaire) appliqué sur peau légèrement humide matin et soir, pour un effet « éponge » immédiat et un confort durable. Superposez ensuite une crème nourrissante à l'huile de figue de barbarie — riche en acides gras essentiels (linoléique, oléique) et en phytostérols — pour soutenir la barrière et limiter l'évaporation de l'eau. Le soir, renforcez ce geste avec l'huile de figue de barbarie en dernière étape, appliquée en effleurage. Poursuivez cette routine deux fois par jour pendant 4 à 6 semaines pour retrouver un grain de peau d'aspect frais et confortable. Revenez faire votre diagnostic gratuitement dans 4 à 6 semaines pour mesurer l'évolution réelle de votre hydratation."
  },

  eclat: {
    labelFr: 'Éclat',
    low: {
      explanation: "Votre teint rayonne d'une luminosité naturelle : la surface de votre épiderme reflète la lumière de façon uniforme et votre grain de peau paraît frais et reposé. Cet éclat se traduit par un teint d'apparence renouvelée, sans accumulation visible de cellules mortes en surface, laissant la peau lisse et lumineuse. Votre barrière cutanée préserve parfaitement le capital lumineux de votre peau."
    },
    medium: {
      explanation: "Votre teint présente quelques irrégularités de luminosité : l'accumulation progressive de cellules mortes en surface diffuse la lumière de façon inégale, créant des zones ternes par endroits. Le grain de peau paraît moins frais, souvent sous l'effet du stress, de la fatigue ou des variations hormonales. Le teint peut aussi sembler moins vif, donnant à la peau un aspect fatigué par endroits."
    },
    high: {
      explanation: "Votre peau accuse une perte d'éclat significative : le teint paraît terne et brouillé, et la surface de la peau, moins lisse, reflète moins bien la lumière. Le grain de peau semble fatigué et manque de fraîcheur apparente. Ce teint grisâtre peut aussi trahir l'effet du stress oxydatif sur l'aspect de la peau : exposée aux radicaux libres, elle perd de sa vivacité visible. Une routine éclat ciblée aide à raviver l'aspect lumineux et reposé du teint."
    },
    conseil: "Commencez par un gommage doux 1 à 2 fois par semaine pour libérer la surface de l'épiderme de ses cellules mortes accumulées — résultats visibles dès 10 à 14 jours. Appliquez ensuite quotidiennement, matin et soir, un sérum à base d'huile de figue de barbarie sur peau légèrement humide, suivi d'une crème éclat nutritive qui scelle les actifs. La nuit, laissez agir un soin concentré nourrissant pour entretenir un grain de peau d'aspect frais, au moment où la peau profite le mieux du repos, entre 23h et 4h. Comptez 4 à 6 semaines pour observer une transformation réelle et durable de la luminosité. Repassez le diagnostic gratuitement à ce terme pour mesurer l'évolution de votre éclat."
  },

  taches: {
    labelFr: 'Uniformité du teint',
    low: {
      explanation: "Votre teint présente une belle homogénéité : il paraît unifié et régulier, sans zones plus marquées. Le grain de peau a un aspect frais, sans accumulation visible de cellules mortes qui terniraient l'éclat naturel de votre peau. C'est le signe d'une peau dont la barrière cutanée est saine et bien équilibrée."
    },
    medium: {
      explanation: "Votre teint révèle quelques irrégularités ponctuelles : des zones légèrement plus marquées ou moins lumineuses, dont l'apparence s'accentue souvent avec les expositions solaires, des inflammations passées ou des micro-variations hormonales. Le grain de peau paraît moins frais par endroits, où des cellules en surface reflètent moins bien la lumière. L'aspect de ces imperfections s'améliore avec un soin ciblé et régulier."
    },
    high: {
      explanation: "Votre peau présente des irrégularités de teint marquées : des zones d'apparence plus foncée se dessinent, dont l'intensité visible est entretenue par le soleil, le stress oxydatif ou des facteurs hormonaux. Le grain de peau paraît par ailleurs moins frais, ce qui accentue l'aspect de tache ou le manque d'éclat. Une approche active et progressive aide à retrouver l'apparence d'un grain de peau unifié."
    },
    conseil: "Pour aider à unifier l'apparence du teint, intégrez en priorité un sérum éclat concentré en actifs antioxydants (vitamine C stable, extraits de figue de barbarie) : appliquez-le matin sur peau nettoyée et sèche, avant votre soin hydratant, en insistant par pressions douces sur les zones concernées. Le soir, associez-lui un soin exfoliant doux (AHA légers) deux à trois fois par semaine pour entretenir un grain de peau d'aspect frais. Terminez systématiquement votre routine du matin par une protection solaire SPF 30 minimum : sans elle, les actifs éclat ne peuvent pas révéler durablement leur effet visible. Les premières améliorations de texture sont visibles dès 3 à 4 semaines. Repassez votre diagnostic gratuitement dans 4 à 6 semaines pour mesurer objectivement l'évolution de votre teint."
  },

  sensibilite: {
    labelFr: 'Sérénité cutanée',
    low: {
      explanation: "Votre peau affiche une belle tolérance : sa barrière cutanée est solide, les lipides intercellulaires assurent une cohésion optimale qui limite les agressions extérieures. Les capteurs nerveux épidermiques restent calmes face aux variations climatiques, aux actifs cosmétiques et au stress quotidien, signe d'un microbiome cutané bien équilibré. Vous pouvez sereinement intégrer des actifs concentrés dans votre routine sans craindre de réaction indésirable."
    },
    medium: {
      explanation: "Votre peau présente une sensibilité modérée : sa barrière lipidique laisse passer occasionnellement des stimuli extérieurs qui se traduisent par des rougeurs passagères, une sensation de tiraillement ou de picotement dans certaines circonstances — changements de température, certains actifs, stress. Ce terrain réactif n'est pas une fatalité, il appelle simplement une routine qui soutient le confort et l'apparence apaisée de la peau."
    },
    high: {
      explanation: "Votre peau est très réactive : le film hydrolipidique et la cohésion de la surface cutanée sont fragilisés, ce qui laisse les stimuli extérieurs déclencher facilement rougeurs persistantes, sensations de brûlure ou de chaleur. Cet état d'inconfort est souvent entretenu par un déséquilibre du microbiome cutané et un manque de céramides. Une approche apaisante ciblée aide à soutenir progressivement le confort de la peau et à retrouver une apparence sereine et durable."
    },
    conseil: "Débutez avec un nettoyant doux sans sulfates, suivi immédiatement d'un soin apaisant concentré en huile de figue de barbarie — ses phytostérols et ses acides gras essentiels (acide linoléique) comblent les espaces intercellulaires et soutiennent le confort de la barrière lipidique. Appliquez matin et soir, en couche généreuse sur peau encore légèrement humide pour favoriser la pénétration. Les premières semaines, évitez tout exfoliant et réduisez les actifs irritants (rétinol, AHA). Des résultats visibles — peau d'aspect moins rouge, moins réactive — sont généralement perceptibles entre 4 et 6 semaines de régularité. Refaites ce diagnostic gratuitement dans 4 à 6 semaines pour mesurer l'évolution de votre score."
  },

  contour_yeux: {
    labelFr: 'Contour des yeux',
    low: {
      explanation: "Votre contour des yeux présente une belle fraîcheur : le regard paraît reposé, la peau de cette zone conserve une apparence souple et lumineuse. La peau particulièrement fine de cette zone — jusqu'à cinq fois plus mince qu'ailleurs sur le visage — ne montre ni cernes marqués ni poches visibles. C'est le signe d'un contour de l'œil d'aspect tonique, au galbe naturel bien préservé."
    },
    medium: {
      explanation: "Votre contour des yeux envoie quelques signaux de fatigue : la peau fine de cette zone laisse transparaître des cernes bleutés ou rosés, et de petites poches passagères peuvent apparaître au réveil. Un grain de peau qui paraît moins frais et une hydratation insuffisante donnent à cette zone un aspect plus translucide et moins tonique. Ces signes s'atténuent : ils indiquent simplement que cette zone a besoin d'une attention ciblée et régulière."
    },
    high: {
      explanation: "La zone du contour des yeux exprime une fatigue cutanée marquée : le regard paraît terne, avec des cernes persistants, des poches installées et des ridules fines visibles. La peau particulièrement fine de ce périmètre manque de lipides et de soutien apparent, ce qui amplifie l'aspect creux ou gonflé selon les jours. Un protocole ciblé et assidu aide à raviver l'apparence fraîche et reposée du regard."
    },
    conseil: "Intégrez un soin contour des yeux riche en actifs drainants et repulpants (acide hyaluronique fragmenté, caféine, huile de figue de barbarie pour ses omégas 6 et vitamine E). Appliquez-le matin et soir après votre sérum, avant votre crème visage : déposez une noisette sur l'annulaire et tapotez délicatement de l'angle interne vers l'angle externe, sans frotter. Le matin, associez-le à un massage drainant de deux minutes (petits cercles vers la tempe) pour activer la lymphe et réduire les poches. Comptez 4 à 6 semaines d'application biquotidienne pour observer une vraie différence visible. Revenez refaire votre diagnostic gratuitement dans 4 à 6 semaines pour mesurer objectivement les progrès de votre regard."
  },

  pores: {
    labelFr: 'Pores & Texture',
    low: {
      explanation: "Votre grain de peau est fin et vos pores sont peu visibles : la peau présente un aspect lisse et net, sans zones brillantes marquées. Le grain de peau paraît régulier et reposé, sans pores congestionnés. C'est un capital cutané précieux à préserver en maintenant un rituel doux et protecteur."
    },
    medium: {
      explanation: "Vos pores sont modérément visibles et la texture de votre peau présente quelques irrégularités localisées, souvent sur la zone T ou les joues. Le grain de peau y paraît irrégulier en apparence, avec des zones plus brillantes par endroits qui rendent les pores plus apparents. Un gommage régulier et un soin matifiant aident efficacement à affiner l'aspect de la peau en quelques semaines."
    },
    high: {
      explanation: "Vos pores sont nettement dilatés et la texture de votre peau manque d'uniformité : le grain de peau paraît irrégulier en apparence, et les zones brillantes accentuent visiblement la taille des pores. La peau, moins tonique en apparence autour des pores, semble plus marquée. Ce déséquilibre s'installe sur la durée mais répond très bien à un protocole ciblé et régulier incluant exfoliation et actifs à l'effet resserrant visible."
    },
    conseil: "Pour affiner visiblement l'aspect des pores et lisser la texture, adoptez ce protocole en 3 étapes : (1) deux fois par semaine le soir, appliquez un exfoliant doux à l'acide lactique ou à la poudre de figue de barbarie pour libérer les pores des résidus en surface ; (2) chaque matin, après nettoyage, utilisez un sérum ou gel léger à base d'extrait de figue de barbarie pour aider à matifier l'apparence et affiner le grain de peau ; (3) terminez par une crème matifiante non comédogène. La cohérence est clé : les premiers résultats sur l'aspect des pores se manifestent généralement entre la 3e et la 6e semaine. Repassez votre diagnostic gratuitement dans 4 à 6 semaines pour mesurer l'évolution réelle de votre texture."
  },

  peau_mature: {
    labelFr: 'Âge cutané',
    low: {
      explanation: "Votre âge cutané est en cohérence avec votre âge chronologique, voire plus jeune : votre peau présente une apparence dense et tonique, au capital jeunesse visible bien préservé. Votre routine actuelle protège efficacement cet aspect jeune contre les principaux facteurs qui marquent la peau (UV, stress oxydatif, déshydratation). Continuez sur cette lancée en intégrant des actifs préventifs ciblés."
    },
    medium: {
      explanation: "Votre âge cutané commence à dépasser légèrement votre âge chronologique : la peau perd progressivement de son apparence de fermeté et de rebond, paraît un peu moins repulpée et son grain semble moins frais. Ces évolutions visibles se combinent aux agressions extérieures (soleil, pollution) pour accentuer les signes apparents du temps. Une action préventive et ciblée aide significativement à préserver le capital jeunesse visible."
    },
    high: {
      explanation: "Votre peau présente un âge cutané perceptiblement supérieur à votre âge chronologique : les signes visibles d'une peau mature — perte d'apparence dense et tonique, rides installées, relâchement apparent du contour — marquent les traits. La peau paraît moins repulpée et son galbe semble moins dessiné. Une routine structurée et intensive, avec des actifs anti-âge ciblés, aide à apporter une amélioration visible de l'aspect de la peau en quelques semaines."
    },
    conseil: "Pour aider à réduire l'écart d'apparence entre âge cutané et âge chronologique, structurez votre routine autour de trois piliers : (1) nutrition intense avec l'huile de figue de barbarie appliquée chaque soir en dernière étape (ses acides gras et sa vitamine E nourrissent intensément la peau) ; (2) soutien de l'apparence repulpée avec un sérum repulpant matin et soir avant la crème ; (3) soin de nuit nourrissant appliqué en mouvements ascendants sur visage et cou. Soyez régulière : des résultats visibles sur l'aspect dense et le galbe s'observent entre 6 et 10 semaines. Refaites votre diagnostic gratuitement dans 4 à 6 semaines pour mesurer objectivement l'évolution de votre âge cutané."
  }
};

// ─── TITRES PAR DIMENSION ET NIVEAU ──────────────────────────────────────────
const LEVEL_TITLES = {
  rides:        { low: 'Capital jeunesse préservé',      medium: 'Premières ridules à traiter',        high: 'Rides installées à corriger' },
  relachement:  { low: 'Tonicité optimale',              medium: 'Relâchement débutant',               high: 'Relâchement cutané marqué' },
  secheresse:   { low: 'Hydratation optimale',           medium: 'Hydratation fragilisée',             high: 'Déshydratation profonde' },
  eclat:        { low: 'Teint lumineux',                 medium: 'Éclat à raviver',                    high: "Perte d'éclat significative" },
  taches:       { low: 'Teint homogène',                 medium: 'Irrégularités ponctuelles',          high: 'Irrégularités marquées' },
  sensibilite:  { low: 'Peau tolérante',                 medium: 'Sensibilité modérée',                high: 'Peau très réactive' },
  contour_yeux: { low: 'Regard frais et reposé',         medium: 'Signes de fatigue oculaire',         high: 'Fatigue du contour des yeux marquée' },
  pores:        { low: 'Grain de peau fin',              medium: 'Pores visibles localement',          high: 'Pores dilatés et texture irrégulière' },
  peau_mature:  { low: 'Âge cutané favorable',           medium: 'Premiers signes du temps',           high: 'Vieillissement cutané avancé' },
};

function _getScoreLevel(score) {
  if (score < 40) return 'low';
  if (score < 70) return 'medium';
  return 'high';
}

/**
 * Retourne les textes enrichis pour une dimension et un score donné.
 * @param {string} dimension  - Clé de dimension ('rides', 'relachement', etc.)
 * @param {number} score      - Score de 0 à 100
 * @returns {{ title: string, explanation: string, conseil: string } | null}
 */
function getDiagnosticText(dimension, score) {
  const data = DIAGNOSTIC_DATA[dimension];
  if (!data) {
    console.warn(`[getDiagnosticText] Dimension inconnue : "${dimension}"`);
    return null;
  }
  const level = _getScoreLevel(score);
  return {
    title:       (LEVEL_TITLES[dimension] || {})[level] || data.labelFr,
    explanation: data[level].explanation,
    conseil:     data.conseil,
    level,
  };
}

/**
 * Retourne un texte de synthèse personnalisé 2-3 phrases.
 * @param {Object} profile - Objet { skinType, skinAge, chronoAge, topConcerns, scores }
 * @returns {string}
 */
function getDiagnosticSummary(profile) {
  if (!profile) return '';

  const { skinType, skinAge, chronoAge, topConcerns, scores } = profile;
  const ageDelta = skinAge - chronoAge;

  const skinTypeLabels = {
    peau_mature: 'mature', peau_seche: 'sèche', peau_grasse: 'grasse',
    peau_sensible: 'sensible', eclat: 'en quête d\'éclat', peau_deshydratee: 'déshydratée',
    seche: 'sèche', normale: 'normale', mixte: 'mixte', grasse: 'grasse', sensible: 'sensible',
  };

  const DIMENSION_LABELS_FR = {
    rides: 'rides & ridules', relachement: 'fermeté', secheresse: 'hydratation',
    eclat: 'éclat', taches: 'uniformité du teint', sensibilite: 'sérénité cutanée',
    contour_yeux: 'contour des yeux', pores: 'pores & texture', peau_mature: 'âge cutané',
  };

  const skinLabel = skinTypeLabels[skinType] || skinType;
  const concern1 = DIMENSION_LABELS_FR[topConcerns?.[0]] || '';
  const concern2 = DIMENSION_LABELS_FR[topConcerns?.[1]] || '';
  const concernText = concern1 && concern2
    ? `${concern1} et ${concern2}`
    : concern1 || 'vos préoccupations prioritaires';

  let agePhrase = '';
  if (ageDelta > 3) {
    agePhrase = `Votre peau paraît légèrement plus âgée que votre âge chronologique (${chronoAge} ans) — un soin ciblé et régulier peut corriger cela visiblement.`;
  } else if (ageDelta < -3) {
    agePhrase = `Bonne nouvelle : votre peau paraît plus jeune que votre âge chronologique (${chronoAge} ans). Continuez sur cette lancée avec une routine préventive adaptée.`;
  } else {
    agePhrase = `Votre âge cutané (${skinAge} ans) est cohérent avec votre âge chronologique (${chronoAge} ans).`;
  }

  const avgScore = scores
    ? Math.round(Object.values(scores).reduce((a, b) => a + b, 0) / Object.values(scores).length)
    : 50;

  let action = '';
  if (avgScore >= 65) {
    action = `Votre peau ${skinLabel} appelle une action prioritaire sur ${concernText} — une routine structurée deux fois par jour produira des améliorations visibles dès 4 à 6 semaines.`;
  } else if (avgScore >= 40) {
    action = `Votre peau ${skinLabel} bénéficiera d'actifs ciblés sur ${concernText} pour révéler tout son potentiel.`;
  } else {
    action = `Votre peau ${skinLabel} est en belle forme — concentrez-vous sur ${concernText} pour en préserver le capital durablement.`;
  }

  return `${agePhrase} ${action} Revenez refaire ce diagnostic gratuitement dans 4 à 6 semaines pour mesurer objectivement l'évolution de votre peau et ajuster votre routine selon vos progrès.`;
}



// ──────────── js/app.js ────────────
/**
 * NOPAL LIFE — Contrôleur Principal SPA
 * Orchestre les 6 étapes du diagnostic cutané
 * Gère l'état global, les transitions, et la collecte de données
 */



// buildRoutines supprimé — remplacé par getRoutineAdvice






// PDF supprimé — envoi par email uniquement

// ─── ÉTAT GLOBAL ───────────────────────────────────────────────────────────
const STATE = {
  step: 'landing',
  userData: { firstName: '', email: '', consent: false, marketingConsent: false },
  captureData: null,
  answers: {},
  currentQuestion: 0,
  profile: null,
  previousProfile: null,   // Diagnostic J0 précédent (pour J30/J60)
  diagnosticStage: 'J0',   // J0 | J30 | J60
  cameraAvailable: false,
  scanSkipped: false
};

// ─── NAVIGATION ────────────────────────────────────────────────────────────
function goToStep(stepName) {
  const current = document.getElementById(`step-${STATE.step}`);
  const next = document.getElementById(`step-${stepName}`);
  if (!next) return;

  if (current) {
    current.classList.add('step-exit');
    setTimeout(() => {
      current.classList.remove('active', 'step-exit');
    }, 400);
  }

  setTimeout(() => {
    next.classList.add('active');
    STATE.step = stepName;
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Panneaux latéraux : visibles uniquement sur landing
    const wrapper = document.getElementById('nopal-wrapper');
    if (wrapper) wrapper.classList.toggle('landing-active', stepName === 'landing');

    // Actions spécifiques à chaque étape
    if (stepName === 'scan') initScanStep();
    if (stepName === 'questionnaire') initQuestionnaireStep();
    if (stepName === 'processing') runProcessingStep();
  }, 200);
}

// ─── ÉTAPE : LANDING ──────────────────────────────────────────────────────
function initLanding() {
  document.getElementById('btn-start').addEventListener('click', () => {
    goToStep('consent');
  });
}

// ─── ÉTAPE : CONSENTEMENT ─────────────────────────────────────────────────
function initConsent() {
  const form = document.getElementById('consent-form');
  const btnConsent = document.getElementById('btn-consent');

  function checkConsent() {
    const firstName = document.getElementById('input-firstname').value.trim();
    const email = document.getElementById('input-email').value.trim();
    const consent = document.getElementById('check-consent').checked;
    btnConsent.disabled = !(firstName && email && consent && isValidEmail(email));
  }

  form.querySelectorAll('input').forEach(el => el.addEventListener('input', checkConsent));
  document.getElementById('check-consent').addEventListener('change', checkConsent);

  btnConsent.addEventListener('click', () => {
    STATE.userData.firstName = document.getElementById('input-firstname').value.trim();
    STATE.userData.email = document.getElementById('input-email').value.trim();
    STATE.userData.consent = true;
    // Opt-in marketing : optionnel — conditionne l'abonnement Klaviyo
    const optinEl = document.getElementById('check-optin-marketing');
    STATE.userData.marketingConsent = optinEl ? optinEl.checked : false;

    // Caméra activée — NOPAL LIFE SKIN INTELLIGENCE™
    STATE.cameraAvailable = true;
    STATE.scanSkipped = false;
    STATE.captureData = null;

    // Précharger face-api.js en arrière-plan pendant le consentement
    // La cliente remplit le formulaire ~30s → temps idéal pour charger les modèles IA
    FaceAnalyzer.init().catch(() => {}); // silencieux si CDN indisponible

    goToStep('scan');
  });
}

// ─── ÉTAPE : SCAN ─────────────────────────────────────────────────────────
async function initScanStep() {
  const videoEl = document.getElementById('scan-video');
  const canvasEl = document.getElementById('scan-canvas');
  const guidanceEl = document.getElementById('scan-guidance');
  const btnCapture = document.getElementById('btn-capture');
  const btnSkip = document.getElementById('btn-skip-scan');
  const statusEl = document.getElementById('scan-status');

  // Toujours attacher le skip listener avant tout return
  btnSkip.addEventListener('click', () => {
    FaceAnalyzer.stopCamera();
    STATE.scanSkipped = true;
    STATE.captureData = { faceData: { simulated: true } };
    goToStep('questionnaire');
  });

  if (!STATE.cameraAvailable) {
    statusEl.textContent = 'Caméra non disponible — nous utiliserons votre questionnaire pour votre diagnostic.';
    btnCapture.style.display = 'none';
    document.getElementById('scan-camera-area').style.display = 'none';
    document.getElementById('scan-no-camera').style.display = 'flex';
    return;
  }

  statusEl.textContent = 'Chargement des modèles IA…';
  const modelOk = await FaceAnalyzer.init();

  const camOk = await FaceAnalyzer.startCamera(videoEl);
  if (!camOk) {
    statusEl.textContent = 'Accès caméra refusé. Continuez avec le questionnaire.';
    document.getElementById('scan-no-camera').style.display = 'flex';
    return;
  }

  statusEl.textContent = modelOk
    ? 'Centrez votre visage dans le cadre'
    : 'Modèles IA en cours de chargement…';

  if (modelOk) {
    FaceAnalyzer.startGuidanceLoop(videoEl, canvasEl, guidanceEl, onCaptureComplete);
  }

  btnCapture.addEventListener('click', () => {
    FaceAnalyzer.captureManual(videoEl);
    btnCapture.disabled = true;
    btnCapture.textContent = 'Capture en cours…';
  });

}

function onCaptureComplete(data) {
  STATE.captureData = data;

  // Feedback visuel de capture
  const flash = document.getElementById('scan-flash');
  if (flash) {
    flash.style.opacity = '1';
    setTimeout(() => { flash.style.opacity = '0'; }, 200);
  }

  setTimeout(() => {
    // Afficher aperçu de la photo capturée
    const preview = document.getElementById('scan-preview');
    if (preview && data.imageDataUrl) {
      preview.src = data.imageDataUrl;
      preview.style.display = 'block';
    }
    document.getElementById('scan-camera-area').style.display = 'none';
    document.getElementById('scan-success').style.display = 'flex';
  }, 300);

  setTimeout(() => goToStep('questionnaire'), 1800);
}

// ─── ÉTAPE : QUESTIONNAIRE ────────────────────────────────────────────────
function initQuestionnaireStep() {
  STATE.currentQuestion = 0;
  STATE.answers = {};
  renderQuestion(0);
}

function renderQuestion(index) {
  const questions = getActiveQuestions(STATE.answers);
  if (index >= questions.length) {
    goToStep('processing');
    return;
  }

  const q = questions[index];
  const total = questions.length;
  const progress = ((index) / total) * 100;

  // Progress bar
  document.getElementById('q-progress-bar').style.width = `${progress}%`;
  document.getElementById('q-counter').textContent = `${index + 1} / ${total}`;

  const container = document.getElementById('question-container');
  container.classList.add('q-fade-out');

  setTimeout(() => {
    container.innerHTML = buildQuestionHTML(q, index);
    container.classList.remove('q-fade-out');
    container.classList.add('q-fade-in');
    setTimeout(() => container.classList.remove('q-fade-in'), 400);

    // Attacher les listeners selon le type
    if (q.type === 'single') attachSingleListeners(q, index, total);
    else if (q.type === 'multi') attachMultiListeners(q, index, total);
    else if (q.type === 'scale') attachScaleListeners(q, index, total);
  }, 200);
}

function buildQuestionHTML(q, index) {
  const isFinal = index === getActiveQuestions(STATE.answers).length - 1;
  let optionsHTML = '';

  if (q.type === 'single') {
    optionsHTML = q.options.map(o => `
      <button class="q-option" data-value="${o.value}">
        ${o.icon ? `<span class="q-opt-icon">${o.icon}</span>` : ''}
        <div class="q-opt-text">
          <span class="q-opt-label">${o.label}</span>
          ${o.description ? `<span class="q-opt-desc">${o.description}</span>` : ''}
        </div>
      </button>
    `).join('');
  } else if (q.type === 'multi') {
    // Pour les questions non-required, le bouton est actif dès le départ (0 sélection = valide)
    const confirmInitiallyDisabled = q.required !== false;
    optionsHTML = `
      <div class="q-multi-grid">
        ${q.options.map(o => `
          <button class="q-chip" data-value="${o.value}">
            ${o.icon ? `<span>${o.icon}</span>` : ''}
            <span>${o.label}</span>
          </button>
        `).join('')}
      </div>
      <button class="btn-primary q-multi-confirm" id="btn-q-confirm"${confirmInitiallyDisabled ? ' disabled' : ''}>
        ${isFinal ? 'Analyser ma peau →' : 'Continuer →'}
      </button>
    `;
  } else if (q.type === 'scale') {
    optionsHTML = `
      <div class="q-scale">
        ${[1, 2, 3, 4, 5].map(v => `
          <button class="q-scale-btn" data-value="${v}">
            <span class="q-scale-num">${v}</span>
          </button>
        `).join('')}
      </div>
      <div class="q-scale-labels">
        <span>${(q.labels[1] || '').replace(/\n/g, '<br>')}</span>
        <span>${(q.labels[3] || '').replace(/\n/g, '<br>')}</span>
        <span>${(q.labels[5] || '').replace(/\n/g, '<br>')}</span>
      </div>
    `;
  }

  return `
    <div class="q-header">
      <span class="q-icon">${q.icon || '◈'}</span>
      <h2 class="q-title">${q.question}</h2>
      ${q.subtext ? `<p class="q-subtext">${q.subtext}</p>` : ''}
    </div>
    <div class="q-options">${optionsHTML}</div>
    ${!q.required ? `<button class="btn-skip-q" id="btn-skip-q">Passer cette question</button>` : ''}
  `;
}

function attachSingleListeners(q, index) {
  document.querySelectorAll('.q-option').forEach(btn => {
    btn.addEventListener('click', () => {
      STATE.answers[q.id] = btn.dataset.value;
      btn.classList.add('selected');
      setTimeout(() => {
        STATE.currentQuestion = index + 1;
        renderQuestion(STATE.currentQuestion);
      }, 350);
    });
  });
  attachSkipListener(q, index);
}

function attachMultiListeners(q, index) {
  const chips = document.querySelectorAll('.q-chip');
  const confirmBtn = document.getElementById('btn-q-confirm');

  // Pour les questions non-required : 0 sélection est une réponse valide
  const minRequired = q.required !== false ? 1 : 0;

  chips.forEach(chip => {
    chip.addEventListener('click', () => {
      const val = chip.dataset.value;
      let selected = STATE.answers[q.id] || [];

      if (chip.classList.contains('selected')) {
        chip.classList.remove('selected');
        selected = selected.filter(v => v !== val);
      } else {
        if (selected.length >= q.maxSelect) {
          // Retirer le premier chip sélectionné (FIFO) pour rester dans la limite
          chips.forEach(c => { if (c.dataset.value === selected[0]) c.classList.remove('selected'); });
          selected = selected.slice(1);
        }
        chip.classList.add('selected');
        selected.push(val);
      }
      STATE.answers[q.id] = selected;
      // Activer si assez de sélections (ou question non-required avec 0 sélection OK)
      confirmBtn.disabled = selected.length < minRequired;
    });
  });

  confirmBtn.addEventListener('click', () => {
    // Avancer si : question non-required (0 sélection OK) OU au moins 1 sélectionné
    const hasEnough = (STATE.answers[q.id] || []).length >= minRequired;
    if (hasEnough) {
      STATE.currentQuestion = index + 1;
      renderQuestion(STATE.currentQuestion);
    }
  });

  attachSkipListener(q, index);
}

function attachScaleListeners(q, index) {
  document.querySelectorAll('.q-scale-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.q-scale-btn').forEach(b => b.classList.remove('selected'));
      btn.classList.add('selected');
      STATE.answers[q.id] = parseInt(btn.dataset.value);
      setTimeout(() => {
        STATE.currentQuestion = index + 1;
        renderQuestion(STATE.currentQuestion);
      }, 350);
    });
  });
  attachSkipListener(q, index);
}

function attachSkipListener(q, index) {
  const skipBtn = document.getElementById('btn-skip-q');
  if (skipBtn) {
    skipBtn.addEventListener('click', () => {
      STATE.currentQuestion = index + 1;
      renderQuestion(STATE.currentQuestion);
    });
  }
}

// ─── ÉTAPE : TRAITEMENT ───────────────────────────────────────────────────
async function runProcessingStep() {
  const firstName = STATE.userData.firstName || 'vous';
  const messages = [
    { text: 'Analyse des zones de fermeté…', delay: 0 },
    { text: 'Détection des rides et marqueurs cutanés…', delay: 1000 },
    { text: 'Calcul de votre score d\'hydratation…', delay: 2000 },
    { text: 'Cartographie de vos zones prioritaires…', delay: 3000 },
    { text: 'Croisement avec votre questionnaire…', delay: 4200 },
    { text: 'Sélection des actifs botaniques adaptés à votre profil…', delay: 5200 },
    { text: `${firstName.charAt(0).toUpperCase()+firstName.slice(1)}, votre rapport de 6 pages est prêt ✦`, delay: 6400 }
  ];

  const msgEl = document.getElementById('processing-message');
  const progressEl = document.getElementById('processing-progress');
  const rapportPreview = document.getElementById('processing-rapport-preview');

  messages.forEach(({ text, delay }, i) => {
    setTimeout(() => {
      if (msgEl) msgEl.textContent = text;
      if (progressEl) progressEl.style.width = `${((i + 1) / messages.length) * 100}%`;
      // Afficher l'aperçu du rapport à 70%
      if (i === 5 && rapportPreview) rapportPreview.style.display = 'block';
    }, delay);
  });

  // Calcul réel
  setTimeout(() => {
    try {
      const faceData = STATE.captureData?.faceData || { simulated: true };
      const ageRangeHint = STATE.answers.q2_age_range === '56_plus' ? 85
        : STATE.answers.q2_age_range === '49_55' ? 70
        : STATE.answers.q2_age_range === '41_48' ? 55 : 40;

      if (faceData.simulated) faceData.ageRangeHint = ageRangeHint;

      const visualScores = computeVisualScores(faceData);
      const questionnaireScores = computeQuestionnaireScores(STATE.answers);
      STATE.profile = buildFinalProfile(visualScores, questionnaireScores, STATE.answers);

      // Générer le texte de diagnostic
      STATE.profile.diagnosticText = generateDiagnosticText(STATE.profile);

      // Calculer l'amélioration si retour J30/J60
      if (STATE.previousProfile) {
        STATE.profile.improvement = LongitudinalTracker.computeImprovement(
          STATE.profile.scores,
          STATE.previousProfile.scores
        );
        STATE.profile.progressText = LongitudinalTracker.generateProgressText(
          STATE.profile.improvement,
          STATE.diagnosticStage
        );
      }

      // Top produits pour les intégrations
      const topProductsForIntegrations = getTopProducts(STATE.profile, 4);

      // Lancer toutes les intégrations en arrière-plan (non bloquant)
      runPostDiagnosticIntegrations(
        STATE.profile,
        STATE.userData,
        STATE.answers,
        topProductsForIntegrations,
        STATE.captureData?.faceData?.simulated ? 'questionnaire_only' : 'visual'
      );

      // Collecte locale (fallback)
      collectDiagnosticData(STATE.profile, STATE.userData, STATE.answers);
      setTimeout(() => goToStep('results'), 500);
    } catch (err) {
      console.error('[Nopal Diagnostic] Erreur scoring:', err);
      // Fallback: profil par défaut pour ne pas bloquer l'utilisateur
      STATE.profile = buildFinalProfile(
        { rides: 60, relachement: 55, secheresse: 65, eclat: 50, taches: 45, sensibilite: 40, contour_yeux: 55, peau_mature: 60 },
        { rides: 60, relachement: 55, secheresse: 65, eclat: 50, taches: 45, sensibilite: 40, contour_yeux: 55, peau_mature: 60 },
        STATE.answers
      );
      setTimeout(() => goToStep('results'), 500);
    }
  }, 7500);
}

// ─── ÉTAPE : RÉSULTATS ────────────────────────────────────────────────────
function initResultsStep() {
  if (STATE._resultsInited) return; // Garde contre double init
  STATE._resultsInited = true;
  const profile = STATE.profile;
  if (!profile) return;

  const firstName = STATE.userData.firstName || 'vous';
  const diagnosticText = generateDiagnosticText(profile);

  // ─── KIT ROUTINE (source de vérité boutique) ────────────────────────────
  // Le profil détecté → objectif → kit boutique (titre EXACT + variants).
  // L'achat = CE kit (1 produit, prix remisé du bundle). Niveau par défaut = 'ciblee' (⭐).
  // Si l'UI propose un sélecteur de niveau (data-kit-level), il surcharge ce défaut.
  const kit = getKitForGoal(profile.skinType);
  const kitLevel = (STATE.kitLevel && kit.variants[STATE.kitLevel]) ? STATE.kitLevel : 'ciblee';
  STATE.kitLevel = kitLevel;

  // En-tête personnalisé
  document.getElementById('results-greeting').textContent =
    `${firstName.charAt(0).toUpperCase() + firstName.slice(1)}, votre diagnostic est prêt`;

  // Texte de diagnostic
  document.getElementById('results-diagnostic-text').textContent = diagnosticText;

  // Âge cutané
  const { skinAge, chronoAge, ageDelta } = profile;
  document.getElementById('results-skin-age').textContent = `${skinAge} ans`;
  document.getElementById('results-chrono-age').textContent = `Âge chronologique : ${chronoAge} ans`;
  document.getElementById('results-age-delta').textContent = ageDelta > 2
    ? `+${ageDelta} ans — votre peau peut être rajeunie`
    : ageDelta < -2
    ? `${ageDelta} ans — votre peau paraît plus jeune !`
    : 'Peau en cohérence avec votre âge';
  document.getElementById('results-age-delta').className = `age-delta ${ageDelta > 2 ? 'delta-positive' : ageDelta < -2 ? 'delta-negative' : 'delta-neutral'}`;

  // Radar chart premium 8 dimensions
  injectRadarStyles();
  buildRadarComponent('results-radar-container', profile.scores, profile);

  // Top préoccupations
  renderTopConcerns(profile.needsHighlights);

  // Cartographie cutanée (heatmap) — uniquement si capture visuelle disponible
  const captureImg = STATE.captureData?.imageDataUrl;
  const landmarks  = STATE.captureData?.faceData?.landmarks;  // face-api.js landmarks object
  if (captureImg && landmarks && landmarks.positions) {
    injectHeatmapStyles();
    // Créer un canvas temporaire pour l'analyse pixelométrique
    const tmpImg    = new Image();
    tmpImg.src      = captureImg;
    tmpImg.onload   = () => {
      const tmpCanvas = document.createElement('canvas');
      tmpCanvas.width  = tmpImg.naturalWidth;
      tmpCanvas.height = tmpImg.naturalHeight;
      tmpCanvas.getContext('2d').drawImage(tmpImg, 0, 0);
      const mapper   = new FaceZoneMapper(tmpCanvas, landmarks);
      const zoneData = mapper.analyzeAllZones();
      buildHeatmapComponent('results-heatmap-container', captureImg, zoneData);
    };
  }

  // Heatmap — si pas de scan, afficher note
  if (!STATE.captureData?.imageDataUrl) {
    const note = document.getElementById('heatmap-note-no-scan');
    if (note) note.style.display = 'block';
    // Heatmap simulée depuis les scores (sans photo)
    injectHeatmapStyles();
    buildHeatmapComponent('results-heatmap-container', null, buildSimulatedZoneData(profile.scores));
  }

  // 4 produits exactement : Huile FdB (fixe) + 3 produits variables selon routine
  const topProducts = enrichProducts(getTopProducts(profile, 4));
  renderProducts(topProducts);

  // Titre de composition = TITRE EXACT du kit boutique (source de vérité)
  const labelEl = document.getElementById('routine-skin-type-label');
  if (labelEl) {
    labelEl.textContent = kit.title + ' · ' + topProducts.length + ' soins dont l\'Huile de Figue de Barbarie · validée par nos experts';
  }

  // Conseil d'utilisation de la routine (texte expert) — titré avec le kit exact
  const routineAdvice = getRoutineAdvice(profile.skinType);
  renderRoutineAdvice(routineAdvice, profile.skinType, kit.title);

  // Résumé global enrichi
  const summaryEl = document.getElementById('results-diagnostic-text');
  if (summaryEl) {
    summaryEl.textContent = getDiagnosticSummary(profile);
  }

  // Routines AM/PM supprimées — remplacées par renderRoutineAdvice() ci-dessus

  // Récap prix routine — libellé = titre exact du kit
  renderPriceRecap(topProducts, kit.title);

  // Projections J30/J60/J90
  renderProjections(profile);

  // Section progression J30/J60
  if (STATE.previousProfile && STATE.profile.improvement) {
    renderProgressComparison(STATE.profile.improvement, STATE.diagnosticStage);
  }

  // CTA — Ajouter LE KIT ROUTINE (1 produit, prix remisé du bundle) au panier Shopify
  const btnShop = document.getElementById('btn-shop-all');
  if (btnShop) {
    // Remplacer le lien par un vrai ajout au panier
    btnShop.removeAttribute('href');
    btnShop.tagName === 'A' && btnShop.setAttribute('href', '#');
    btnShop.addEventListener('click', async function(e) {
      e.preventDefault();
      const originalText = btnShop.textContent;
      btnShop.textContent = 'Ajout en cours…';
      btnShop.style.opacity = '0.7';
      btnShop.style.pointerEvents = 'none';

      // Ajoute le KIT du bon objectif + niveau choisi (défaut 'ciblee' ⭐)
      const result = await addKitToCart(profile.skinType, STATE.kitLevel);

      if (result.success) {
        btnShop.textContent = '✓ ' + kit.title + ' ajoutée !';
        btnShop.style.opacity = '1';
        btnShop.style.background = 'linear-gradient(135deg,#5B9E6B,#3D7A4E)';
        // Rediriger vers le panier après 1.5s
        setTimeout(function() {
          window.location.href = '/cart';
        }, 1500);
      } else {
        // Fallback : aller à la fiche du kit si l'API échoue (hors Shopify / local)
        window.location.href = 'https://nopal-life.com/products/' + kit.handle;
      }
    });
  }
  document.getElementById('btn-redo').addEventListener('click', restartDiagnostic);

  // Bouton "Renvoyer" (discret, sous confirmation)
  const btnResend = document.getElementById('btn-email-results');
  if (btnResend) btnResend.addEventListener('click', () => sendResultsByEmail());

  // Afficher la confirmation d'envoi email avec l'adresse de la cliente
  const confirmBlock = document.getElementById('email-confirm-block');
  const confirmText  = document.getElementById('email-confirm-text');
  if (confirmBlock && STATE.userData.email && STATE.userData.email !== 'anonyme@nopal-life.com') {
    const emailDisplay = STATE.userData.email;
    if (confirmText) confirmText.textContent = `✓ Vos résultats ont été envoyés à ${emailDisplay}`;
    confirmBlock.style.display = 'flex';
  }

  // Animer les blocs résultats au scroll
  initResultsReveal();

  // Animer les barres de préoccupations après affichage
  setTimeout(() => animateConcernBars(), 400);
}

// ─── HEATMAP SIMULÉE (sans photo) ──────────────────────────────────────────
function buildSimulatedZoneData(scores) {
  // Mappe les dimensions aux zones du visage
  return {
    forehead: { score: Math.round((scores.rides + scores.peau_mature) / 2), label: 'Front', metrics: { brightness: 65, redness: 25, textureVariance: scores.rides / 2, uniformity: 75 } },
    eye_area: { score: Math.round((scores.contour_yeux + scores.relachement) / 2), label: 'Contour yeux', metrics: { brightness: 55, redness: 30, textureVariance: scores.contour_yeux / 2, uniformity: 70 } },
    cheek_left: { score: Math.round((scores.sensibilite + scores.eclat) / 2), label: 'Joue gauche', metrics: { brightness: 70, redness: scores.sensibilite / 2, textureVariance: 30, uniformity: 80 } },
    cheek_right: { score: Math.round((scores.taches + scores.eclat) / 2), label: 'Joue droite', metrics: { brightness: 68, redness: scores.sensibilite / 2, textureVariance: 28, uniformity: 78 } },
    nose: { score: (scores.pores || 50), label: 'Nez / Zone T', metrics: { brightness: 80, redness: 20, textureVariance: (scores.pores || 50) / 2, uniformity: 72 } },
    chin: { score: Math.round((scores.relachement + scores.peau_mature) / 2), label: 'Menton', metrics: { brightness: 62, redness: 22, textureVariance: 35, uniformity: 75 } },
    lips: { score: Math.round(scores.secheresse * 0.6), label: 'Contour lèvres', metrics: { brightness: 58, redness: 28, textureVariance: 32, uniformity: 68 } }
  };
}

// ─── RÉCAP PRIX ROUTINE ───────────────────────────────────────────────────
function renderPriceRecap(products, kitTitle) {
  const el = document.getElementById('routine-price-recap');
  if (!el || !products.length) return;
  const total = products.reduce((sum, p) => sum + (p.price || 0), 0);
  const discounted = Math.round(total * 0.90 * 100) / 100;
  const savings = Math.round((total - discounted) * 100) / 100;
  const recapLabel = kitTitle ? (kitTitle + ' — ' + products.length + ' soins') : 'Votre routine sur mesure — ' + products.length + ' soins';

  el.innerHTML = `
    <div class="price-recap-inner">
      <div class="price-recap-header">
        <span class="price-recap-label">${recapLabel}</span>
        <span class="price-recap-badge">–10% diagnostic</span>
      </div>
      <div class="price-recap-nums">
        <span class="price-original">${total.toFixed(2)} €</span>
        <span class="price-arrow">→</span>
        <span class="price-discounted">${discounted.toFixed(2)} €</span>
      </div>
      <span class="price-savings">Vous économisez ${savings.toFixed(2)} € avec votre diagnostic personnalisé</span>
    </div>`;

  // Mettre à jour le bouton panier avec le prix
  const btn = document.getElementById('btn-shop-all');
  if (btn) btn.textContent = `Ajouter ma routine au panier — ${discounted.toFixed(2)} € →`;
}

// ─── PROJECTIONS J30/J60/J90 ──────────────────────────────────────────────
function renderProjections(profile) {
  const el = document.getElementById('projections-container');
  if (!el || !profile.scores) return;

  // Formule de progression : score_t = s0 + (100-s0)*(1-e^(-0.4t))
  const project = (s0, t) => Math.round(s0 + (100 - s0) * (1 - Math.exp(-0.4 * t)));

  // Dimensions principales à projeter (inversées : score élevé = problème)
  const dims = [
    { key: 'secheresse', label: 'Hydratation' },
    { key: 'relachement', label: 'Fermeté' },
    { key: 'eclat', label: 'Éclat' },
    { key: 'rides', label: 'Rides' }
  ];

  const paliers = [
    { t: 0, label: 'Aujourd\'hui' },
    { t: 1, label: 'J+30' },
    { t: 2, label: 'J+60' },
    { t: 3, label: 'J+90' }
  ];

  el.innerHTML = `
    <div class="projections-grid">
      ${paliers.map(p => `<div class="proj-palier ${p.t === 0 ? 'current' : ''}">${p.label}</div>`).join('')}
      ${dims.map(d => {
        const s0 = 100 - (profile.scores[d.key] || 50); // inverser: score problème → score amélioration
        return `
          <div class="proj-dim-label">${d.label}</div>
          ${paliers.map(p => {
            const val = p.t === 0 ? s0 : project(s0, p.t);
            return `<div class="proj-val ${p.t === 0 ? 'current' : ''}">${val}<small>/100</small></div>`;
          }).join('')}
        `;
      }).join('')}
    </div>
    <p class="projections-note">Estimations basées sur l'utilisation régulière de votre routine personnalisée.</p>`;
}

// ─── PDF GENERATION supprimée — rapport envoyé par email ─────────────────

// ─── REVEAL ANIMATIONS ────────────────────────────────────────────────────
function initResultsReveal() {
  const blocks = document.querySelectorAll('.result-block');
  if (!blocks.length) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('revealed'); observer.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
  blocks.forEach(b => observer.observe(b));
}

// ─── RADAR CHART (REMPLACÉ PAR radar-premium.js) ─────────────────────────────
// La fonction drawRadarChart est désormais remplacée par buildRadarComponent
// importé depuis ./radar-premium.js — 8 dimensions, Chart.js, animé.
// Le <canvas id="radar-canvas"> dans le HTML peut être remplacé par :
//   <div id="results-radar-container"></div>

// ─── PRÉOCCUPATIONS avec textes enrichis ──────────────────────────────────
function renderTopConcerns(highlights) {
  const container = document.getElementById('top-concerns');
  if (!container || !highlights) return;

  container.innerHTML = highlights.map(h => {
    const txt = getDiagnosticText(h.key, h.score) || {};
    const title = txt.title || h.label;
    const explanation = txt.explanation || '';
    const conseil = txt.conseil || '';
    const severityLabel = h.severity === 'high' ? '⚠ Priorité haute' : h.severity === 'medium' ? '◆ À surveiller' : '✓ Satisfaisant';

    return `
    <div class="concern-card ${h.severity}">
      <div class="concern-header">
        <div class="concern-bar-wrap">
          <div class="concern-bar" style="width: ${h.score}%"></div>
        </div>
        <div class="concern-info">
          <span class="concern-label">${h.label}</span>
          <span class="concern-score-badge ${h.severity}">${severityLabel}</span>
        </div>
      </div>
      <h4 class="concern-title">${title}</h4>
      ${explanation ? `<p class="concern-explanation">${explanation}</p>` : ''}
      ${conseil ? `<div class="concern-conseil"><span class="conseil-icon">💡</span><p>${conseil}</p></div>` : ''}
    </div>`;
  }).join('');
}

// ─── PRODUITS RECOMMANDÉS ─────────────────────────────────────────────────
/**
 * Enrichit les produits Nopal Life avec les champs attendus par le PDF et les cards :
 * compatibility, badge, badgeColor, tagline, keyIngredients, url
 */
function enrichProducts(products) {
  const HANDLES = {
    'SN-HFB-15': '/products/huile-de-figue-de-barbarie-pure',
    'SN-PUM-190': '/products/mousse-nettoyante-aloe-vera-peaux-sensibles',
    'SN-CLG-200': '/products/gel-clarifiant-a-l-aloe-vera-pour-peaux-mixtes',
    'SN-HYT-200': '/products/tonique-hydratant-a-l-eau-de-rose',
    'SN-PUT-200': '/products/tonique-purifiant-anti-sebum-pour-peaux-mixtes',
    'SN-MPFM-100':'/products/brume-prebiotiques-hydrate-calme-protege',
    'SN-CBS-30':  '/products/serum-collagene-hydratation-rebond-de-la-peau',
    'SN-DHBG-30': '/products/gel-hydratant-ha-sodium-pca-effet-repulpant',
    'SN-VCS-30':  '/products/serum-vitamine-c-2-eclat-taches-de-la-peau',
    'SN-RAES-15': '/products/serum-vitalisant-contour-des-yeux',
    'SN-CBG-20-AB':'/products/booster-gel-cafeine-1-anti-cernes',
    'SN-GBG-20-AB':'/products/booster-gel-ginkgo-antioxydant-eclat-de-la-peau',
    'SN-MDC-50-W':'/products/creme-jour-hydratante-ha-pour-une-peau-repulpee',
    'SN-SSM-50-FF':'/products/creme-de-jour-aloe-vera-peaux-sensibles',
    'SN-BPJS-30': '/products/gel-hydratant-ha-fini-mat',
    'SN-CFB-50':  '/products/creme-regenerant-figue-de-barbarie',
    'SN-CNC-50-W':'/products/creme-nuit-ceramides-reperation-hydratation-profonde',
    'SN-CAN-50-W':'/products/creme-nuit-anti-age-fermete-ridules',
    'SN-AFO-30':  '/products/huile-visage-multi-usage-glow-confort',
    'SN-SOM-150': '/products/nettoyant-gel-huile-demaquillage-en-douceur',
    'SN-MFB-120': '/products/masque-visage-bio-figue-de-barbarie',
    'SN-SFB-100': '/products/savon-exfoliant-regenerant-figue-de-barbarie-100-g',
    'SN-AHAP-30': '/products/peeling-aha-10-lactique-acide-hyaluronique-eclat-de-la-peau',
  };
  const BADGES = {
    'SN-HFB-15':   { text: '★ Signature', color: '#C9956A' },
    'SN-VCS-30':   { text: 'Éclat',       color: '#E8896B' },
    'SN-CBS-30':   { text: 'Anti-âge',    color: '#8BAF8B' },
    'SN-DHBG-30':  { text: 'Hydratation', color: '#8BAF8B' },
    'SN-CFB-50':   { text: 'Nuit',        color: '#7A5C42' },
    'SN-CAN-50-W': { text: 'Nuit',        color: '#7A5C42' },
    'SN-CNC-50-W': { text: 'Nuit',        color: '#7A5C42' },
  };

  return products.map(function(p, i) {
    const badge = BADGES[p.id];
    const compat = i === 0 ? 98 : i <= 2 ? 94 - (i * 2) : 88 - (i * 3);
    const tagline = (p.description || '').split('.')[0];
    // Ingredients clés extraits de la description (mots en majuscule = actifs)
    const descWords = (p.description || '');
    const keyIngredients = p.category ? [p.category] : ['Figue de barbarie', 'Actifs naturels'];

    return Object.assign({}, p, {
      compatibility:  p.compatibility  !== undefined ? p.compatibility  : compat,
      badge:          p.badge          !== undefined ? p.badge          : (badge ? badge.text : null),
      badgeColor:     p.badgeColor     !== undefined ? p.badgeColor     : (badge ? badge.color : '#C9956A'),
      tagline:        p.tagline        !== undefined ? p.tagline        : tagline,
      keyIngredients: p.keyIngredients !== undefined ? p.keyIngredients : keyIngredients,
      url:            p.url            !== undefined ? p.url            : (HANDLES[p.id] || '/collections/soins-de-visage-naturels'),
    });
  });
}

function renderProducts(products) {
  const container = document.getElementById('recommended-products');
  if (!container) return;

  // Les produits arrivent déjà enrichis par enrichProducts()
  container.innerHTML = products.map(function(p, i) {
    const compat = p.compatibility || 80;
    const url = p.url || '/collections/soins-de-visage-naturels';
    return `
    <div class="product-card ${i === 0 ? 'product-card--top' : ''}">
      <div class="product-compat">
        <svg class="compat-ring" viewBox="0 0 44 44">
          <circle cx="22" cy="22" r="18" fill="none" stroke="rgba(200,169,110,0.2)" stroke-width="3"/>
          <circle cx="22" cy="22" r="18" fill="none" stroke="#C8A96E" stroke-width="3"
            stroke-dasharray="${(compat / 100) * 113} 113"
            stroke-linecap="round" transform="rotate(-90 22 22)"/>
        </svg>
        <span class="compat-num">${compat}%</span>
      </div>
      <div class="product-info">
        ${p.badge ? `<span class="product-badge" style="background:${p.badgeColor || '#C9956A'}">${p.badge}</span>` : ''}
        <h4 class="product-name">${p.shortName || p.name}</h4>
        <p class="product-tagline">${p.tagline || ''}</p>
        <p class="product-category">${p.category || ''}</p>
      </div>
      <div class="product-price-action">
        <span class="product-price">${(p.price || 0).toFixed(2)} €</span>
        <a href="https://nopal-life.com${url}" class="btn-product" target="_blank">Voir le produit</a>
      </div>
    </div>`;
  }).join('');
}

// ─── CONSEIL ROUTINE ────────────────────────────────────────────────────────
function renderRoutineAdvice(adviceText, skinType, kitTitle) {
  const el = document.getElementById('routine-advice-text');
  if (!el) return;
  const skinLabels = {
    peau_mature: 'Peau mature', peau_seche: 'Peau sèche', peau_grasse: 'Peau grasse',
    peau_sensible: 'Peau sensible', eclat: 'Éclat', peau_deshydratee: 'Peau déshydratée',
  };
  // Titre = nom EXACT du kit boutique si fourni, sinon libellé type de peau (compat)
  const label = kitTitle || skinLabels[skinType] || skinType;
  el.innerHTML = `
    <h4 class="routine-advice-title">Votre protocole — ${label} — Mode d'emploi expert</h4>
    <p class="routine-advice-body">${adviceText}</p>
    <p class="routine-advice-suivi">💡 Refaites ce diagnostic <strong>gratuitement dans 4 à 6 semaines</strong> pour mesurer l'évolution de votre peau et ajuster votre protocole selon vos progrès.</p>
  `;
}

// ─── ROUTINES ─────────────────────────────────────────────────────────────
function renderRoutines(routines) {
  const amEl = document.getElementById('routine-morning');
  const pmEl = document.getElementById('routine-evening');

  const renderRoutineList = (products) => products.map((p, i) => `
    <div class="routine-step">
      <span class="routine-num">${i + 1}</span>
      <span class="routine-product-name">${p.shortName}</span>
    </div>
  `).join('');

  if (amEl && routines.morning.length) amEl.innerHTML = renderRoutineList(routines.morning);
  if (pmEl && routines.evening.length) pmEl.innerHTML = renderRoutineList(routines.evening);
}

// ─── EMAIL RÉSULTATS (renvoi manuel) ──────────────────────────────────────
async function sendResultsByEmail() {
  const btn = document.getElementById('btn-email-results');
  if (!btn) return;
  btn.textContent = 'Envoi en cours…';
  btn.disabled = true;

  // Vrai appel EmailJS (renvoi)
  try {
    const { EmailService } = await import('./integrations.js').catch(() => null) || {};
    if (EmailService && STATE.profile && STATE.userData.email) {
      await EmailService.sendResults(STATE.profile, STATE.userData, []);
    }
    btn.textContent = `✓ Renvoyé à ${STATE.userData.email}`;
    btn.style.borderColor = '#5B9E6B';
    btn.style.color = '#5B9E6B';
    // Désactiver après succès pour éviter spam
    setTimeout(() => { btn.disabled = true; btn.style.opacity = '0.6'; }, 2000);
  } catch(e) {
    btn.textContent = 'Réessayer';
    btn.disabled = false;
    console.warn('[Email] Renvoi échoué:', e);
  }
}

// ─── ANIMATION BARRES ───────────────────────────────────────────────────────
function animateConcernBars() {
  document.querySelectorAll('.concern-bar').forEach(bar => {
    const targetWidth = bar.style.width;
    bar.style.width = '0%';
    bar.style.transition = 'width 1.2s cubic-bezier(0.4, 0, 0.2, 1)';
    setTimeout(() => { bar.style.width = targetWidth; }, 50);
  });
}

// ─── PROGRESSION J30/J60 ────────────────────────────────────────────────────
function renderProgressComparison(improvement, stage) {
  const container = document.getElementById('top-concerns');
  if (!container) return;

  const stageLabel = stage === 'J60' ? '60 jours' : '30 jours';
  const global = improvement.global || 0;
  const emoji = global > 5 ? '🌟' : global > 0 ? '✨' : '💪';

  const progressHtml = `
    <div style="background:linear-gradient(135deg,rgba(91,158,107,0.15),rgba(44,56,40,0.3));
                border:1px solid rgba(91,158,107,0.4);border-radius:14px;padding:18px;margin-bottom:16px;">
      <p style="font-size:12px;letter-spacing:0.2em;text-transform:uppercase;color:#2E6B3E;margin-bottom:8px;">
        ${emoji} Votre progression — ${stageLabel}
      </p>
      <p style="font-size:15px;color:#2A1A0F;line-height:1.6;margin-bottom:12px;">
        ${improvement.global > 0 ? `Votre peau s'est améliorée de <strong style="color:#2E6B3E">${improvement.global} points</strong> depuis votre diagnostic initial.` : 'Continuez votre routine — les résultats arrivent bientôt.'}
      </p>
      <div style="display:flex;gap:8px;flex-wrap:wrap;">
        ${Object.entries(improvement)
          .filter(([k]) => !['global', 'globalPct'].includes(k))
          .sort((a, b) => (b[1].delta || 0) - (a[1].delta || 0))
          .slice(0, 4)
          .map(([dim, data]) => `
            <div style="background:rgba(250,247,242,0.05);border-radius:8px;padding:8px 12px;flex:1;min-width:80px;">
              <p style="font-size:12px;color:#3A2A1A;margin-bottom:4px;">${DIMENSION_LABELS[dim] || dim}</p>
              <p style="font-size:14px;font-weight:700;color:${(data.delta || 0) > 0 ? '#7AC48A' : '#E08070'};">
                ${(data.delta || 0) > 0 ? '↓' : '↑'} ${Math.abs(data.delta || 0)}pts
              </p>
            </div>
          `).join('')}
      </div>
    </div>
  `;

  container.insertAdjacentHTML('beforebegin', progressHtml);
}

// ─── COLLECTE DONNÉES ─────────────────────────────────────────────────────
function collectDiagnosticData(profile, userData, answers) {
  const record = {
    timestamp: new Date().toISOString(),
    email: userData.email,
    firstName: userData.firstName,
    skinType: profile.skinType,
    ageRange: answers.q2_age_range,
    hormonalStage: answers.q5_hormonal_stage,
    skinAge: profile.skinAge,
    chronoAge: profile.chronoAge,
    topConcerns: profile.topConcerns,
    scores: profile.scores,
    scanSimulated: STATE.captureData?.faceData?.simulated !== false
  };

  // Stocker en localStorage pour récupération future (Klaviyo, Airtable, etc.)
  try {
    const existing = JSON.parse(localStorage.getItem('nopal_diagnostics') || '[]');
    existing.push(record);
    localStorage.setItem('nopal_diagnostics', JSON.stringify(existing.slice(-50)));
  } catch { /* Storage non disponible */ }

  // TODO Phase 2 : POST vers webhook Klaviyo / Airtable
  console.log('[Nopal Life] Diagnostic collecté:', record.email);
}

// ─── RESTART ──────────────────────────────────────────────────────────────
function restartDiagnostic() {
  STATE._resultsInited = false; // Réinitialiser pour un nouveau diagnostic
  STATE.step = 'landing';
  // Annuler l'animation portrait scan pour éviter le RAF leak
  const nlScanCanvas = document.getElementById('nl-scan-canvas');
  if (nlScanCanvas) nlScanCanvas.style.display = 'none';
  STATE.captureData = null;
  STATE.answers = {};
  STATE.profile = null;
  STATE.currentQuestion = 0;
  document.querySelectorAll('.step').forEach(s => s.classList.remove('active'));
  document.getElementById('step-landing').classList.add('active');
  const wrapper = document.getElementById('nopal-wrapper');
  if (wrapper) wrapper.classList.add('landing-active');
  window.scrollTo({ top: 0 });
}

// ─── UTILS ────────────────────────────────────────────────────────────────
function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

// ─── DÉTECTION RETOUR J30/J60 ─────────────────────────────────────────────
async function checkReturnDiagnostic() {
  const params = LongitudinalTracker.getReturnParams();
  if (!params.isReturn || !params.email) return;

  // Pré-remplir l'email et le stage
  STATE.userData.email = decodeURIComponent(params.email);
  STATE.diagnosticStage = params.stage.toUpperCase();

  // Récupérer le profil précédent
  STATE.previousProfile = await getPreviousDiagnosticForReturn(params.email);

  // Afficher un message d'accueil retour
  const greetingEl = document.querySelector('.landing-subtitle');
  if (greetingEl && STATE.previousProfile) {
    const stageLabel = STATE.diagnosticStage === 'J30' ? '30 jours' : '60 jours';
    greetingEl.textContent = `Bienvenue ! Votre bilan ${stageLabel} vous attend. Refaites le diagnostic pour mesurer vos progrès.`;
    greetingEl.style.color = '#C8A96E';
  }
}

// ─── SCAN PANELS ANIMATION ────────────────────────────────────────────────
function initScanPanels() {
  ['scan-canvas-left', 'scan-canvas-right'].forEach(id => {
    const canvas = document.getElementById(id);
    if (!canvas) return;
    const frame = canvas.closest('.skin-panel__frame');
    const img = frame ? frame.querySelector('.skin-panel__img') : null;

    function setup() {
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
      if (canvas.width < 10) { requestAnimationFrame(setup); return; }
      runScanAnimation(canvas);
    }

    if (img && img.complete) setup();
    else if (img) img.addEventListener('load', setup);
    else setup();
  });
}

function runScanAnimation(canvas) {
  const ctx = canvas.getContext('2d');
  const W = canvas.width;
  const H = canvas.height;
  const G = [200, 167, 105]; // Gold RGB

  // Nuage de points — léger décalage aléatoire pour aspect organique
  const COLS = 20, ROWS = 28;
  const dots = [];
  for (let r = 0; r < ROWS; r++) {
    for (let c = 0; c < COLS; c++) {
      dots.push({
        x: (c + 0.5) / COLS * W + (Math.random() - 0.5) * (W / COLS * 0.6),
        y: (r + 0.5) / ROWS * H + (Math.random() - 0.5) * (H / ROWS * 0.6),
        base: Math.random() * 0.06 + 0.02,
        lit:  Math.random() * 0.04,
        size: Math.random() * 0.8 + 0.8
      });
    }
  }

  let scanY = -60;
  const SPEED = 1.4;

  function frame() {
    ctx.clearRect(0, 0, W, H);

    scanY += SPEED;
    if (scanY > H + 80) scanY = -60;

    // Halo de scan
    const grd = ctx.createLinearGradient(0, scanY - 55, 0, scanY + 55);
    grd.addColorStop(0,   `rgba(${G},0)`);
    grd.addColorStop(0.4, `rgba(${G},0.08)`);
    grd.addColorStop(0.5, `rgba(${G},0.14)`);
    grd.addColorStop(0.6, `rgba(${G},0.08)`);
    grd.addColorStop(1,   `rgba(${G},0)`);
    ctx.fillStyle = grd;
    ctx.fillRect(0, scanY - 55, W, 110);

    // Ligne de scan fine
    ctx.strokeStyle = `rgba(${G},0.55)`;
    ctx.lineWidth = 0.8;
    ctx.beginPath();
    ctx.moveTo(0, scanY);
    ctx.lineTo(W, scanY);
    ctx.stroke();

    // Points
    dots.forEach(d => {
      const dist = Math.abs(d.y - scanY);
      if (dist < 45) {
        d.lit = Math.min(0.95, d.lit + 0.12 * (1 - dist / 45));
      } else {
        d.lit = Math.max(d.base, d.lit * 0.975);
      }

      const a = d.lit;
      const r = d.size * (a > 0.4 ? 1.8 : 1.2);

      // Halo du point allumé
      if (a > 0.35) {
        ctx.beginPath();
        ctx.arc(d.x, d.y, r * 3.5, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${G},${a * 0.12})`;
        ctx.fill();
      }

      // Point principal
      ctx.beginPath();
      ctx.arc(d.x, d.y, r, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(${G},${a})`;
      ctx.fill();
    });

    requestAnimationFrame(frame);
  }

  frame();
}

// ─── INIT ─────────────────────────────────────────────────────────────────
function initApp() {
  try { checkReturnDiagnostic(); } catch(e) { console.warn('[Init] checkReturn', e); }
  try { initLanding(); } catch(e) { console.warn('[Init] landing', e); }
  try { initConsent(); } catch(e) { console.warn('[Init] consent', e); }
  try { initScanPanels(); } catch(e) { console.warn('[Init] scanPanels', e); }

  // Observer résultats — déclenche initResultsStep quand la step devient active
  try {
    const resultsStep = document.getElementById('step-results');
    if (resultsStep) {
      const observer = new MutationObserver(mutations => {
        mutations.forEach(m => {
          if (m.target.id === 'step-results' && m.target.classList.contains('active')) {
            initResultsStep();
          }
        });
      });
      observer.observe(resultsStep, { attributes: true, attributeFilter: ['class'] });
    }
  } catch(e) { console.warn('[Init] observer', e); }

  // Afficher la landing step en dernier
  const landing = document.getElementById('step-landing');
  if (landing) landing.classList.add('active');
  console.log('[Nopal Life] App initialisée ✦');

  // Animation scan sur le portrait droit
  initPortraitScan();

  // Gestion placeholder si image absente
  const portraitImg = document.getElementById('portrait-img');
  const placeholder = document.getElementById('portrait-placeholder');
  if (portraitImg && placeholder) {
    portraitImg.onerror = () => {
      portraitImg.style.display = 'none';
      placeholder.style.display = 'flex';
    };
    portraitImg.onload = () => {
      portraitImg.style.display = 'block';
      placeholder.style.display = 'none';
    };
  }
}

// Pattern robuste : fonctionne si DOM déjà chargé OU en attente
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}

// ─── ANIMATION SCAN PORTRAIT ──────────────────────────────────────────────
function initPortraitScan() {
  const canvas = document.getElementById('nl-scan-canvas');
  if (!canvas) return;

  const frame = canvas.closest('.nl-portrait-frame');
  if (!frame) return;

  canvas.width = frame.offsetWidth;
  canvas.height = frame.offsetHeight;
  const ctx = canvas.getContext('2d');

  const CX = canvas.width / 2;
  const CY = canvas.height / 2;
  const RX = canvas.width * 0.46;
  const RY = canvas.height * 0.47;

  // Nuage de points dorés
  const GOLD = [200, 167, 105]; // or Nopal Life
  const N = 45;
  const dots = Array.from({ length: N }, () => {
    // Distribuer dans l'ovale
    const angle = Math.random() * Math.PI * 2;
    const r = Math.random();
    return {
      x: CX + RX * 0.9 * r * Math.cos(angle),
      y: CY + RY * 0.9 * r * Math.sin(angle),
      base: 0.04 + Math.random() * 0.08,
      lit: 0,
      size: 1 + Math.random() * 1.5
    };
  });

  let scanY = CY - RY;
  let scanDir = 1;
  let frame_id;

  const animate = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Ligne de scan
    scanY += scanDir * 1.2;
    if (scanY > CY + RY) scanDir = -1;
    if (scanY < CY - RY) scanDir = 1;

    // Clipper à l'ovale
    ctx.save();
    ctx.beginPath();
    ctx.ellipse(CX, CY, RX, RY, 0, 0, Math.PI * 2);
    ctx.clip();

    // Ligne scan horizontale
    const progress = (scanY - (CY - RY)) / (2 * RY);
    ctx.strokeStyle = `rgba(${GOLD},${0.25 - Math.abs(progress - 0.5) * 0.3})`;
    ctx.lineWidth = 1.5;
    ctx.beginPath();
    ctx.moveTo(CX - RX, scanY);
    ctx.lineTo(CX + RX, scanY);
    ctx.stroke();

    // Halo sous la ligne
    const grad = ctx.createLinearGradient(0, scanY - 20, 0, scanY + 20);
    grad.addColorStop(0, `rgba(${GOLD},0)`);
    grad.addColorStop(0.5, `rgba(${GOLD},0.06)`);
    grad.addColorStop(1, `rgba(${GOLD},0)`);
    ctx.fillStyle = grad;
    ctx.fillRect(CX - RX, scanY - 20, RX * 2, 40);

    // Points
    dots.forEach(d => {
      const dist = Math.abs(d.y - scanY);
      if (dist < 40) {
        d.lit = Math.min(0.85, d.lit + 0.1 * (1 - dist / 40));
      } else {
        d.lit = Math.max(d.base, d.lit * 0.97);
      }
      const a = d.lit;
      const r = d.size * (a > 0.3 ? 1.6 : 1);
      if (a > 0.25) {
        ctx.beginPath();
        ctx.arc(d.x, d.y, r * 3, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${GOLD},${a * 0.1})`;
        ctx.fill();
      }
      ctx.beginPath();
      ctx.arc(d.x, d.y, r, 0, Math.PI * 2);
      ctx.fillStyle = `rgba(${GOLD},${a})`;
      ctx.fill();
    });

    ctx.restore();
    frame_id = requestAnimationFrame(animate);
  };

  animate();
}


})();
/* NOPAL cache-bump 2026-07-02 - contenu identique au build 24/06 (Palier 2 complet) */
